<template>
  <fragment>
    <g id="Y-Shirts_B-1-1-7_G-2" v-if="data.value === 'type-14'">
      <g>
        <path
          d="M105.75,277.39c-.1,.2-.2,.4-.3,.61,0,0,0,0,0-.01,.1-.2,.19-.4,.29-.6Z"
          fill="#e9e9e9"
        />
        <path
          d="M108.1,272.88h0c-.7,1.27-1.4,2.6-2.1,4h0c.7-1.4,1.4-2.74,2.1-4Z"
          fill="#e9e9e9"
        />
        <path
          d="M98.95,293.15c-.04,.09-.07,.19-.11,.29,.01-.04,.03-.08,.04-.11,.02-.06,.04-.11,.06-.17Z"
          fill="#e9e9e9"
        />
        <path
          d="M104.14,280.78h0c-.62,1.35-1.24,2.75-1.86,4.2h0c.62-1.44,1.24-2.84,1.86-4.2Z"
          fill="#e9e9e9"
        />
        <path
          d="M113.01,265.26h-.01c-.9,1.15-1.79,2.45-2.69,3.87h0c.9-1.42,1.8-2.71,2.7-3.87Z"
          fill="#e9e9e9"
        />
        <path
          d="M99.67,291.32c-.24,.6-.47,1.2-.71,1.81h0c.24-.61,.47-1.21,.71-1.81Z"
          fill="#e9e9e9"
        />
        <path
          d="M100.67,288.8s-.03,.08-.05,.12c0-.02,.02-.04,.03-.06,0-.02,.01-.04,.02-.05Z"
          fill="#e9e9e9"
        />
        <path
          d="M102.27,284.99c-.52,1.21-1.04,2.46-1.56,3.73,.46-1.13,.93-2.24,1.39-3.33,.06-.13,.11-.27,.17-.4Z"
          fill="#e9e9e9"
        />
        <path
          d="M100.62,288.94c-.27,.66-.54,1.33-.8,2,.27-.67,.54-1.34,.8-2h0Z"
          fill="#e9e9e9"
        />
        <path
          d="M106.71,281.79l-1.69,4.27,2.81,1.11c.46-1.52,.91-3,1.34-4.4l-2.46-.97Z"
          fill="#e9e9e9"
        />
        <path
          d="M111.73,274.31l-1.78-.7-1.65,4.18,2.14,.84c.47-1.56,.91-3.01,1.3-4.32Z"
          fill="#e9e9e9"
        />
        <path
          d="M106.58,291.29l-3.14-1.24-1.65,4.18,3.48,1.37c.44-1.47,.88-2.91,1.31-4.32Z"
          fill="#e9e9e9"
        />
        <path
          d="M112.96,270.18c.52-1.64,1.23-3,2.08-4.11l-1.84-.73-1.69,4.27,1.44,.57Z"
          fill="#e9e9e9"
        />
        <path
          d="M119.09,262.93l1.53-3.88c.12-.04,.24-.06,.37-.1h-.02c.11-.04,.21-.06,.32-.08,.02,0,.03-.02,.05-.03-1.75,.38-3.5,1.43-5.24,3.01l2.87,1.13s.08-.04,.13-.06Z"
          fill="#e9e9e9"
        />
        <polygon
          points="96.54 320.03 97.99 316.37 93.72 314.69 91.96 319.14 94.2 320.03 96.54 320.03"
          fill="#e9e9e9"
        />
        <path
          d="M113.77,264.33c-.1,.12-.2,.22-.3,.34v.02c.09-.13,.2-.25,.3-.37Z"
          fill="#e9e9e9"
        />
        <rect
          x="96.01"
          y="307.15"
          width="4.5"
          height="4.59"
          transform="translate(-225.64 287.17) rotate(-68.45)"
          fill="#e9e9e9"
        />
        <path
          d="M90.02,318.5c-.03,.09-.06,.19-.09,.28,.02-.05,.03-.1,.05-.15,.01-.04,.03-.08,.04-.13Z"
          fill="#e9e9e9"
        />
        <path
          d="M95.84,301.47c-.19,.54-.39,1.08-.58,1.62,.1-.28,.2-.55,.29-.82,.09-.27,.19-.54,.28-.8Z"
          fill="#e9e9e9"
        />
        <path
          d="M94.96,303.94c-.18,.51-.36,1.03-.54,1.54,.04-.1,.07-.2,.11-.3,.15-.41,.29-.83,.44-1.24Z"
          fill="#e9e9e9"
        />
        <path
          d="M91.56,313.84c-.19,.55-.37,1.11-.55,1.67,.18-.56,.37-1.11,.55-1.66h0Z"
          fill="#e9e9e9"
        />
        <path
          d="M90.37,317.42c-.11,.32-.21,.64-.32,.97h0c.11-.32,.21-.65,.32-.97Z"
          fill="#e9e9e9"
        />
        <path
          d="M94.41,305.5c-.03,.1-.07,.19-.1,.29,.03-.1,.07-.19,.1-.29h0Z"
          fill="#e9e9e9"
        />
        <path
          d="M100.21,298.24l-1.69,4.27,4.17,1.65c.44-1.48,.89-2.96,1.33-4.41l-3.81-1.5Z"
          fill="#e9e9e9"
        />
        <path
          d="M97.43,297.14h0c-.53,1.42-1.06,2.85-1.58,4.31h0c.53-1.46,1.05-2.89,1.58-4.31Z"
          fill="#e9e9e9"
        />
        <path
          d="M91.82,313.05c-.08,.23-.16,.46-.23,.7,.01-.04,.03-.08,.04-.12,.06-.19,.13-.38,.19-.57Z"
          fill="#e9e9e9"
        />
        <path
          d="M98.7,293.79c-.42,1.1-.84,2.21-1.26,3.33,.02-.06,.05-.13,.07-.19,.4-1.06,.79-2.11,1.19-3.14Z"
          fill="#e9e9e9"
        />
        <path
          d="M113.92,297.44s0,0,0,0c.02-.36,.04-.74,.07-1.13h0c.03-.39,.06-.8,.09-1.22,0,0,0,0,0-.01,0,0,0-.01,0-.01,.02-.25,.04-.5,.06-.76l-2.44-.97-1.65,4.18,3.8,1.5c.01-.47,.03-1,.06-1.56Z"
          fill="#e9e9e9"
        />
        <rect
          x="104.23"
          y="310.44"
          width="4.5"
          height="4.5"
          transform="translate(-223.46 296.87) rotate(-68.45)"
          fill="#e9e9e9"
        />
        <rect
          x="107.44"
          y="302.22"
          width="4.59"
          height="4.5"
          transform="translate(-213.76 294.69) rotate(-68.45)"
          fill="#e9e9e9"
        />
        <path
          d="M114.82,288.19s.01-.09,.02-.14c.05-.41,.1-.82,.16-1.23,.02-.19,.05-.36,.07-.55,.02-.16,.04-.32,.07-.49,.03-.21,.05-.42,.08-.63l-.23-.09-1.69,4.27,1.33,.52c.06-.54,.13-1.1,.2-1.66Z"
          fill="#e9e9e9"
        />
        <path
          d="M104.48,299.92l-.46-.18c-.44,1.45-.88,2.93-1.33,4.41l.1,.04,1.69-4.27Z"
          fill="#e9e9e9"
        />
        <path
          d="M115.79,271.29l1.69-4.27-2.43-.96c-.85,1.11-1.56,2.47-2.08,4.11l2.83,1.12Z"
          fill="#e9e9e9"
        />
        <path
          d="M107.71,291.74l-1.13-.45c-.43,1.41-.87,2.85-1.31,4.32l.79,.31,1.65-4.18Z"
          fill="#e9e9e9"
        />
        <polygon
          points="106.17 319.61 101.98 317.95 101.17 320.03 106 320.03 106.17 319.61"
          fill="#e9e9e9"
        />
        <path
          d="M119.09,262.93s-.08,.04-.13,.06l.09,.04,.04-.09Z"
          fill="#e9e9e9"
        />
        <path
          d="M110.98,283.48l-1.8-.71c-.43,1.41-.88,2.88-1.34,4.4l1.46,.58,1.69-4.27Z"
          fill="#e9e9e9"
        />
        <path
          d="M114.21,275.29l-2.48-.98c-.39,1.32-.83,2.77-1.3,4.32l2.13,.84,1.65-4.18Z"
          fill="#e9e9e9"
        />
        <path
          d="M113.27,317.05h.04s0-.05,0-.07c.03-.69,.07-1.37,.1-2.04,0-.07,0-.14,.01-.22,.03-.57,.05-1.14,.08-1.69l-.11-.04-1.65,4.18,1.53,.6v-.74Z"
          fill="#e9e9e9"
        />
        <path
          d="M228.58,318.9c-.05-.16-.11-.33-.16-.49,.02,.07,.05,.15,.07,.22,.03,.09,.06,.18,.09,.27Z"
          fill="#e9e9e9"
        />
        <path
          d="M223.22,303.15c-.2-.57-.4-1.14-.6-1.7,.1,.27,.19,.54,.29,.81,.11,.29,.21,.59,.32,.88Z"
          fill="#e9e9e9"
        />
        <path
          d="M222.61,301.45h0c-.53-1.46-1.05-2.89-1.58-4.31h0c.53,1.42,1.06,2.85,1.58,4.31Z"
          fill="#e9e9e9"
        />
        <path
          d="M224.17,305.83c-.04-.11-.08-.22-.11-.33h0c.04,.11,.08,.22,.12,.33Z"
          fill="#e9e9e9"
        />
        <path
          d="M227.56,315.81c-.22-.66-.44-1.31-.65-1.97h0c.22,.65,.44,1.31,.66,1.97Z"
          fill="#e9e9e9"
        />
        <path
          d="M228.41,318.39c-.11-.33-.22-.67-.33-1,.11,.33,.22,.67,.33,1h0Z"
          fill="#e9e9e9"
        />
        <path
          d="M226.9,313.81c-.12-.35-.24-.7-.35-1.05,.1,.29,.19,.58,.29,.87,.02,.06,.04,.12,.06,.19Z"
          fill="#e9e9e9"
        />
        <path
          d="M224.05,305.5c-.19-.53-.37-1.06-.56-1.59,.15,.42,.3,.85,.45,1.27,.04,.11,.08,.21,.11,.32Z"
          fill="#e9e9e9"
        />
        <path
          d="M209.19,270.81s.05,.09,.08,.13c-.37-.62-.74-1.23-1.1-1.81,.05,.08,.1,.17,.15,.25,.29,.46,.58,.94,.87,1.43Z"
          fill="#e9e9e9"
        />
        <path
          d="M211.3,274.61c-.31-.59-.62-1.18-.93-1.74h0c.31,.56,.62,1.15,.93,1.74Z"
          fill="#e9e9e9"
        />
        <path
          d="M218.66,290.97c-.27-.68-.54-1.36-.81-2.03h0c.27,.67,.54,1.34,.81,2.03Z"
          fill="#e9e9e9"
        />
        <path
          d="M208.16,269.13h0c-.89-1.42-1.79-2.72-2.69-3.87h-.02c.9,1.16,1.8,2.45,2.7,3.87Z"
          fill="#e9e9e9"
        />
        <path
          d="M210.06,272.33c-.26-.46-.52-.93-.79-1.38,.17,.29,.34,.6,.52,.9,.09,.16,.18,.32,.27,.47Z"
          fill="#e9e9e9"
        />
        <path
          d="M217.85,288.94s-.04-.1-.06-.15c0,.02,.02,.05,.03,.07,.01,.03,.02,.05,.03,.08Z"
          fill="#e9e9e9"
        />
        <path
          d="M217.77,288.75c-.52-1.29-1.05-2.55-1.58-3.78,.06,.13,.11,.28,.17,.41,.47,1.1,.94,2.22,1.41,3.36Z"
          fill="#e9e9e9"
        />
        <path
          d="M216.19,284.97c-.11-.26-.22-.5-.33-.76,.11,.25,.22,.5,.33,.76h0Z"
          fill="#e9e9e9"
        />
        <path
          d="M206.95,269.61l-1.69-4.27-1.92,.76c.85,1.11,1.55,2.47,2.07,4.12l1.53-.6Z"
          fill="#e9e9e9"
        />
        <path
          d="M207.95,278.67l2.22-.88-1.65-4.18-1.87,.74c.39,1.32,.83,2.77,1.3,4.32Z"
          fill="#e9e9e9"
        />
        <path
          d="M205,264.69v-.02c.15,.2,.31,.38,.47,.59-1.03-1.32-2.06-2.45-3.09-3.39,.88,.8,1.75,1.75,2.62,2.83Z"
          fill="#e9e9e9"
        />
        <path
          d="M198.41,260.25s0,0,0,0c.17,.43,.33,.93,.5,1.49l.49,1.25s.04,.02,.05,.02l2.92-1.15c-1.5-1.37-3.01-2.32-4.53-2.8l.02,.05c.18,.29,.36,.68,.54,1.15Z"
          fill="#e9e9e9"
        />
        <polygon
          points="197.83 259.05 197.82 259.05 197.82 259.05 197.83 259.05"
          fill="#e9e9e9"
        />
        <path
          d="M219.94,302.51l-1.69-4.27-3.9,1.54c.44,1.45,.88,2.93,1.33,4.41l4.26-1.68Z"
          fill="#e9e9e9"
        />
        <path
          d="M213.11,295.65l3.57-1.41-1.65-4.18-3.22,1.27c.43,1.41,.87,2.85,1.31,4.32Z"
          fill="#e9e9e9"
        />
        <polygon
          points="221.92 320.03 224.27 320.03 226.51 319.14 224.75 314.69 220.48 316.37 221.92 320.03"
          fill="#e9e9e9"
        />
        <rect
          x="217.91"
          y="307.19"
          width="4.59"
          height="4.5"
          transform="translate(-98.27 102.52) rotate(-21.55)"
          fill="#e9e9e9"
        />
        <path
          d="M210.54,287.2l2.9-1.14-1.69-4.27-2.55,1.01c.43,1.41,.88,2.88,1.34,4.4Z"
          fill="#e9e9e9"
        />
        <polygon
          points="212.46 320.03 217.3 320.03 216.48 317.95 212.3 319.61 212.46 320.03"
          fill="#e9e9e9"
        />
        <path
          d="M203.44,295.04s0,.02,0,.02c0,0,0,.01,0,.02,.02,.42,.04,.82,.06,1.21,0,.01,0,.02,0,.03,.02,.39,.03,.76,.04,1.11,0,0,0,.01,0,.02,0,0,0,0,0,0l.67,1.7,4.18-1.65-1.65-4.18-3.33,1.32c0,.14,.02,.27,.02,.41Z"
          fill="#e9e9e9"
        />
        <path
          d="M204.12,317.05c.02,.37,.04,.76,.06,1.14l2.55-1.01-1.65-4.18-1.13,.44c.05,1.16,.11,2.35,.17,3.6Z"
          fill="#e9e9e9"
        />
        <path
          d="M202.74,286.24s0,.02,0,.03c0,0,0,0,0,0,.13,1.33,.25,2.63,.35,3.87l2.08-.82-1.69-4.27-.83,.33c.03,.29,.06,.57,.09,.86Z"
          fill="#e9e9e9"
        />
        <path
          d="M205.91,279.48l2.04-.81c-.47-1.56-.91-3-1.3-4.32l-2.4,.95,1.65,4.18Z"
          fill="#e9e9e9"
        />
        <rect
          x="209.73"
          y="310.44"
          width="4.5"
          height="4.5"
          transform="translate(-100.04 99.72) rotate(-21.55)"
          fill="#e9e9e9"
        />
        <rect
          x="206.49"
          y="302.17"
          width="4.5"
          height="4.59"
          transform="translate(-97.25 97.96) rotate(-21.55)"
          fill="#e9e9e9"
        />
        <path
          d="M202.68,271.29l2.74-1.08c-.52-1.64-1.23-3.01-2.07-4.12l-2.35,.93,1.69,4.27Z"
          fill="#e9e9e9"
        />
        <path
          d="M215.67,304.19h.01c-.44-1.49-.89-2.96-1.33-4.41l-.37,.15,1.69,4.27Z"
          fill="#e9e9e9"
        />
        <path
          d="M209.17,287.74l1.37-.54c-.46-1.52-.91-3-1.34-4.4l-1.72,.68,1.69,4.27Z"
          fill="#e9e9e9"
        />
        <path
          d="M199.45,263.01s-.04-.02-.05-.02l.02,.04,.04-.02Z"
          fill="#e9e9e9"
        />
        <path
          d="M212.4,295.93l.7-.28c-.44-1.47-.88-2.91-1.31-4.32l-1.05,.41,1.65,4.18Z"
          fill="#e9e9e9"
        />
        <path
          d="M228.95,320.03c-.12-.38-.25-.75-.37-1.13,.12,.38,.25,.75,.37,1.13h0Z"
          fill="#666"
        />
        <path
          d="M226.83,313.63c-.1-.29-.19-.58-.29-.87-.13-.38-.26-.77-.39-1.15-.21-.62-.42-1.23-.63-1.84,0,0,0,0,0,0,.44,1.28,.87,2.56,1.31,3.86Z"
          fill="#666"
        />
        <polygon
          points="225.53 309.77 225.53 309.76 225.53 309.77 225.53 309.77"
          fill="#666"
        />
        <path
          d="M224.75,314.69l1.76,4.45,1.91-.75c-.11-.33-.22-.67-.33-1-.17-.53-.35-1.05-.52-1.58-.22-.66-.44-1.31-.66-1.97l-2.16,.85Z"
          fill="#666"
        />
        <rect
          x="219.53"
          y="311.38"
          width="4.59"
          height="4.3"
          transform="translate(-99.66 103.4) rotate(-21.55)"
          fill="#666"
        />
        <path
          d="M199.02,262.13c.07,.25,.14,.51,.21,.78,.06,.02,.11,.05,.17,.08l-.49-1.25c.04,.13,.07,.25,.11,.39,0,0,0,0,0,0Z"
          fill="#666"
        />
        <polygon
          points="226.86 320.03 226.51 319.14 224.27 320.03 226.86 320.03"
          fill="#666"
        />
        <path
          d="M228.95,320.03h0c-.12-.38-.25-.75-.37-1.13-.03-.09-.06-.18-.09-.27,.15,.46,.3,.93,.46,1.4Z"
          fill="#666"
        />
        <path
          d="M208.16,269.13c-.9-1.42-1.8-2.71-2.7-3.87l-.2,.08,1.69,4.27,1.22-.48Z"
          fill="#666"
        />
        <path
          d="M203.34,266.1l1.92-.76-.26-.65c-.87-1.07-1.75-2.03-2.62-2.83,0,0,0,0-.01,0l-2.92,1.15c1.47,.64,2.8,1.65,3.89,3.09Z"
          fill="#666"
        />
        <polygon
          points="202.37 261.86 202.37 261.86 202.38 261.87 202.37 261.86"
          fill="#666"
        />
        <path
          d="M205.55,270.59c.32,1.09,.69,2.35,1.11,3.76l1.87-.74-1.58-4-1.53,.6c.04,.13,.09,.25,.13,.38Z"
          fill="#666"
        />
        <path
          d="M214.36,299.78l3.9-1.54-1.58-4-3.57,1.41c.41,1.36,.83,2.73,1.25,4.13Z"
          fill="#666"
        />
        <path
          d="M209.2,282.8l2.55-1.01-1.58-4-2.22,.88c.39,1.3,.81,2.68,1.25,4.13Z"
          fill="#666"
        />
        <path
          d="M208.52,273.61l1.65,4.18,2.29-.9c-.07-.14-.14-.27-.2-.41-.27-.54-.55-1.08-.82-1.61-.05-.09-.09-.17-.14-.26-.31-.59-.62-1.17-.93-1.73l-1.84,.73Z"
          fill="#666"
        />
        <path
          d="M212.47,276.89c-.07-.14-.14-.27-.21-.41,.07,.14,.14,.27,.2,.41h0Z"
          fill="#666"
        />
        <path
          d="M217.81,288.86s-.02-.05-.03-.07c0-.01-.01-.02-.02-.04-.47-1.15-.94-2.26-1.41-3.36,.48,1.13,.97,2.29,1.45,3.47Z"
          fill="#666"
        />
        <path
          d="M220.36,320.03h1.57l-1.44-3.65-1.06,.42c.32,1.08,.63,2.16,.94,3.23Z"
          fill="#666"
        />
        <path
          d="M219.94,302.51l2.68-1.06c-.53-1.46-1.05-2.89-1.58-4.31l-2.78,1.1,1.69,4.27Z"
          fill="#666"
        />
        <path
          d="M213.03,278.02s0,0,0-.01c0,0,0,0,0,0,0,0,0-.01-.01-.02,0,.01,.01,.03,.02,.04Z"
          fill="#666"
        />
        <path
          d="M213.02,278.01s0-.02-.01-.02c0,0,0,0,0,0,0,0,0,.01,.01,.02Z"
          fill="#666"
        />
        <path
          d="M213.04,278.03s0-.02-.01-.02c0,0,0,0,0,.01,0,0,0,0,0,0Z"
          fill="#666"
        />
        <path
          d="M215.02,290.06l1.65,4.18,2.83-1.12c-.24-.61-.48-1.23-.72-1.83-.04-.11-.09-.22-.13-.33-.27-.68-.54-1.36-.81-2.03l-2.83,1.12Z"
          fill="#666"
        />
        <path
          d="M219.51,293.12c-.24-.61-.48-1.23-.72-1.83,.24,.6,.48,1.21,.72,1.83h0Z"
          fill="#666"
        />
        <path
          d="M221.52,306.51l1.65,4.18,2.36-.93c-.12-.36-.24-.72-.37-1.07-.21-.62-.43-1.24-.64-1.86-.11-.33-.23-.66-.35-.99-.04-.11-.08-.22-.12-.33l-2.54,1Z"
          fill="#666"
        />
        <path
          d="M211.76,281.79l1.69,4.27,2.75-1.08c-.11-.26-.22-.5-.33-.76-.3-.7-.61-1.39-.91-2.06-.18-.4-.36-.8-.54-1.2-.03-.06-.06-.12-.08-.18l-2.57,1.01Z"
          fill="#666"
        />
        <path
          d="M214.41,280.96c-.03-.06-.05-.12-.08-.18h0c.03,.06,.06,.12,.08,.18Z"
          fill="#666"
        />
        <path
          d="M215.68,304.19s.03,.1,.04,.15l1.52,3.86,4.27-1.69-1.58-4-4.26,1.68Z"
          fill="#666"
        />
        <path
          d="M223.94,305.18c-.15-.42-.3-.85-.45-1.27-.09-.25-.18-.51-.27-.76-.11-.3-.21-.59-.32-.88,.34,.96,.69,1.93,1.03,2.91Z"
          fill="#666"
        />
        <path
          d="M218.2,312.65l.7-.28-1.65-4.18-.33,.13c.43,1.44,.86,2.88,1.28,4.33Z"
          fill="#666"
        />
        <path
          d="M197.86,259.1l-.02-.05s0,0-.01,0c0,0,0,0,0,0,.01,.02,.03,.03,.04,.05Z"
          fill="#666"
        />
        <path d="M197.84,259.05s0,0-.01,0c0,0,0,0,.01,0h0Z" fill="#666" />
        <path
          d="M220.7,296.25c-.32-.84-.63-1.68-.95-2.51-.04-.1-.08-.2-.11-.29-.02-.04-.03-.09-.05-.13,.37,.96,.74,1.94,1.11,2.93Z"
          fill="#666"
        />
        <path
          d="M220.95,296.93c-.4-1.07-.8-2.14-1.21-3.19,.32,.82,.63,1.67,.95,2.51,.09,.23,.17,.45,.26,.68Z"
          fill="#666"
        />
        <path
          d="M219.63,293.45s-.03-.09-.05-.13c0,0,0,0,0,0,.02,.04,.03,.09,.05,.13Z"
          fill="#666"
        />
        <path
          d="M211.8,291.33l3.22-1.27-1.58-4-2.9,1.14c.41,1.34,.83,2.72,1.25,4.13Z"
          fill="#666"
        />
        <rect
          x="204.85"
          y="298.18"
          width="4.5"
          height="4.3"
          transform="translate(-95.84 97.07) rotate(-21.55)"
          fill="#666"
        />
        <rect
          x="205.74"
          y="312.06"
          width="4.3"
          height="4.5"
          transform="translate(-100.92 98.34) rotate(-21.55)"
          fill="#666"
        />
        <path
          d="M207.49,283.48l1.72-.68c-.44-1.45-.86-2.83-1.25-4.13l-2.04,.81,1.58,4Z"
          fill="#666"
        />
        <path
          d="M203.13,290.55s0,.01,0,.02c0,.01,0,.02,0,.03,.12,1.44,.21,2.8,.29,4.04l3.33-1.32-1.58-4-2.08,.82c.01,.14,.02,.27,.03,.41Z"
          fill="#666"
        />
        <path
          d="M203.62,305.93s0,0,0,.01c.01,.35,.03,.71,.04,1.09,0,.02,0,.04,0,.05,.01,.38,.03,.77,.05,1.17,0,.21,.02,.44,.03,.65l3.75-1.48-1.69-4.27-2.24,.88c.02,.58,.03,1.21,.06,1.89Z"
          fill="#666"
        />
        <path
          d="M199.27,263.08l.14-.06-.02-.04c-.06-.02-.11-.05-.17-.08,.01,.06,.03,.11,.04,.17Z"
          fill="#666"
        />
        <path
          d="M206.65,274.35c-.42-1.41-.79-2.67-1.11-3.76-.04-.13-.09-.25-.13-.38l-2.74,1.08,1.58,4,2.4-.95Z"
          fill="#666"
        />
        <rect
          x="207.43"
          y="292.37"
          width="4.3"
          height="4.5"
          transform="translate(-93.57 97.58) rotate(-21.55)"
          fill="#666"
        />
        <rect
          x="208.12"
          y="306.45"
          width="4.5"
          height="4.3"
          transform="translate(-98.65 98.84) rotate(-21.55)"
          fill="#666"
        />
        <path
          d="M218.2,312.65c-.43-1.44-.85-2.89-1.28-4.33l-3.67,1.45,1.65,4.18,3.3-1.3Z"
          fill="#666"
        />
        <path
          d="M202.53,284.13c.04,.42,.09,.84,.13,1.26l.83-.33-1.19-3.01c.07,.6,.13,1.2,.2,1.8,0,.09,.02,.19,.03,.28Z"
          fill="#666"
        />
        <path
          d="M217.3,320.03h3.06c-.31-1.07-.62-2.15-.94-3.23l-2.94,1.16,.82,2.07Z"
          fill="#666"
        />
        <rect
          x="204.18"
          y="284.11"
          width="4.3"
          height="4.59"
          transform="translate(-90.78 95.81) rotate(-21.55)"
          fill="#666"
        />
        <rect
          x="210.68"
          y="300.55"
          width="4.3"
          height="4.59"
          transform="translate(-96.36 99.34) rotate(-21.55)"
          fill="#666"
        />
        <rect
          x="211.35"
          y="314.63"
          width="4.5"
          height="4.3"
          transform="translate(-101.43 100.6) rotate(-21.55)"
          fill="#666"
        />
        <path
          d="M200.41,268.58h0c.03,.17,.06,.36,.09,.53,.05,.31,.11,.62,.16,.94,.04,.24,.08,.48,.12,.73,.06,.39,.13,.78,.19,1.18l1.71-.67-1.69-4.27-.81,.32c.07,.4,.15,.82,.22,1.24Z"
          fill="#666"
        />
        <path
          d="M203.94,313.45l1.13-.44-1.29-3.28c.04,.96,.09,1.96,.13,3.03,.01,.23,.02,.47,.03,.7Z"
          fill="#666"
        />
        <path
          d="M210.75,291.74l1.05-.41c-.43-1.41-.85-2.79-1.25-4.13l-1.37,.54,1.58,4Z"
          fill="#666"
        />
        <polygon
          points="212.3 319.61 211.23 320.03 212.46 320.03 212.3 319.61"
          fill="#666"
        />
        <path
          d="M204.27,320.03h3.57l-1.12-2.84-2.55,1.01c.03,.6,.06,1.21,.09,1.83Z"
          fill="#666"
        />
        <path
          d="M200.99,267.03l2.35-.93c-1.1-1.44-2.43-2.45-3.89-3.09l-.04,.02,1.58,4Z"
          fill="#666"
        />
        <path
          d="M201.74,277.38c.09,.71,.17,1.43,.26,2.14,.06,.48,.12,.95,.18,1.43l3.73-1.47-1.65-4.18-2.66,1.05c.02,.13,.03,.27,.05,.4,.03,.21,.06,.42,.09,.64Z"
          fill="#666"
        />
        <path
          d="M215.73,304.34s-.03-.1-.04-.15h-.01s.06,.15,.06,.15Z"
          fill="#666"
        />
        <path
          d="M213.98,299.92l.37-.15c-.42-1.4-.84-2.77-1.25-4.13l-.7,.28,1.58,4Z"
          fill="#666"
        />
        <path
          d="M203.58,298.47c0,.32,0,.62,0,.9h0s0,.03,0,.04l.64-.25-.67-1.7c.01,.35,.02,.69,.03,1,0,0,0,0,0,0Z"
          fill="#666"
        />
        <path
          d="M228.49,318.63c-.02-.07-.05-.15-.07-.22v-.02s0,0,0,0c.03,.08,.05,.16,.08,.24Z"
          fill="#292929"
        />
        <path
          d="M228.95,320.03c-.15-.47-.3-.93-.46-1.4-.03-.08-.05-.16-.08-.24l-1.91,.75,.35,.88h2.09Z"
          fill="#292929"
        />
        <polygon
          points="207.84 320.03 211.23 320.03 212.3 319.61 210.72 315.61 206.72 317.19 207.84 320.03"
          fill="#292929"
        />
        <path
          d="M219.42,316.79l1.06-.42-1.58-4-.7,.28c.41,1.38,.81,2.77,1.22,4.14Z"
          fill="#292929"
        />
        <path
          d="M216.48,317.95l2.94-1.16c-.4-1.38-.81-2.76-1.22-4.14l-3.3,1.3,1.58,4Z"
          fill="#292929"
        />
        <path
          d="M226.91,313.84s0-.02,0-.03c0,0,0,.02,0,.03h0Z"
          fill="#292929"
        />
        <path
          d="M226.9,313.84h0s0-.02,0-.03c-.02-.06-.04-.12-.06-.19,.02,.07,.05,.14,.07,.21Z"
          fill="#292929"
        />
        <path
          d="M224.75,314.69l2.16-.85c-.02-.07-.05-.14-.07-.21-.43-1.3-.87-2.58-1.31-3.86,0,0,0,0,0,0l-2.36,.93,1.58,4Z"
          fill="#292929"
        />
        <polygon
          points="225.53 309.76 225.53 309.76 225.53 309.77 225.53 309.76"
          fill="#292929"
        />
        <path
          d="M203.77,309.72l1.29,3.28,4-1.58-1.58-4-3.75,1.48c.01,.27,.02,.54,.03,.82Z"
          fill="#292929"
        />
        <path
          d="M217.25,308.19l-1.52-3.86c.4,1.32,.79,2.65,1.19,3.99l.33-.13Z"
          fill="#292929"
        />
        <path
          d="M211.67,305.77l1.58,4,3.67-1.45c-.4-1.33-.79-2.67-1.19-3.99l-.06-.14-4,1.58Z"
          fill="#292929"
        />
        <polygon
          points="222.62 301.45 222.62 301.45 222.62 301.45 222.62 301.45"
          fill="#292929"
        />
        <path
          d="M222.91,302.27c-.1-.27-.19-.55-.29-.81,0,0,0,0,0,0h0c.1,.27,.2,.55,.29,.82Z"
          fill="#292929"
        />
        <path
          d="M224.05,305.5h0s0,0,0,0c-.04-.11-.08-.21-.11-.32,.04,.11,.08,.21,.11,.32Z"
          fill="#292929"
        />
        <path
          d="M221.52,306.51l2.54-1c-.04-.11-.08-.22-.11-.32-.34-.98-.69-1.95-1.03-2.91-.1-.27-.2-.55-.29-.82l-2.68,1.06,1.58,4Z"
          fill="#292929"
        />
        <path
          d="M203.58,299.41c0,.21,0,.41,0,.59,0,.21-.01,.41-.02,.59,0,0,0,.02,0,.02,0,.07,0,.15-.01,.24,0,.04,0,.08,0,.13,0,.06,0,.13,0,.2,0,.06,0,.12,0,.18,0,.07,0,.13,0,.2,0,.08,0,.16,0,.24,0,.06,0,.12,0,.19,0,.1,0,.2,0,.3,0,.05,0,.1,0,.15,0,.45,.02,.96,.03,1.53,0,.03,0,.06,0,.09l2.24-.88-1.58-4-.64,.25Z"
          fill="#292929"
        />
        <rect
          x="209.04"
          y="296.57"
          width="4.3"
          height="4.3"
          transform="translate(-94.96 98.46) rotate(-21.55)"
          fill="#292929"
        />
        <path
          d="M221.03,297.14h0s-.02-.05-.03-.08c.01,.03,.02,.05,.03,.08Z"
          fill="#292929"
        />
        <path
          d="M221.03,297.14h0c-.03-.07-.05-.14-.08-.21,.02,.04,.03,.09,.05,.13,.01,.03,.02,.05,.03,.08Z"
          fill="#292929"
        />
        <path
          d="M219.51,293.12h0c.03,.07,.05,.13,.08,.2-.02-.06-.05-.13-.07-.2Z"
          fill="#292929"
        />
        <path
          d="M221.03,297.14s-.02-.05-.03-.08c-.1-.27-.2-.54-.31-.81-.37-.99-.74-1.97-1.11-2.93-.03-.07-.05-.13-.08-.2l-2.83,1.12,1.58,4,2.78-1.1Z"
          fill="#292929"
        />
        <path
          d="M221,297.06s-.03-.09-.05-.13c-.09-.23-.17-.45-.26-.68,.1,.27,.2,.54,.31,.81Z"
          fill="#292929"
        />
        <path
          d="M219.58,293.32s0,0,0,0c-.03-.07-.05-.13-.08-.2h0c.03,.07,.05,.13,.08,.2Z"
          fill="#292929"
        />
        <rect
          x="205.81"
          y="288.38"
          width="4.3"
          height="4.3"
          transform="translate(-92.18 96.7) rotate(-21.55)"
          fill="#292929"
        />
        <path
          d="M217.85,288.94h0s0,0,0,0c-.01-.03-.02-.05-.03-.08,.01,.03,.02,.05,.03,.08Z"
          fill="#292929"
        />
        <path
          d="M216.37,285.39c-.06-.14-.11-.28-.17-.41,0,0,0,0,0,0h0c.06,.14,.12,.28,.18,.42Z"
          fill="#292929"
        />
        <path
          d="M217.85,288.94s-.02-.05-.03-.08c-.48-1.18-.96-2.34-1.45-3.47-.06-.14-.12-.28-.18-.42l-2.75,1.08,1.58,4,2.83-1.12Z"
          fill="#292929"
        />
        <path
          d="M202.26,281.67s0,0,0,0c0,0,0,.01,0,.02,.01,.11,.03,.23,.04,.34l1.19,3.01,4-1.58-1.58-4-3.73,1.47c.03,.24,.06,.48,.08,.72Z"
          fill="#292929"
        />
        <path
          d="M214.33,280.77c-.07-.16-.15-.31-.22-.47,.07,.16,.14,.32,.22,.48h0Z"
          fill="#292929"
        />
        <path
          d="M212.48,276.88h0c.18,.37,.36,.73,.54,1.1-.18-.37-.36-.74-.53-1.1Z"
          fill="#292929"
        />
        <path
          d="M213.01,277.98c-.18-.38-.37-.73-.55-1.1l-2.29,.9,1.58,4,2.57-1.01c-.21-.46-.43-.92-.64-1.38-.14-.3-.28-.6-.43-.9-.08-.16-.15-.32-.23-.48,0-.01-.01-.03-.02-.04Z"
          fill="#292929"
        />
        <path
          d="M213.01,277.98s0,0,0,0c-.18-.37-.36-.73-.54-1.09h0c.18,.37,.37,.72,.55,1.1Z"
          fill="#292929"
        />
        <path
          d="M214.33,280.78c-.07-.16-.14-.32-.22-.48-.09-.2-.19-.4-.28-.6-.05-.1-.1-.2-.14-.3,.21,.46,.43,.92,.64,1.38h0Z"
          fill="#292929"
        />
        <path
          d="M213.26,278.5c-.07-.15-.15-.31-.22-.47,0,0,0,0,0,0,.08,.16,.15,.32,.23,.48Z"
          fill="#292929"
        />
        <path
          d="M201.11,272.88s0,0,0,0h.17v1.13s0,0,0,0c.11,.77,.22,1.54,.32,2.33l2.66-1.05-1.58-4-1.71,.67c.05,.3,.09,.61,.14,.91Z"
          fill="#292929"
        />
        <path
          d="M210.37,272.88h0s0,0,0,0c-.06-.1-.11-.19-.17-.29,.05,.1,.11,.2,.16,.29Z"
          fill="#292929"
        />
        <path
          d="M210.38,272.88c-.06-.1-.11-.19-.17-.29,0,0,0,0,0,0,.06,.1,.11,.19,.17,.29Z"
          fill="#292929"
        />
        <path
          d="M209.79,271.86c-.17-.3-.34-.61-.52-.9,0,0,0-.01,0-.02-.03-.05-.05-.09-.08-.13,.2,.34,.4,.7,.61,1.05Z"
          fill="#292929"
        />
        <path
          d="M208.32,269.38c-.05-.08-.1-.17-.15-.25,0,0,0,0,0,0h0c.05,.08,.1,.17,.16,.25Z"
          fill="#292929"
        />
        <path
          d="M209.19,270.81c-.29-.49-.58-.96-.87-1.43-.05-.08-.1-.17-.16-.25l-1.22,.48,1.58,4,1.84-.73c-.05-.1-.11-.2-.16-.29-.05-.09-.1-.17-.15-.26-.09-.16-.18-.32-.27-.47-.2-.35-.4-.71-.61-1.05Z"
          fill="#292929"
        />
        <path
          d="M210.21,272.58c-.05-.09-.1-.17-.15-.26,.05,.09,.1,.17,.15,.26,0,0,0,0,0,0Z"
          fill="#292929"
        />
        <path
          d="M199.32,263.28c.09,.36,.18,.74,.27,1.13,.01,.05,.02,.09,.03,.13h0c.19,.87,.38,1.8,.57,2.79l.81-.32-1.58-4-.14,.06c.01,.06,.03,.11,.04,.17,0,0,0,.02,0,.03Z"
          fill="#292929"
        />
        <polygon
          points="205.47 265.26 205.47 265.25 205.47 265.26 205.47 265.26"
          fill="#5e7695"
        />
        <path
          d="M205,264.69c.15,.19,.3,.37,.45,.57h.02s0,0,0,0c-.16-.2-.32-.39-.48-.59v.02Z"
          fill="#5e7695"
        />
        <path
          d="M205,264.69l.26,.65,.2-.08c-.15-.19-.3-.38-.45-.57Z"
          fill="#5e7695"
        />
        <polygon
          points="116.09 261.86 116.09 261.86 116.09 261.86 116.09 261.86"
          fill="#666"
        />
        <path
          d="M89.92,318.78c-.14,.42-.27,.83-.41,1.25h0c.14-.42,.27-.83,.41-1.25Z"
          fill="#666"
        />
        <path
          d="M92.93,309.78s-.02,.04-.02,.07c0-.02,.01-.04,.02-.06,0,0,0,0,0,0Z"
          fill="#666"
        />
        <path
          d="M119.64,262.16s.02-.06,.03-.09c.1-.32,.2-.61,.3-.88,.01-.04,.03-.08,.04-.12,.1-.27,.2-.52,.3-.74,.01-.02,.02-.06,.03-.08h0c.27-.6,.53-1.03,.78-1.24l-.13-.05c-.12,.03-.24,.06-.37,.1l-1.53,3.88c.12-.05,.24-.11,.36-.15,.06-.22,.13-.42,.19-.62Z"
          fill="#666"
        />
        <path
          d="M101.46,308.29l-.24-.1-1.65,4.18,.61,.24c.43-1.44,.85-2.89,1.28-4.33Z"
          fill="#666"
        />
        <path
          d="M98.96,316.76l-.98-.39-1.44,3.65h1.47c.31-1.08,.63-2.17,.95-3.27Z"
          fill="#666"
        />
        <path
          d="M101.79,294.24l1.65-4.18-2.83-1.12c-.27,.66-.54,1.33-.8,2-.05,.12-.1,.25-.15,.37-.24,.6-.47,1.2-.71,1.81l2.83,1.12Z"
          fill="#666"
        />
        <path
          d="M92.93,309.79s-.01,.04-.02,.06c-.2,.57-.39,1.15-.59,1.73-.17,.49-.33,.98-.5,1.48-.06,.19-.13,.38-.19,.57,.43-1.29,.86-2.57,1.3-3.83Z"
          fill="#666"
        />
        <path
          d="M110.43,278.63l-2.14-.84-1.58,4,2.46,.97c.44-1.45,.86-2.83,1.25-4.13Z"
          fill="#666"
        />
        <path
          d="M95.56,302.27c-.1,.27-.2,.55-.29,.82-.1,.28-.2,.56-.3,.85-.15,.41-.29,.83-.44,1.24,.34-.98,.69-1.95,1.03-2.91Z"
          fill="#666"
        />
        <path
          d="M112.82,270.59c.04-.15,.1-.27,.14-.41l-1.44-.57-1.58,4,1.78,.7c.42-1.39,.78-2.64,1.1-3.72Z"
          fill="#666"
        />
        <polygon
          points="94.2 320.03 91.96 319.14 91.61 320.03 94.2 320.03"
          fill="#666"
        />
        <path
          d="M89.52,320.03c.15-.47,.3-.93,.46-1.4-.02,.05-.03,.1-.05,.15-.14,.41-.27,.83-.41,1.25h0Z"
          fill="#666"
        />
        <path
          d="M113.21,265.34l1.84,.73c1.1-1.44,2.44-2.44,3.92-3.08l-2.87-1.13s0,0,0,0c-.39,.36-.78,.75-1.17,1.17-.11,.12-.22,.24-.33,.36-.27,.3-.55,.62-.82,.94-.1,.12-.21,.24-.31,.37l-.26,.65Z"
          fill="#666"
        />
        <path
          d="M96.95,306.51l-2.54-1c-.03,.1-.07,.19-.1,.29-.12,.36-.25,.72-.37,1.07-.21,.59-.41,1.19-.62,1.78-.13,.37-.25,.74-.38,1.11l2.36,.93,1.65-4.18Z"
          fill="#666"
        />
        <path
          d="M113.21,265.34l-.2-.08c-.9,1.16-1.8,2.45-2.7,3.87l1.22,.48,1.69-4.27Z"
          fill="#666"
        />
        <path
          d="M98.88,293.32s-.03,.08-.04,.11c-.05,.12-.09,.24-.14,.35-.4,1.03-.79,2.08-1.19,3.14,.46-1.22,.91-2.43,1.37-3.61Z"
          fill="#666"
        />
        <path
          d="M105.46,277.98s0,0,0,.01c0,0,0,.02-.01,.03,0,0,0,0,0,0,0-.02,.02-.03,.02-.05Z"
          fill="#666"
        />
        <path
          d="M105.44,278.02s0,0,0,.01c0,0,0,0,0,0,0,0,0,0,0,0Z"
          fill="#666"
        />
        <path
          d="M109.94,273.61l-1.84-.73c-.7,1.27-1.4,2.61-2.1,4.01l2.29,.9,1.65-4.18Z"
          fill="#666"
        />
        <rect
          x="94.49"
          y="311.24"
          width="4.3"
          height="4.59"
          transform="translate(-230.47 288.25) rotate(-68.45)"
          fill="#666"
        />
        <path
          d="M107.83,287.17l-2.81-1.11-1.58,4,3.14,1.24c.43-1.41,.85-2.79,1.25-4.13Z"
          fill="#666"
        />
        <path
          d="M106.71,281.79l-2.57-1.01c-.62,1.35-1.24,2.75-1.86,4.2l2.75,1.08,1.69-4.27Z"
          fill="#666"
        />
        <path
          d="M102.1,285.39c-.46,1.09-.93,2.19-1.39,3.33-.01,.03-.02,.06-.04,.09,0,.02-.01,.04-.02,.05,.48-1.18,.96-2.34,1.45-3.47Z"
          fill="#666"
        />
        <path
          d="M100.21,298.24l-2.78-1.1c-.53,1.42-1.06,2.85-1.58,4.31l2.68,1.06,1.69-4.27Z"
          fill="#666"
        />
        <path
          d="M91.96,319.14l1.76-4.45-2.16-.85c-.19,.55-.37,1.11-.55,1.66-.21,.64-.42,1.28-.64,1.92-.11,.32-.21,.64-.32,.97l1.91,.75Z"
          fill="#666"
        />
        <path
          d="M102.33,305.37c.12-.4,.24-.81,.36-1.21l-4.17-1.65-1.58,4,4.27,1.69,1.12-2.83Z"
          fill="#666"
        />
        <path
          d="M104.02,299.74c.42-1.4,.84-2.77,1.25-4.13l-3.48-1.37-1.58,4,3.81,1.5Z"
          fill="#666"
        />
        <path
          d="M114.48,291.07c.02-.17,.03-.33,.05-.5,0-.09,.02-.18,.03-.26,.02-.16,.03-.3,.05-.46l-1.33-.52-1.58,4,2.44,.97c.09-1,.2-2.09,.33-3.22Z"
          fill="#666"
        />
        <path
          d="M113.52,312.8s0-.08,0-.11l-.13,.32,.11,.04c0-.08,0-.17,.01-.25Z"
          fill="#666"
        />
        <path
          d="M113.27,317.84v-.05l-1.53-.6-1.12,2.84h2.54c.04-.74,.08-1.47,.11-2.18Z"
          fill="#666"
        />
        <path
          d="M115.35,284.13s0-.03,0-.04l-.38,.96,.23,.09c.05-.34,.09-.68,.14-1.02Z"
          fill="#666"
        />
        <path
          d="M106.06,295.93l-.79-.31c-.41,1.36-.83,2.73-1.25,4.13l.46,.18,1.58-4Z"
          fill="#666"
        />
        <path
          d="M117.42,271.53c.05-.26,.1-.53,.15-.79,.05-.23,.09-.44,.14-.66,.06-.32,.13-.63,.19-.94,.04-.18,.08-.38,.11-.56h0c.09-.41,.18-.84,.27-1.24l-.81-.32-1.69,4.27,1.56,.62c.02-.13,.05-.25,.07-.38Z"
          fill="#666"
        />
        <path
          d="M111.73,274.31l2.48,.98,1.58-4-2.83-1.12c-.04,.14-.1,.27-.14,.41-.31,1.08-.68,2.33-1.1,3.72Z"
          fill="#666"
        />
        <path
          d="M110.43,278.63c-.39,1.3-.81,2.68-1.25,4.13l1.8,.71,1.58-4-2.13-.84Z"
          fill="#666"
        />
        <path
          d="M115.84,280.77c.08-.5,.16-1,.24-1.5,.1-.63,.19-1.27,.3-1.9,.04-.24,.08-.48,.12-.72,.02-.14,.05-.29,.07-.43l-2.36-.93-1.65,4.18,3.28,1.3Z"
          fill="#666"
        />
        <path
          d="M119.34,263.14c.03-.12,.07-.24,.1-.36-.12,.04-.24,.1-.36,.15l-.04,.09,.29,.11Z"
          fill="#666"
        />
        <path
          d="M119.05,263.03l-.09-.04c-1.48,.63-2.81,1.64-3.92,3.08l2.43,.96,1.58-4Z"
          fill="#666"
        />
        <path
          d="M102.7,304.15c-.12,.4-.24,.81-.36,1.21l.46-1.17-.1-.04Z"
          fill="#666"
        />
        <path
          d="M109.29,287.74l-1.46-.58c-.41,1.34-.83,2.72-1.25,4.13l1.13,.45,1.58-4Z"
          fill="#666"
        />
        <path
          d="M113.86,300c0-.3,0-.63,0-1l-3.8-1.5-1.58,4,4.18,1.65,1.2-3.03s0-.08,0-.12Z"
          fill="#666"
        />
        <path
          d="M101.98,317.95l-3.02-1.19c-.32,1.09-.64,2.18-.95,3.27h3.15l.82-2.07Z"
          fill="#666"
        />
        <polygon
          points="106.17 319.61 106 320.03 107.23 320.03 106.17 319.61"
          fill="#666"
        />
        <rect
          x="105.95"
          y="306.35"
          width="4.3"
          height="4.5"
          transform="translate(-218.63 295.78) rotate(-68.45)"
          fill="#666"
        />
        <rect
          x="106.64"
          y="292.47"
          width="4.5"
          height="4.3"
          transform="translate(-205.14 287.68) rotate(-68.45)"
          fill="#666"
        />
        <rect
          x="109.84"
          y="284.25"
          width="4.59"
          height="4.3"
          transform="translate(-195.43 285.49) rotate(-68.45)"
          fill="#666"
        />
        <rect
          x="103.34"
          y="300.7"
          width="4.59"
          height="4.3"
          transform="translate(-214.84 289.86) rotate(-68.45)"
          fill="#666"
        />
        <path
          d="M105.22,309.77l-3.76-1.48c-.43,1.44-.86,2.88-1.28,4.33l3.39,1.34,1.65-4.18Z"
          fill="#666"
        />
        <rect
          x="102.72"
          y="314.53"
          width="4.3"
          height="4.5"
          transform="translate(-228.29 297.96) rotate(-68.45)"
          fill="#666"
        />
        <rect
          x="108.32"
          y="312.15"
          width="4.5"
          height="4.3"
          transform="translate(-222.38 301.7) rotate(-68.45)"
          fill="#666"
        />
        <path
          d="M113.72,308.27s0-.04,0-.07c.01-.36,.03-.72,.04-1.06,0-.06,0-.12,0-.18,.01-.32,.02-.64,.03-.94,0-.04,0-.08,0-.12,.02-.7,.04-1.35,.06-1.93,0-.04,0-.07,0-.11,0-.07,0-.15,0-.22l-1.21-.48-1.69,4.27,2.73,1.08c0-.07,0-.16,0-.23Z"
          fill="#666"
        />
        <path
          d="M90.05,318.39s-.02,.08-.04,.11c.01-.04,.02-.08,.04-.11h0Z"
          fill="#292929"
        />
        <path
          d="M90.05,318.39h0s-.02,.08-.04,.11c-.01,.04-.03,.08-.04,.13,.03-.08,.05-.16,.08-.24Z"
          fill="#292929"
        />
        <path
          d="M91.96,319.14l-1.91-.75c-.03,.08-.05,.16-.08,.24-.15,.46-.3,.93-.46,1.4h2.09l.35-.88Z"
          fill="#292929"
        />
        <polygon
          points="107.23 320.03 110.63 320.03 111.75 317.19 107.75 315.61 106.17 319.61 107.23 320.03"
          fill="#292929"
        />
        <path
          d="M100.18,312.62l-.61-.24-1.58,4,.98,.39c.4-1.38,.81-2.76,1.22-4.14Z"
          fill="#292929"
        />
        <path
          d="M103.56,313.95l-3.39-1.34c-.41,1.38-.81,2.77-1.22,4.14l3.02,1.19,1.58-4Z"
          fill="#292929"
        />
        <path
          d="M91.56,313.84h0s.02-.06,.03-.09c0,.03-.02,.06-.03,.09Z"
          fill="#292929"
        />
        <path
          d="M91.63,313.63s-.03,.08-.04,.12c0,.03-.02,.06-.03,.09h0c.02-.07,.05-.14,.07-.21Z"
          fill="#292929"
        />
        <path
          d="M92.94,309.76s0,.02,0,.03c0,0,0,0,0,0,0-.01,0-.02,.01-.03Z"
          fill="#292929"
        />
        <path d="M92.94,309.76s0,.02,0,.03c0,0,0-.02,0-.03h0Z" fill="#292929" />
        <path
          d="M91.63,313.63c-.02,.07-.05,.14-.07,.21l2.16,.85,1.58-4-2.36-.93s0,.02-.01,.03c-.43,1.27-.87,2.55-1.3,3.83Z"
          fill="#292929"
        />
        <path
          d="M113.52,312.69s0,0,0-.01c.04-.77,.07-1.51,.1-2.22,0-.03,0-.07,0-.1,.03-.64,.05-1.25,.08-1.85l-2.73-1.08-1.58,4,4,1.58,.13-.32Z"
          fill="#292929"
        />
        <path
          d="M102.33,305.37l-1.12,2.83,.24,.1c.29-.98,.58-1.95,.87-2.92Z"
          fill="#292929"
        />
        <path
          d="M105.22,309.77l1.58-4-4-1.58-.46,1.17c-.29,.97-.58,1.95-.87,2.92l3.76,1.48Z"
          fill="#292929"
        />
        <path d="M94.41,305.5h0s0-.02,0-.03c0,0,0,.02,0,.03Z" fill="#292929" />
        <path d="M95.85,301.45s0,.01,0,.02c0,0,0-.01,0-.02h0Z" fill="#292929" />
        <path
          d="M95.85,301.45h0s0,.01,0,.02c-.09,.26-.19,.54-.28,.8,.1-.27,.2-.55,.29-.82Z"
          fill="#292929"
        />
        <path
          d="M94.52,305.18c-.04,.1-.07,.2-.11,.3,0,0,0,.02,0,.03h0c.04-.11,.08-.21,.11-.32Z"
          fill="#292929"
        />
        <path
          d="M95.85,301.45c-.1,.27-.2,.55-.29,.82-.34,.96-.69,1.93-1.03,2.91-.04,.11-.08,.21-.11,.32l2.54,1,1.58-4-2.68-1.06Z"
          fill="#292929"
        />
        <path
          d="M113.89,302.87s0-.04,0-.06c0-.11,0-.2,0-.3,0-.08,0-.17,0-.25,0-.08,0-.16,0-.24,0-.08,0-.17,0-.25,0-.07,0-.13,0-.2,0-.08,0-.16,0-.24,0-.05,0-.11,0-.16,0-.08,0-.16,0-.23,0-.03,0-.07,0-.1,0-.1,0-.19-.01-.26,0-.01,0-.03,0-.05,0-.13-.01-.27-.02-.41l-1.2,3.03,1.21,.48c0-.27,.01-.53,.02-.77Z"
          fill="#292929"
        />
        <rect
          x="105.12"
          y="296.57"
          width="4.3"
          height="4.3"
          transform="translate(-209.97 288.76) rotate(-68.45)"
          fill="#292929"
        />
        <path
          d="M98.96,293.12s0,.02,0,.03c0,0,0-.02,.01-.03h0Z"
          fill="#292929"
        />
        <path d="M97.43,297.14h0v-.02s0,.01,0,.02Z" fill="#292929" />
        <path
          d="M97.51,296.93c-.02,.06-.05,.13-.07,.19,0,0,0,.01,0,.02h0c.03-.07,.05-.14,.08-.21Z"
          fill="#292929"
        />
        <path
          d="M98.96,293.12h0s0,.02-.01,.03c-.02,.06-.04,.11-.06,.17,.03-.07,.05-.13,.08-.2Z"
          fill="#292929"
        />
        <path
          d="M101.79,294.24l-2.83-1.12c-.03,.07-.05,.13-.08,.2-.46,1.18-.92,2.39-1.37,3.61-.03,.07-.05,.14-.08,.21l2.78,1.1,1.58-4Z"
          fill="#292929"
        />
        <rect
          x="108.35"
          y="288.38"
          width="4.3"
          height="4.3"
          transform="translate(-200.31 286.59) rotate(-68.45)"
          fill="#292929"
        />
        <path
          d="M102.27,284.97s0,.01,0,.02c0,0,0-.01,0-.02h0Z"
          fill="#292929"
        />
        <path
          d="M100.62,288.94h0s0-.01,0-.02c0,0,0,.01,0,.02Z"
          fill="#292929"
        />
        <path
          d="M100.65,288.86s-.02,.04-.03,.06c0,0,0,.01,0,.02h0s.02-.05,.03-.08Z"
          fill="#292929"
        />
        <path
          d="M102.28,284.97h0s0,.01,0,.02c-.06,.13-.11,.27-.17,.4,.06-.14,.12-.28,.18-.42Z"
          fill="#292929"
        />
        <path
          d="M102.28,284.97c-.06,.14-.12,.28-.18,.42-.48,1.13-.97,2.29-1.45,3.47-.01,.03-.02,.05-.03,.08l2.83,1.12,1.58-4-2.75-1.08Z"
          fill="#292929"
        />
        <path
          d="M115.36,284.09c.01-.07,.02-.15,.03-.22,.1-.73,.21-1.46,.32-2.19,.02-.14,.04-.28,.07-.41,.02-.16,.05-.33,.07-.49l-3.28-1.3-1.58,4,4,1.58,.38-.96Z"
          fill="#292929"
        />
        <path
          d="M104.14,280.77h0s0-.02,.01-.03c0,.01-.01,.02-.02,.03Z"
          fill="#292929"
        />
        <path
          d="M105.99,276.88c-.08,.16-.16,.34-.24,.5,.08-.17,.16-.34,.24-.5h0Z"
          fill="#292929"
        />
        <path
          d="M106,276.89h0c-.08,.16-.16,.33-.24,.5-.1,.2-.19,.4-.29,.6,.18-.37,.36-.73,.54-1.09Z"
          fill="#292929"
        />
        <path
          d="M104.29,280.46c-.04,.1-.09,.19-.13,.28,0,.01,0,.02-.01,.03h0c.05-.1,.1-.21,.15-.32Z"
          fill="#292929"
        />
        <path
          d="M104.36,280.3c-.07,.15-.14,.29-.21,.44,.04-.1,.09-.19,.13-.28,.02-.05,.05-.11,.07-.16Z"
          fill="#292929"
        />
        <path
          d="M108.29,277.79l-2.29-.9c-.18,.36-.36,.72-.54,1.09,0,.02-.02,.03-.02,.05-.38,.79-.76,1.6-1.15,2.43-.05,.11-.1,.21-.15,.32l2.57,1.01,1.58-4Z"
          fill="#292929"
        />
        <path
          d="M105.43,278.03s0,0,0,0c-.26,.55-.53,1.1-.79,1.67-.09,.2-.19,.4-.28,.6-.02,.05-.05,.1-.07,.16,.38-.82,.76-1.64,1.15-2.43Z"
          fill="#292929"
        />
        <path
          d="M116.57,276.23c.06-.33,.11-.66,.17-.99,.01-.07,.03-.15,.04-.22,.13-.72,.25-1.43,.38-2.13,.05-.25,.09-.48,.14-.72,.02-.08,.03-.17,.05-.25l-1.56-.62-1.58,4,2.36,.93Z"
          fill="#292929"
        />
        <polygon
          points="110.3 269.13 110.3 269.14 110.3 269.13 110.3 269.13"
          fill="#292929"
        />
        <polygon
          points="108.09 272.88 108.09 272.88 108.09 272.87 108.09 272.88"
          fill="#292929"
        />
        <path
          d="M108.26,272.59c-.05,.1-.11,.19-.16,.28,0,0,0,0,0,0h0c.05-.09,.11-.19,.16-.29Z"
          fill="#292929"
        />
        <path
          d="M108.26,272.58c-.05,.1-.11,.19-.16,.29,.05-.1,.11-.19,.16-.28h0Z"
          fill="#292929"
        />
        <path
          d="M110.31,269.13h0s0,0,0,0c-.05,.08-.1,.16-.15,.24,.05-.08,.1-.17,.15-.25Z"
          fill="#292929"
        />
        <path
          d="M110.3,269.14c-.05,.08-.1,.16-.15,.24,0,0,0,0,0,0,.05-.08,.1-.16,.15-.24Z"
          fill="#292929"
        />
        <path
          d="M109.28,270.81s-.05,.08-.08,.13c0,.01-.01,.02-.02,.03-.17,.29-.34,.59-.51,.89,.2-.35,.4-.71,.6-1.05Z"
          fill="#292929"
        />
        <path
          d="M109.18,270.97c-.17,.29-.34,.59-.51,.89,0,0,0,0,0,0,.17-.3,.34-.6,.51-.89Z"
          fill="#292929"
        />
        <path
          d="M109.28,270.81s-.05,.08-.08,.13c.03-.04,.05-.08,.08-.13,0,0,0,0,0,0Z"
          fill="#292929"
        />
        <path
          d="M111.52,269.61l-1.22-.48c-.05,.08-.1,.17-.15,.25-.29,.46-.58,.94-.87,1.43-.2,.34-.4,.7-.6,1.05-.14,.24-.28,.48-.42,.73-.05,.1-.11,.2-.16,.29l1.84,.73,1.58-4Z"
          fill="#292929"
        />
        <path
          d="M108.67,271.86s0,0,0,0c-.14,.24-.28,.48-.42,.73h0c.14-.25,.28-.49,.42-.73Z"
          fill="#292929"
        />
        <path
          d="M110.15,269.38s0,0,0,0c-.29,.46-.58,.94-.87,1.43,0,0,0,0,0,0,.29-.49,.58-.96,.87-1.43Z"
          fill="#292929"
        />
        <path
          d="M118.96,264.55h0s.02-.07,.03-.11c.11-.4,.21-.8,.32-1.17,0,0,0-.02,0-.02,0-.03,.02-.07,.03-.1l-.29-.11-1.58,4,.81,.32c.22-1,.45-1.93,.67-2.8Z"
          fill="#292929"
        />
        <path
          d="M113.47,264.67s-.01,.01-.02,.02c0,0,.01-.01,.02-.02h0Z"
          fill="#5e7695"
        />
        <polygon
          points="112.99 265.26 112.99 265.26 112.99 265.25 112.99 265.26"
          fill="#5e7695"
        />
        <path
          d="M113.46,264.69v-.02s0,.01,0,.02c-.15,.19-.31,.37-.46,.56,0,0,0,0,0,0h.01c.15-.19,.3-.37,.45-.56Z"
          fill="#5e7695"
        />
        <path
          d="M113.46,264.69c-.15,.19-.3,.37-.45,.57l.2,.08,.26-.65Z"
          fill="#5e7695"
        />
        <path
          d="M121.28,258.87c-.11,.03-.21,.04-.32,.07h.02c.1-.02,.19-.04,.29-.07,0,0,0,0,0,0Z"
          fill="#5e7695"
        />
        <path
          d="M121.23,258.91s.03-.02,.05-.03c-.1,.02-.19,.05-.29,.08l.13,.05s.07-.08,.11-.1Z"
          fill="#5e7695"
        />
        <path
          d="M180.32,266.14c-.32,.86-.63,1.67-.93,2.44h3.27c.25-.33,.52-.66,.81-.97v-3.06h-2.55c-.17,.47-.36,.99-.59,1.59Z"
          fill="#ececec"
        />
        <path
          d="M137.27,260.25c-.12-.53-.24-1.12-.39-1.83-.08-.37-.13-.75-.17-1.13-.05-.51-.09-1.07-.1-1.64h-1.35v4.59h2.01Z"
          fill="#ececec"
        />
        <path
          d="M135.71,268.58h4.05v-.82c-.2-.52-.4-1.06-.62-1.62-.23-.6-.42-1.12-.59-1.59h-3.29v3.48c.15,.18,.31,.36,.45,.55Z"
          fill="#ececec"
        />
        <path
          d="M138.32,277.38h1.44v-4.5h-1.83c.42,1.43,.57,2.94,.39,4.5Z"
          fill="#ececec"
        />
        <path
          d="M182.42,286.27c0-.3,0-.6,0-.9-.47-1.36-.89-2.6-1.25-3.69h-2.2v4.59h3.46Z"
          fill="#ececec"
        />
        <path
          d="M180.05,277.38c-.18-1.56-.03-3.07,.39-4.5h-1.48v4.5h1.08Z"
          fill="#ececec"
        />
        <rect x="170.08" y="281.68" width="4.59" height="4.59" fill="#ececec" />
        <rect x="144.06" y="281.68" width="4.59" height="4.59" fill="#ececec" />
        <path
          d="M136.05,285.09c0,.39,0,.79,0,1.18h3.71v-4.59h-2.56c-.33,1.02-.72,2.16-1.15,3.41Z"
          fill="#ececec"
        />
        <rect x="152.95" y="281.68" width="1.43" height="4.59" fill="#ececec" />
        <rect x="164.23" y="281.68" width="1.54" height="4.59" fill="#ececec" />
        <rect x="144.06" y="308.25" width="4.59" height="4.5" fill="#ececec" />
        <rect x="135.26" y="308.25" width="4.5" height="4.5" fill="#ececec" />
        <rect x="164.23" y="308.25" width="1.54" height="4.5" fill="#ececec" />
        <rect x="152.95" y="308.25" width="1.43" height="4.5" fill="#ececec" />
        <path
          d="M183.46,302.64s0-.09-.01-.13c0,0,0,0,0,0-.12-1.05-.22-2.1-.32-3.14h-4.16v4.59h4.5v-1.32Z"
          fill="#ececec"
        />
        <path
          d="M182.58,258.42c-.14,.71-.27,1.29-.39,1.83h1.26v-4.59h-.61c-.01,.57-.05,1.13-.1,1.64-.04,.38-.1,.75-.17,1.13Z"
          fill="#ececec"
        />
        <rect x="178.97" y="317.05" width="4.5" height="2.97" fill="#ececec" />
        <rect x="170.08" y="317.05" width="4.59" height="2.97" fill="#ececec" />
        <rect x="164.23" y="317.05" width="1.54" height="2.97" fill="#ececec" />
        <rect x="170.08" y="308.25" width="4.59" height="4.5" fill="#ececec" />
        <rect x="178.97" y="308.25" width="4.5" height="4.5" fill="#ececec" />
        <rect x="170.08" y="299.37" width="4.59" height="4.59" fill="#ececec" />
        <rect x="170.08" y="290.57" width="4.59" height="4.5" fill="#ececec" />
        <rect x="164.23" y="290.57" width="1.54" height="4.5" fill="#ececec" />
        <rect x="152.95" y="290.57" width="1.43" height="4.5" fill="#ececec" />
        <path
          d="M182.77,295.07c-.02-.31-.03-.61-.05-.92-.02-.29-.05-.58-.06-.87h0c-.01-.23-.02-.45-.04-.68v.02c0-.22,0-.44-.02-.65-.02-.46-.06-.94-.08-1.4h-3.56v4.5h3.8Z"
          fill="#ececec"
        />
        <rect x="144.06" y="290.57" width="4.59" height="4.5" fill="#ececec" />
        <rect x="152.95" y="317.05" width="1.43" height="2.97" fill="#ececec" />
        <rect x="144.06" y="299.37" width="4.59" height="4.59" fill="#ececec" />
        <rect x="152.95" y="299.37" width="1.43" height="4.59" fill="#ececec" />
        <path
          d="M135.84,292.62v-.02c0,.23-.01,.45-.03,.68h0c-.02,.28-.04,.57-.06,.86-.02,.31-.03,.61-.05,.92h4.06v-4.5h-3.81c-.02,.46-.05,.94-.08,1.41,0,.22-.02,.43-.03,.64Z"
          fill="#ececec"
        />
        <rect x="164.23" y="299.37" width="1.54" height="4.59" fill="#ececec" />
        <path
          d="M135.26,300.21v3.74h4.5v-4.59h-4.42c-.03,.28-.05,.56-.08,.85Z"
          fill="#ececec"
        />
        <path
          d="M187.76,260.25h2.12c.11-.07,.21-.14,.32-.21,.12-.07,.24-.14,.36-.21,.13-.07,.26-.14,.4-.21,.11-.05,.22-.11,.34-.16,.19-.08,.39-.16,.59-.23,.09-.03,.19-.07,.29-.1,.1-.03,.2-.06,.3-.09v-2.55c-.74-.28-1.51-.56-2.28-.83h-2.43v4.59Z"
          fill="#ececec"
        />
        <path
          d="M196.86,258.8s.07,.01,.11,.02c.04,0,.08,.02,.12,.03,.13,.03,.27,.06,.4,.09h-.02c.12,.04,.23,.06,.35,.1-.17-.25-.33-.44-.5-.53-.17-.08-.35-.17-.55-.26v.53s.06,.01,.08,.02Z"
          fill="#ececec"
        />
        <path
          d="M126.58,259.23c.2,.07,.39,.15,.58,.23,.12,.05,.23,.11,.34,.16,.13,.07,.27,.13,.4,.21,.12,.07,.24,.14,.36,.21,.11,.07,.21,.14,.32,.21h2.38v-4.59h-2.86c-.58,.23-1.16,.46-1.73,.7v2.8c.07,.02,.14,.05,.21,.08Z"
          fill="#ececec"
        />
        <path
          d="M131.01,254.56c1.29-.47,2.55-.91,3.74-1.33-1.19,.42-2.45,.86-3.74,1.33Z"
          fill="#ececec"
        />
        <path
          d="M148.65,276.94c-.12,.15-.25,.3-.37,.44h.37v-.44Z"
          fill="#ececec"
        />
        <rect x="164.23" y="272.88" width="1.54" height="4.5" fill="#ececec" />
        <path
          d="M170.08,276.06v1.32h1.11c-.35-.43-.72-.86-1.11-1.32Z"
          fill="#ececec"
        />
        <rect x="152.95" y="272.88" width="1.43" height="4.5" fill="#ececec" />
        <rect x="135.26" y="317.05" width="4.5" height="2.97" fill="#ececec" />
        <path
          d="M183.45,253.36c-.29-.09-.57-.19-.83-.27,0,0,0,0,0,0l.83,.27Z"
          fill="#ececec"
        />
        <rect x="144.06" y="317.05" width="4.59" height="2.97" fill="#ececec" />
        <path
          d="M121.6,258.8c.16-.03,.31-.05,.47-.07v-.32c-.26,.15-.5,.29-.74,.44,.05-.01,.11-.01,.16-.02,.04,0,.07-.01,.11-.02Z"
          fill="#ececec"
        />
        <path
          d="M135.71,268.58c-.14-.19-.3-.37-.45-.55v.55h.45Z"
          fill="#ececec"
        />
        <path
          d="M135.27,274.23c.13,.86,.24,1.75,.34,2.66,.02,.17,.05,.32,.06,.49h2.64c.18-1.56,.03-3.07-.39-4.5h-2.67v1.23s0,.08,.02,.12Z"
          fill="#ececec"
        />
        <path
          d="M136.03,283.91h-.01c0,.39,.03,.77,.03,1.17,.43-1.24,.82-2.39,1.15-3.41h-1.23c0,.14,0,.28,0,.42,.02,.6,.04,1.2,.05,1.81Z"
          fill="#ececec"
        />
        <path
          d="M180.05,277.38h2.74c.11-1.15,.26-2.26,.43-3.33,0-.01,0-.02,0-.03,.06-.38,.12-.76,.19-1.13h-2.97c-.42,1.43-.57,2.94-.39,4.5Z"
          fill="#ececec"
        />
        <path
          d="M182.43,283.91c.01-.65,.03-1.29,.06-1.92,0-.1,0-.21,0-.31h-1.33c.36,1.1,.78,2.33,1.25,3.69,0-.5,.02-.98,.03-1.47h-.02Z"
          fill="#ececec"
        />
        <path
          d="M183.46,267.61c-.28,.31-.55,.64-.81,.97h.81v-.97Z"
          fill="#ececec"
        />
        <path
          d="M126.58,259.23c-.07-.03-.14-.05-.21-.08h0c.07,.02,.14,.05,.21,.08Z"
          fill="#ececec"
        />
        <path
          d="M121.37,258.85s.08-.02,.12-.03c-.05,.01-.11,.01-.16,.02-.02,0-.03,.02-.05,.03,.03,0,.06-.01,.09-.02Z"
          fill="#ececec"
        />
        <path
          d="M135.7,295.07c.02-.31,.03-.61,.05-.92-.02,.31-.05,.62-.07,.92h.02Z"
          fill="#ececec"
        />
        <path
          d="M135.87,291.98c.02-.47,.06-.95,.08-1.41h-.02c-.02,.47-.04,.94-.06,1.41Z"
          fill="#ececec"
        />
        <polygon
          points="135.61 293.2 135.26 293.06 135.26 294.09 135.61 293.2"
          fill="#ececec"
        />
        <path
          d="M135.26,300.08v.14c.03-.28,.05-.56,.08-.85h-.01c-.02,.24-.05,.47-.07,.71Z"
          fill="#ececec"
        />
        <path
          d="M130.96,300.92l-.57-.22c-.4,1.07-.8,2.15-1.21,3.26h1.78v-3.03Z"
          fill="#ececec"
        />
        <path
          d="M136.04,286.27c0-.4,0-.79,0-1.18-.13,.38-.27,.78-.41,1.18h.41Z"
          fill="#ececec"
        />
        <path
          d="M129.11,309.65l-1.81-.71c-.31,.82-.62,1.65-.94,2.48v1.33h1.52l1.22-3.1Z"
          fill="#ececec"
        />
        <path
          d="M130.24,319.66l-.39-.16-.21,.53h1.32v-2.51c-.24,.71-.47,1.42-.72,2.14Z"
          fill="#ececec"
        />
        <polygon
          points="130.96 292.73 130.04 295.07 130.96 295.07 130.96 292.73"
          fill="#ececec"
        />
        <polygon
          points="126.37 290.57 126.37 292.64 127.19 290.57 126.37 290.57"
          fill="#ececec"
        />
        <polygon
          points="122.07 291.04 121.47 292.55 122.07 292.79 122.07 291.04"
          fill="#ececec"
        />
        <path
          d="M130.39,300.7l-2.23-.88-1.63,4.14h2.65c.41-1.1,.82-2.19,1.21-3.26Z"
          fill="#ececec"
        />
        <polygon
          points="118.21 276.87 118.01 277.38 119.49 277.38 118.21 276.87"
          fill="#ececec"
        />
        <path
          d="M126.37,308.57v2.85c.31-.83,.63-1.66,.94-2.48l-.94-.37Z"
          fill="#ececec"
        />
        <polygon
          points="119.81 272.88 122.07 273.77 122.07 272.88 119.81 272.88"
          fill="#ececec"
        />
        <polygon
          points="127.24 266.26 127.91 264.55 126.37 264.55 126.37 265.92 127.24 266.26"
          fill="#ececec"
        />
        <polygon
          points="122.07 320.03 122.07 317.05 121.36 317.05 120.18 320.03 122.07 320.03"
          fill="#ececec"
        />
        <polygon
          points="130.66 281.79 130.38 281.68 126.37 281.68 126.37 284.93 129.01 285.97 130.66 281.79"
          fill="#ececec"
        />
        <polygon
          points="117.57 286.08 117.57 286.27 118.05 286.27 117.57 286.08"
          fill="#ececec"
        />
        <path
          d="M135.27,274.23s0-.08-.02-.12h0s.01,.09,.02,.12Z"
          fill="#ececec"
        />
        <path
          d="M135.68,277.38c-.02-.17-.04-.32-.06-.49,.02,.16,.04,.32,.05,.49h0Z"
          fill="#ececec"
        />
        <path
          d="M135.98,282.1c0-.14,0-.28,0-.42h0c0,.14,0,.28,.01,.42Z"
          fill="#ececec"
        />
        <path
          d="M135.26,283.61v2.66h.38c.14-.4,.28-.8,.41-1.18,0-.4-.02-.78-.03-1.18l-.76-.3Z"
          fill="#ececec"
        />
        <polygon
          points="118.78 299.37 118.24 300.74 122.07 302.25 122.07 299.37 118.78 299.37"
          fill="#ececec"
        />
        <path d="M113.32,316.98s0,.05,0,.07h0s0-.04,0-.07Z" fill="#ececec" />
        <polygon
          points="121.15 281.68 118.14 281.68 120.74 282.71 121.15 281.68"
          fill="#ececec"
        />
        <path
          d="M114.16,294.29c-.02,.26-.04,.51-.06,.76,.02-.24,.05-.51,.07-.76h0Z"
          fill="#ececec"
        />
        <path
          d="M113.92,297.44c-.03,.57-.05,1.1-.06,1.56h0c0-.47,.03-.99,.06-1.56Z"
          fill="#ececec"
        />
        <polygon
          points="117.64 290.57 117.57 290.57 117.57 290.73 117.64 290.57"
          fill="#ececec"
        />
        <path
          d="M115.21,285.15c-.03,.21-.05,.42-.08,.63,.03-.21,.06-.42,.09-.63h0Z"
          fill="#ececec"
        />
        <path
          d="M114.82,288.19c-.07,.56-.14,1.12-.2,1.66h0c.06-.54,.13-1.1,.2-1.66Z"
          fill="#ececec"
        />
        <polygon
          points="120.21 308.25 117.57 308.25 117.57 310.03 119.25 310.69 120.21 308.25"
          fill="#ececec"
        />
        <polygon
          points="130.96 277.28 130.96 272.88 129.24 272.88 127.97 276.1 130.96 277.28"
          fill="#ececec"
        />
        <polygon
          points="182.86 293.2 183.46 294.74 183.46 292.96 182.86 293.2"
          fill="#ececec"
        />
        <path
          d="M198.41,260.25c-.18-.47-.36-.86-.54-1.15l.45,1.15h.09Z"
          fill="#ececec"
        />
        <path
          d="M187.76,303.95h1.43c-.41-1.09-.81-2.17-1.2-3.22l-.23,.09v3.13Z"
          fill="#ececec"
        />
        <path
          d="M198.9,261.74c-.17-.56-.33-1.06-.5-1.49,.16,.41,.32,.9,.48,1.44l.02,.05Z"
          fill="#ececec"
        />
        <path
          d="M183.45,302.52h0s0-.01,0-.02c0,.04,0,.09,.01,.13h0s0-.08-.01-.11Z"
          fill="#ececec"
        />
        <path
          d="M183.39,301.97c-.09-.87-.18-1.73-.26-2.6h-.01c.1,1.05,.21,2.09,.32,3.14-.02-.18-.03-.36-.05-.54Z"
          fill="#ececec"
        />
        <path
          d="M182.54,290.57h-.02c.02,.46,.05,.94,.08,1.4-.02-.47-.04-.93-.06-1.4Z"
          fill="#ececec"
        />
        <path
          d="M182.72,294.15c.02,.31,.03,.61,.05,.92h.02c-.02-.31-.04-.61-.07-.92Z"
          fill="#ececec"
        />
        <path
          d="M188.22,319.66c-.16-.47-.31-.92-.46-1.38v1.75h1.06l-.21-.53-.39,.16Z"
          fill="#ececec"
        />
        <path
          d="M192.48,312.75v-.05c-.47-1.25-.94-2.5-1.41-3.73l-1.72,.68,1.22,3.1h1.9Z"
          fill="#ececec"
        />
        <path
          d="M182.42,285.37c0,.3,0,.6,0,.9h.31c-.11-.3-.21-.6-.31-.9Z"
          fill="#ececec"
        />
        <path
          d="M197.1,258.86s-.08-.03-.12-.03c.04,0,.08,.02,.12,.03,0,0,0,0,0,0Z"
          fill="#ececec"
        />
        <path
          d="M197.48,258.96c.12,.03,.23,.06,.35,.09,0,0,0,0,0,0-.12-.04-.23-.06-.35-.09h0Z"
          fill="#ececec"
        />
        <polygon
          points="200.46 277.38 200.26 276.87 198.97 277.38 200.46 277.38"
          fill="#ececec"
        />
        <polygon
          points="201.28 286.27 201.28 285.93 200.42 286.27 201.28 286.27"
          fill="#ececec"
        />
        <polygon
          points="198.65 272.88 196.78 272.88 196.78 273.62 198.65 272.88"
          fill="#ececec"
        />
        <polygon
          points="189.22 272.88 187.76 272.88 187.76 277.18 190.49 276.1 189.22 272.88"
          fill="#ececec"
        />
        <path
          d="M202.74,286.24c-.03-.28-.06-.57-.09-.86h0c.03,.29,.06,.57,.09,.86Z"
          fill="#ececec"
        />
        <polygon
          points="192.48 293.62 192.48 290.57 191.27 290.57 192.48 293.62"
          fill="#ececec"
        />
        <polygon
          points="196.78 320.03 198.28 320.03 197.11 317.05 196.78 317.05 196.78 320.03"
          fill="#ececec"
        />
        <path
          d="M183.46,286.27v-2.76l-1.01,.4c0,.49-.03,.97-.03,1.47,.1,.29,.21,.59,.31,.9h.73Z"
          fill="#ececec"
        />
        <path
          d="M182.5,281.68h0c0,.1,0,.21,0,.31,0-.1,0-.21,0-.31Z"
          fill="#ececec"
        />
        <polygon
          points="200.33 281.68 197.32 281.68 197.73 282.71 200.33 281.68"
          fill="#ececec"
        />
        <path
          d="M203.1,290.14c-.1-1.24-.22-2.53-.35-3.87,.13,1.34,.25,2.62,.35,3.87h0Z"
          fill="#ececec"
        />
        <path
          d="M203.44,295.04c0-.14-.01-.27-.02-.41h0c0,.13,.02,.27,.02,.41Z"
          fill="#ececec"
        />
        <path
          d="M183.42,272.88h0c-.07,.37-.13,.75-.19,1.13,.06-.39,.13-.76,.2-1.13Z"
          fill="#ececec"
        />
        <polygon
          points="200.99 290.97 201.28 290.86 201.28 290.57 200.83 290.57 200.99 290.97"
          fill="#ececec"
        />
        <polygon
          points="196.78 292.64 196.99 292.55 196.78 292.02 196.78 292.64"
          fill="#ececec"
        />
        <path
          d="M192.48,308.42l-1.41,.56c.46,1.23,.93,2.48,1.41,3.73v-4.28Z"
          fill="#ececec"
        />
        <polygon
          points="192.48 265.76 192.48 264.55 190.55 264.55 191.23 266.26 192.48 265.76"
          fill="#ececec"
        />
        <polygon
          points="199.22 310.69 201.28 309.88 201.28 308.25 198.26 308.25 199.22 310.69"
          fill="#ececec"
        />
        <polygon
          points="196.78 302.1 200.22 300.74 199.68 299.37 196.78 299.37 196.78 302.1"
          fill="#ececec"
        />
        <path
          d="M183.22,274.05c-.17,1.07-.31,2.18-.43,3.33h0c.11-1.15,.25-2.26,.42-3.33Z"
          fill="#ececec"
        />
        <polygon
          points="189.46 285.97 192.48 284.78 192.48 281.68 188.08 281.68 187.81 281.79 189.46 285.97"
          fill="#ececec"
        />
        <polygon
          points="203.55 297.46 203.55 297.45 203.55 297.46 203.55 297.46"
          fill="#ececec"
        />
        <polygon
          points="187.76 293.38 187.76 295.07 188.43 295.07 187.76 293.38"
          fill="#ececec"
        />
        <path
          d="M189.19,303.95h2.75l-1.63-4.14-2.32,.91c.39,1.06,.79,2.13,1.2,3.22Z"
          fill="#ececec"
        />
        <path
          d="M190.2,260.04c-.11,.07-.22,.14-.32,.21h0c.11-.07,.21-.14,.32-.21Z"
          fill="#ececec"
        />
        <path
          d="M192.48,259.05c-.1,.03-.2,.06-.3,.09,.1-.03,.2-.06,.3-.08h0Z"
          fill="#ececec"
        />
        <path
          d="M196.97,258.82s-.07-.01-.11-.02c.02,0,.04,0,.06,.01,.02,0,.03,0,.05,0Z"
          fill="#ececec"
        />
        <path
          d="M183.22,274.04s0-.02,0-.03c0,.01,0,.02,0,.03,0,0,0,0,0,0,0,0,0,0,0,0Z"
          fill="#ececec"
        />
        <path
          d="M188.22,319.66l.39-.16-.86-2.17v.94c.15,.46,.31,.91,.46,1.38Z"
          fill="#ececec"
        />
        <polygon
          points="187.76 312.75 190.58 312.75 189.35 309.65 187.76 310.28 187.76 312.75"
          fill="#ececec"
        />
        <path
          d="M199.22,262.91c-.07-.27-.14-.53-.21-.78,.07,.24,.14,.51,.2,.78,0,0,0,0,0,0Z"
          fill="#ececec"
        />
        <path
          d="M199.01,262.13c-.04-.13-.07-.26-.11-.39l-.02-.05c.04,.15,.09,.28,.13,.44Z"
          fill="#ececec"
        />
        <path
          d="M197.1,258.85s-.08-.02-.12-.03c-.02,0-.03,0-.05,0,.06,.01,.12,.03,.17,.04Z"
          fill="#ececec"
        />
        <path
          d="M183.46,295.07v-.33l-.61-1.54-.18,.07c.02,.29,.03,.58,.05,.87,.02,.31,.05,.61,.07,.92h.68Z"
          fill="#ececec"
        />
        <path
          d="M182.66,293.28c.02,.29,.04,.58,.06,.87-.02-.29-.03-.58-.05-.87h-.01Z"
          fill="#ececec"
        />
        <path
          d="M192.48,260.25v-1.2c-.1,.03-.21,.05-.3,.08-.1,.03-.19,.07-.29,.1-.2,.07-.4,.15-.59,.23-.12,.05-.23,.11-.34,.16-.13,.07-.27,.13-.4,.21-.12,.07-.24,.14-.36,.21-.11,.07-.21,.14-.32,.21h2.6Z"
          fill="#ececec"
        />
        <polygon
          points="192.48 317.57 192.48 317.05 192.27 317.05 192.48 317.57"
          fill="#ececec"
        />
        <path d="M183.45,302.52s0,.07,.01,.11v-.11h-.01Z" fill="#ececec" />
        <polygon
          points="188.62 319.5 188.83 320.03 192.48 320.03 192.48 317.97 188.62 319.5"
          fill="#ececec"
        />
        <path
          d="M196.78,260.25h1.54l-.45-1.15s-.03-.03-.04-.05c-.12-.04-.23-.06-.35-.09l-.7,.27v1.02Z"
          fill="#ececec"
        />
        <path
          d="M189.35,309.65l1.72-.68c-.09-.24-.18-.48-.27-.72h-2l.55,1.4Z"
          fill="#ececec"
        />
        <path
          d="M182.86,293.2l.61-.24v-2.4h-.92c.02,.47,.04,.93,.06,1.4,.01,.23,.03,.45,.04,.68l.22,.56Z"
          fill="#ececec"
        />
        <path
          d="M182.6,291.97c0,.22,.02,.43,.03,.65v.02c0-.23-.02-.45-.03-.68Z"
          fill="#ececec"
        />
        <path
          d="M187.99,300.73c-.08-.2-.15-.4-.23-.61v.7l.23-.09Z"
          fill="#ececec"
        />
        <path
          d="M183.39,301.97c.02,.18,.03,.36,.05,.54,0,0,0,0,0,0,0,0,0,0,0,.01-.02-.18-.03-.37-.05-.55Z"
          fill="#ececec"
        />
        <path
          d="M202.66,285.38c-.04-.42-.09-.84-.13-1.26,.04,.42,.09,.84,.13,1.26h0Z"
          fill="#ececec"
        />
        <polygon
          points="192.48 265.76 191.23 266.26 192.15 268.58 192.48 268.58 192.48 265.76"
          fill="#ececec"
        />
        <polygon
          points="196.78 273.62 196.78 277.38 198.97 277.38 200.26 276.87 198.68 272.88 198.65 272.88 196.78 273.62"
          fill="#ececec"
        />
        <path
          d="M183.44,272.88h-.01c-.07,.38-.14,.75-.2,1.13,0,0,0,.02,0,.03,.06-.4,.15-.77,.22-1.16Z"
          fill="#ececec"
        />
        <path
          d="M199.27,263.08h0c-.01-.06-.03-.12-.04-.17,0,0,0,0,0,0,.02,.06,.03,.11,.05,.17Z"
          fill="#ececec"
        />
        <path
          d="M203.13,290.55c-.01-.14-.02-.27-.03-.41h0c.01,.13,.02,.27,.03,.41Z"
          fill="#ececec"
        />
        <path
          d="M203.58,298.46c0-.32-.01-.65-.03-1h0c.01,.35,.02,.69,.03,1Z"
          fill="#ececec"
        />
        <path
          d="M203.58,299.41h0s0-.03,0-.04c0,.01,0,.03,0,.04Z"
          fill="#ececec"
        />
        <polygon
          points="201.28 277.38 201.28 276.47 200.26 276.87 200.46 277.38 201.28 277.38"
          fill="#ececec"
        />
        <path
          d="M203.42,294.64c-.07-1.24-.17-2.6-.29-4.04,.12,1.44,.21,2.8,.29,4.04h0Z"
          fill="#ececec"
        />
        <polygon
          points="196.78 283.08 197.73 282.71 197.32 281.68 196.78 281.68 196.78 283.08"
          fill="#ececec"
        />
        <polygon
          points="188.71 286.27 189.46 285.97 187.81 281.79 187.76 281.81 187.76 286.27 188.71 286.27"
          fill="#ececec"
        />
        <polygon
          points="199.68 299.37 200.22 300.74 201.28 300.32 201.28 299.37 199.68 299.37"
          fill="#ececec"
        />
        <polygon
          points="188.08 281.68 187.76 281.68 187.81 281.79 188.08 281.68"
          fill="#ececec"
        />
        <polygon
          points="201.28 291.7 201.28 290.86 200.99 290.97 201.28 291.7"
          fill="#ececec"
        />
        <polygon
          points="192.48 275.32 192.48 272.88 189.22 272.88 190.49 276.1 192.48 275.32"
          fill="#ececec"
        />
        <polygon
          points="191 277.38 190.49 276.1 187.76 277.18 187.76 277.38 191 277.38"
          fill="#ececec"
        />
        <polygon
          points="199.13 286.27 200.42 286.27 201.28 285.93 201.28 281.68 200.33 281.68 197.73 282.71 199.13 286.27"
          fill="#ececec"
        />
        <polygon
          points="196.78 302.1 196.78 303.95 201.28 303.95 201.28 303.41 200.22 300.74 196.78 302.1"
          fill="#ececec"
        />
        <polygon
          points="196.78 311.65 199.22 310.69 198.26 308.25 196.78 308.25 196.78 311.65"
          fill="#ececec"
        />
        <polygon
          points="200.04 312.75 201.28 312.75 201.28 309.88 199.22 310.69 200.04 312.75"
          fill="#ececec"
        />
        <polygon
          points="196.78 292.02 196.99 292.55 200.99 290.97 200.83 290.57 196.78 290.57 196.78 292.02"
          fill="#ececec"
        />
        <polygon
          points="190.55 264.55 187.76 264.55 187.76 267.63 191.23 266.26 190.55 264.55"
          fill="#ececec"
        />
        <path
          d="M183.14,281.68h-.64c0,.1,0,.21,0,.31-.02,.63-.03,1.27-.04,1.92l1.01-.4v-1.01l-.32-.81Z"
          fill="#ececec"
        />
        <path
          d="M182.43,283.91h.02c.01-.65,.02-1.29,.04-1.92-.02,.63-.05,1.27-.06,1.92Z"
          fill="#ececec"
        />
        <polygon
          points="196.78 295.07 197.98 295.07 196.99 292.55 196.78 292.64 196.78 295.07"
          fill="#ececec"
        />
        <path
          d="M202.5,283.85c-.06-.6-.13-1.2-.2-1.8h0c.07,.6,.13,1.2,.2,1.8Z"
          fill="#ececec"
        />
        <polygon
          points="196.98 268.58 196.78 268.07 196.78 268.58 196.98 268.58"
          fill="#ececec"
        />
        <path
          d="M183.46,277.38v-3.43l-.24,.1s0,0,0,0c-.17,1.07-.31,2.19-.42,3.33h.66Z"
          fill="#ececec"
        />
        <path
          d="M202.18,280.95c-.06-.48-.12-.95-.18-1.43,.06,.48,.12,.95,.17,1.43h0Z"
          fill="#ececec"
        />
        <path
          d="M201.65,276.74c-.02-.13-.03-.27-.05-.4h0c.02,.14,.04,.27,.05,.4Z"
          fill="#ececec"
        />
        <path
          d="M192.48,308.42v-.16h-1.68c.09,.24,.18,.48,.27,.72l1.41-.56Z"
          fill="#ececec"
        />
        <polygon
          points="190.3 299.82 191.94 303.95 192.08 303.95 192.48 303.79 192.48 299.37 191.45 299.37 190.3 299.82"
          fill="#ececec"
        />
        <path
          d="M187.76,300.13c.08,.2,.15,.4,.23,.61l2.32-.91-.18-.45h-2.36v.76Z"
          fill="#ececec"
        />
        <polygon
          points="199.53 320.03 201.28 319.34 201.28 317.05 197.11 317.05 198.28 320.03 199.53 320.03"
          fill="#ececec"
        />
        <polygon
          points="189.53 290.57 187.76 291.27 187.76 293.38 188.43 295.07 190.63 295.07 192.48 294.34 192.48 293.62 191.27 290.57 189.53 290.57"
          fill="#ececec"
        />
        <polygon
          points="189.58 286.27 192.48 286.27 192.48 284.78 189.46 285.97 189.58 286.27"
          fill="#ececec"
        />
        <path
          d="M200.97,271.97c-.06-.4-.13-.79-.19-1.18,.06,.39,.13,.78,.19,1.18h0Z"
          fill="#ececec"
        />
        <path
          d="M200.41,268.58c-.07-.41-.15-.84-.22-1.24l-3.14,1.24h3.36Z"
          fill="#ececec"
        />
        <polygon
          points="201.28 320.03 201.28 319.34 199.53 320.03 201.28 320.03"
          fill="#ececec"
        />
        <polygon
          points="187.76 317.05 187.76 317.33 188.62 319.5 192.48 317.97 192.48 317.57 192.27 317.05 187.76 317.05"
          fill="#ececec"
        />
        <polygon
          points="196.78 312.75 200.04 312.75 199.22 310.69 196.78 311.65 196.78 312.75"
          fill="#ececec"
        />
        <polygon
          points="187.76 310.28 189.35 309.65 188.8 308.25 187.76 308.25 187.76 310.28"
          fill="#ececec"
        />
        <polygon
          points="192.48 303.95 192.48 303.79 192.08 303.95 192.48 303.95"
          fill="#ececec"
        />
        <polygon
          points="201.28 303.41 201.28 300.32 200.22 300.74 201.28 303.41"
          fill="#ececec"
        />
        <path
          d="M203.57,300c0-.18,0-.38,0-.59h0c0,.21,0,.41,0,.59Z"
          fill="#ececec"
        />
        <polygon
          points="183.45 302.52 183.45 302.52 183.45 302.52 183.45 302.52"
          fill="#ececec"
        />
        <path
          d="M183.14,299.37c.08,.87,.16,1.73,.26,2.6-.09-.87-.17-1.73-.26-2.6h0Z"
          fill="#ececec"
        />
        <path
          d="M183.45,302.52h.01v-3.16h-.32c.08,.87,.16,1.73,.26,2.6,.02,.18,.03,.37,.05,.55,0,0,0,0,0,0Z"
          fill="#ececec"
        />
        <polygon
          points="191.45 299.37 190.13 299.37 190.3 299.82 191.45 299.37"
          fill="#ececec"
        />
        <polygon
          points="192.48 294.34 190.63 295.07 192.48 295.07 192.48 294.34"
          fill="#ececec"
        />
        <polygon
          points="196.99 292.55 197.98 295.07 201.28 295.07 201.28 291.7 200.99 290.97 196.99 292.55"
          fill="#ececec"
        />
        <path
          d="M182.62,292.6c.01,.23,.02,.45,.04,.68h0c-.01-.22-.02-.44-.03-.66v-.02Z"
          fill="#ececec"
        />
        <path
          d="M182.67,293.28l.18-.07-.22-.56c.01,.21,.02,.42,.03,.63Z"
          fill="#ececec"
        />
        <path
          d="M182.64,292.65v-.02c0,.22,0,.44,.02,.66h.01c-.01-.22-.02-.43-.03-.64Z"
          fill="#ececec"
        />
        <polygon
          points="189.53 290.57 187.76 290.57 187.76 291.27 189.53 290.57"
          fill="#ececec"
        />
        <polygon
          points="189.46 285.97 188.71 286.27 189.58 286.27 189.46 285.97"
          fill="#ececec"
        />
        <polygon
          points="199.13 286.27 197.73 282.71 196.78 283.08 196.78 286.27 199.13 286.27"
          fill="#ececec"
        />
        <path
          d="M202.3,282.04c-.01-.11-.03-.23-.04-.34,.01,.11,.02,.23,.04,.34h0Z"
          fill="#ececec"
        />
        <path
          d="M202.26,281.67c-.03-.24-.05-.48-.08-.72h0c.03,.24,.06,.48,.09,.72Z"
          fill="#ececec"
        />
        <polygon
          points="187.76 281.68 187.76 281.68 187.76 281.81 187.81 281.79 187.76 281.68"
          fill="#ececec"
        />
        <polygon
          points="183.46 281.68 183.14 281.68 183.46 282.49 183.46 281.68"
          fill="#ececec"
        />
        <polygon
          points="192.48 275.32 190.49 276.1 191 277.38 192.48 277.38 192.48 275.32"
          fill="#ececec"
        />
        <path
          d="M201.6,276.34c-.1-.78-.21-1.56-.32-2.33,.11,.76,.21,1.55,.32,2.33h0Z"
          fill="#ececec"
        />
        <path
          d="M200.26,276.87l1.02-.4v-2.46c-.05-.38-.11-.76-.17-1.13h-2.43l1.58,3.99Z"
          fill="#ececec"
        />
        <path
          d="M201.11,272.88c-.05-.31-.09-.61-.14-.91h0c.05,.31,.1,.6,.14,.91Z"
          fill="#ececec"
        />
        <path
          d="M183.44,272.88c-.07,.39-.16,.76-.22,1.16,0,0,0,0,0,0l.24-.1v-1.07h-.03Z"
          fill="#ececec"
        />
        <polygon
          points="192.15 268.58 191.23 266.26 187.76 267.63 187.76 268.58 192.15 268.58"
          fill="#ececec"
        />
        <path
          d="M196.78,268.07l.2,.52h.06l3.14-1.24c-.19-1-.38-1.93-.57-2.79h-2.83v3.52Z"
          fill="#ececec"
        />
        <path
          d="M199.31,263.26c-.01-.06-.03-.12-.04-.17h0c.02,.06,.03,.11,.05,.17Z"
          fill="#ececec"
        />
        <path
          d="M196.86,258.8s-.06-.01-.08-.02h0s.06,.01,.08,.02Z"
          fill="#ececec"
        />
        <path
          d="M197.48,258.96h0c-.13-.04-.25-.07-.38-.1,0,0,0,0,0,0,.13,.03,.25,.07,.38,.1Z"
          fill="#ececec"
        />
        <path
          d="M197.5,258.95c-.13-.04-.27-.06-.4-.09,.13,.03,.25,.06,.38,.1h.02Z"
          fill="#ececec"
        />
        <path
          d="M196.78,258.79s.09,.01,.14,.02c-.02,0-.04,0-.06-.01-.03,0-.06,0-.08-.01h0Z"
          fill="#ececec"
        />
        <path
          d="M196.92,258.81s-.09-.01-.14-.02v.44l.7-.27c-.13-.04-.25-.07-.38-.1-.06-.01-.12-.03-.17-.04Z"
          fill="#ececec"
        />
        <path
          d="M121.6,258.8s-.07,.01-.11,.02c.02,0,.03,0,.05,0,.02,0,.04,0,.06-.01Z"
          fill="#ececec"
        />
        <path
          d="M128.58,260.25c-.11-.07-.21-.14-.32-.21,.11,.07,.21,.14,.32,.21h0Z"
          fill="#ececec"
        />
        <path
          d="M135.61,293.2l-.35,.89v.97h.42c.02-.31,.04-.62,.07-.92,.02-.29,.03-.58,.05-.87l-.19-.07Z"
          fill="#ececec"
        />
        <path
          d="M135.75,294.14c.02-.29,.05-.58,.06-.86h-.01c-.02,.28-.03,.57-.05,.86Z"
          fill="#ececec"
        />
        <path
          d="M135.61,293.2l.22-.56c.01-.22,.03-.45,.04-.67,.02-.47,.04-.94,.06-1.41h-.67v2.5l.35,.14Z"
          fill="#ececec"
        />
        <path
          d="M135.84,292.62c.01-.22,.02-.43,.03-.64-.01,.22-.02,.45-.04,.67v-.02Z"
          fill="#ececec"
        />
        <path
          d="M121.49,258.82s-.08,.02-.12,.03c.06-.01,.12-.03,.17-.04-.02,0-.03,0-.05,0Z"
          fill="#ececec"
        />
        <path
          d="M119.64,262.16c-.06,.2-.13,.4-.19,.62,0,0,0,0,0,0,.06-.21,.12-.42,.18-.62Z"
          fill="#ececec"
        />
        <path
          d="M130.24,319.66c.24-.73,.48-1.43,.72-2.14v-.46h-.14l-.97,2.45,.39,.16Z"
          fill="#ececec"
        />
        <path
          d="M130.96,299.37h-.07c-.16,.44-.33,.88-.49,1.33l.57,.22v-1.56Z"
          fill="#ececec"
        />
        <polygon
          points="130.96 310.38 129.11 309.65 127.89 312.75 130.96 312.75 130.96 310.38"
          fill="#ececec"
        />
        <path
          d="M129.11,309.65l.55-1.4h-2.1c-.09,.23-.17,.46-.26,.69l1.81,.71Z"
          fill="#ececec"
        />
        <path
          d="M122.07,259.38l-.95-.38c-.25,.22-.51,.64-.78,1.24h1.73v-.87Z"
          fill="#ececec"
        />
        <polygon
          points="129.85 319.5 126.37 318.13 126.37 320.03 129.64 320.03 129.85 319.5"
          fill="#ececec"
        />
        <path
          d="M126.37,260.25h2.21c-.11-.07-.21-.14-.32-.21-.12-.07-.24-.14-.36-.21-.13-.07-.26-.14-.4-.21-.11-.06-.23-.11-.34-.16-.19-.08-.39-.16-.58-.23-.07-.03-.14-.05-.21-.08v1.09Z"
          fill="#ececec"
        />
        <polygon
          points="120.18 320.03 121.36 317.05 117.57 317.05 117.57 319.49 118.94 320.03 120.18 320.03"
          fill="#ececec"
        />
        <path
          d="M130.89,299.37h-2.55l-.18,.45,2.23,.88c.17-.45,.33-.89,.49-1.33Z"
          fill="#ececec"
        />
        <path
          d="M113.86,299.01h0c0,.37,0,.69,0,1,0-.2,0-.41,0-.64,0-.11,0-.24,0-.36Z"
          fill="#ececec"
        />
        <path
          d="M116.57,276.23h0c-.02,.14-.05,.29-.07,.43,.02-.14,.05-.29,.07-.43Z"
          fill="#ececec"
        />
        <path
          d="M116.08,279.28c-.08,.5-.16,1-.24,1.5h0c.08-.5,.16-1,.23-1.5Z"
          fill="#ececec"
        />
        <path
          d="M113.87,303.85s0,.07,0,.11c0,0,0,0,0-.01,0-.04,0-.07,0-.1Z"
          fill="#ececec"
        />
        <path
          d="M117.42,271.53c-.02,.13-.05,.25-.07,.38h0c.02-.13,.05-.25,.07-.38Z"
          fill="#ececec"
        />
        <path
          d="M118.29,267.35c-.09,.4-.18,.82-.27,1.24h3.4l-3.13-1.24Z"
          fill="#ececec"
        />
        <polygon
          points="127.84 295.07 130.04 295.07 130.96 292.73 130.96 291.37 128.94 290.57 127.19 290.57 126.37 292.64 126.37 294.49 127.84 295.07"
          fill="#ececec"
        />
        <path
          d="M113.72,308.2s0,.04,0,.07c0,0,0-.01,0-.02,0-.02,0-.03,0-.05Z"
          fill="#ececec"
        />
        <polygon
          points="128.89 286.27 129.01 285.97 126.37 284.93 126.37 286.27 128.89 286.27"
          fill="#ececec"
        />
        <polygon
          points="122.07 291.04 122.07 290.57 117.64 290.57 117.57 290.73 117.57 291.01 121.47 292.55 122.07 291.04"
          fill="#ececec"
        />
        <path
          d="M114.48,291.07c-.12,1.13-.24,2.22-.33,3.22h0c.09-1.01,.2-2.08,.32-3.22Z"
          fill="#ececec"
        />
        <path
          d="M114.62,289.85c-.02,.16-.03,.3-.05,.46,.02-.15,.04-.31,.05-.46h0Z"
          fill="#ececec"
        />
        <path
          d="M127.57,308.25h-1.19v.32l.94,.37c.09-.23,.17-.46,.26-.69Z"
          fill="#ececec"
        />
        <path
          d="M113.52,312.75s0-.04,0-.07c0,.04,0,.08,0,.11,0-.02,0-.03,0-.05Z"
          fill="#ececec"
        />
        <polygon
          points="130.7 281.68 130.38 281.68 130.66 281.79 130.7 281.68"
          fill="#ececec"
        />
        <polygon
          points="122.07 292.79 121.47 292.55 120.48 295.07 122.07 295.07 122.07 292.79"
          fill="#ececec"
        />
        <polygon
          points="122.07 308.25 120.21 308.25 119.25 310.69 122.07 311.81 122.07 308.25"
          fill="#ececec"
        />
        <path
          d="M115.35,284.13c-.05,.34-.1,.68-.14,1.02h0c.05-.34,.09-.67,.14-1.02Z"
          fill="#ececec"
        />
        <polygon
          points="126.53 303.95 128.16 299.82 127.02 299.37 126.37 299.37 126.37 303.95 126.39 303.95 126.53 303.95"
          fill="#ececec"
        />
        <polygon
          points="130.96 286.27 130.96 281.91 130.66 281.79 129.01 285.97 129.76 286.27 130.96 286.27"
          fill="#ececec"
        />
        <polygon
          points="130.96 268.54 130.94 268.58 130.96 268.58 130.96 268.54"
          fill="#ececec"
        />
        <polygon
          points="121.91 303.95 122.07 303.53 122.07 302.25 118.24 300.74 117.57 302.43 117.57 303.95 121.91 303.95"
          fill="#ececec"
        />
        <polygon
          points="122.07 283.23 122.07 281.68 121.15 281.68 120.74 282.71 122.07 283.23"
          fill="#ececec"
        />
        <polygon
          points="126.37 265.92 126.37 268.45 127.24 266.26 126.37 265.92"
          fill="#ececec"
        />
        <path
          d="M135.26,277.38h.41c-.02-.17-.04-.32-.05-.49-.1-.91-.21-1.8-.34-2.66,0-.04,0-.07-.02-.11v3.26Z"
          fill="#ececec"
        />
        <polygon
          points="127.47 277.38 130.96 277.38 130.96 277.28 127.97 276.1 127.47 277.38"
          fill="#ececec"
        />
        <path
          d="M113.27,317.84h0c-.04,.71-.07,1.44-.11,2.18h.11v-2.18Z"
          fill="#ececec"
        />
        <polygon
          points="118.78 299.37 117.57 299.37 117.57 300.47 118.24 300.74 118.78 299.37"
          fill="#ececec"
        />
        <path
          d="M135.26,281.85v1.76l.76,.3c-.01-.6-.02-1.21-.04-1.8,0-.14,0-.28-.01-.42h-.64l-.07,.17Z"
          fill="#ececec"
        />
        <path
          d="M136.03,283.91c-.01-.61-.03-1.21-.05-1.81,.02,.59,.03,1.2,.04,1.8h.01Z"
          fill="#ececec"
        />
        <polygon
          points="119.33 286.27 120.74 282.71 118.14 281.68 117.57 281.68 117.57 286.08 118.05 286.27 119.33 286.27"
          fill="#ececec"
        />
        <polygon
          points="126.37 275.47 127.97 276.1 129.24 272.88 126.37 272.88 126.37 275.47"
          fill="#ececec"
        />
        <polygon
          points="119.49 277.38 122.07 277.38 122.07 273.77 119.81 272.88 119.78 272.88 118.21 276.87 119.49 277.38"
          fill="#ececec"
        />
        <polygon
          points="122.07 267.09 121.48 268.58 122.07 268.58 122.07 267.09"
          fill="#ececec"
        />
        <polygon
          points="118.01 277.38 118.21 276.87 117.57 276.62 117.57 277.38 118.01 277.38"
          fill="#ececec"
        />
        <polygon
          points="130.96 267.73 130.96 264.55 127.91 264.55 127.24 266.26 130.96 267.73"
          fill="#ececec"
        />
        <polygon
          points="119.25 310.69 117.57 310.03 117.57 312.75 118.43 312.75 119.25 310.69"
          fill="#ececec"
        />
        <path
          d="M119.45,262.78s0,0,0,0c-.03,.12-.07,.24-.1,.36h0c.04-.13,.07-.24,.11-.36Z"
          fill="#ececec"
        />
        <polygon
          points="117.57 319.49 117.57 320.03 118.94 320.03 117.57 319.49"
          fill="#ececec"
        />
        <polygon
          points="130.81 317.05 126.37 317.05 126.37 318.13 129.85 319.5 130.81 317.05"
          fill="#ececec"
        />
        <polygon
          points="122.07 311.81 119.25 310.69 118.43 312.75 122.07 312.75 122.07 311.81"
          fill="#ececec"
        />
        <polygon
          points="130.96 308.25 129.67 308.25 129.11 309.65 130.96 310.38 130.96 308.25"
          fill="#ececec"
        />
        <polygon
          points="126.37 303.95 126.37 303.95 126.39 303.95 126.37 303.95"
          fill="#ececec"
        />
        <polygon
          points="122.07 303.53 121.91 303.95 122.07 303.95 122.07 303.53"
          fill="#ececec"
        />
        <path
          d="M113.88,300.54s0,.03,0,.05c0,.08,0,.17,.01,.26,0-.1,0-.19-.01-.26,0-.01,0-.03,0-.05Z"
          fill="#ececec"
        />
        <polygon
          points="117.57 300.47 117.57 302.43 118.24 300.74 117.57 300.47"
          fill="#ececec"
        />
        <path
          d="M135.26,300.08c.02-.24,.05-.47,.07-.71h0c-.02,.23-.05,.47-.07,.7h0Z"
          fill="#ececec"
        />
        <path
          d="M135.26,300.07c.02-.23,.05-.47,.07-.7h-.07v.7Z"
          fill="#ececec"
        />
        <polygon
          points="126.37 295.07 127.84 295.07 126.37 294.49 126.37 295.07"
          fill="#ececec"
        />
        <polygon
          points="127.02 299.37 128.16 299.82 128.34 299.37 127.02 299.37"
          fill="#ececec"
        />
        <polygon
          points="121.47 292.55 117.57 291.01 117.57 295.07 120.48 295.07 121.47 292.55"
          fill="#ececec"
        />
        <path
          d="M135.81,293.28c.01-.23,.02-.45,.04-.68v.02c-.02,.22-.03,.44-.04,.66h0Z"
          fill="#ececec"
        />
        <path
          d="M135.83,292.65l-.22,.56,.19,.07c.01-.21,.02-.42,.03-.63Z"
          fill="#ececec"
        />
        <path
          d="M135.79,293.28h.01c.01-.22,.02-.43,.03-.65v.02c-.02,.21-.03,.42-.04,.63Z"
          fill="#ececec"
        />
        <polygon
          points="129.01 285.97 128.89 286.27 129.76 286.27 129.01 285.97"
          fill="#ececec"
        />
        <polygon
          points="130.96 291.37 130.96 290.57 128.94 290.57 130.96 291.37"
          fill="#ececec"
        />
        <polygon
          points="122.07 283.23 120.74 282.71 119.33 286.27 122.07 286.27 122.07 283.23"
          fill="#ececec"
        />
        <path
          d="M115.84,280.77c-.03,.16-.05,.33-.07,.49,.03-.16,.05-.33,.08-.49h0Z"
          fill="#ececec"
        />
        <polygon
          points="130.96 281.91 130.96 281.68 130.7 281.68 130.66 281.79 130.96 281.91"
          fill="#ececec"
        />
        <polygon
          points="135.32 281.68 135.26 281.68 135.26 281.85 135.32 281.68"
          fill="#ececec"
        />
        <polygon
          points="127.97 276.1 126.37 275.47 126.37 277.38 127.47 277.38 127.97 276.1"
          fill="#ececec"
        />
        <polygon
          points="119.78 272.88 117.57 272.88 117.57 276.62 118.21 276.87 119.78 272.88"
          fill="#ececec"
        />
        <path
          d="M116.74,275.24c-.06,.33-.11,.66-.17,.99h0c.06-.33,.11-.66,.17-.99Z"
          fill="#ececec"
        />
        <path
          d="M117.35,271.91c-.02,.08-.03,.17-.05,.25,.02-.08,.03-.17,.05-.25h0Z"
          fill="#ececec"
        />
        <polygon
          points="126.37 268.45 126.37 268.58 130.94 268.58 130.96 268.54 130.96 267.73 127.24 266.26 126.37 268.45"
          fill="#ececec"
        />
        <path
          d="M121.48,268.58l.59-1.49v-2.54h-3.11c-.22,.86-.45,1.8-.67,2.8l3.13,1.24h.06Z"
          fill="#ececec"
        />
        <path
          d="M119.34,263.14h0s-.02,.07-.03,.1c.01-.04,.02-.07,.03-.1Z"
          fill="#ececec"
        />
        <path
          d="M122.07,258.73c-.16,.02-.31,.04-.47,.07,.16-.03,.31-.04,.47-.06h0Z"
          fill="#ececec"
        />
        <path
          d="M121.37,258.85s-.06,.01-.09,.02c0,0,0,0,0,0,.03,0,.06-.02,.1-.03Z"
          fill="#ececec"
        />
        <path
          d="M122.07,258.74h0c-.16,.02-.31,.03-.47,.06-.02,0-.04,0-.06,.01,.18-.03,.35-.06,.53-.08Z"
          fill="#ececec"
        />
        <path
          d="M121.23,258.91s-.07,.07-.11,.1l.95,.38v-.64c-.18,.02-.35,.04-.53,.08-.06,.01-.12,.03-.17,.04-.03,0-.06,.02-.1,.03-.01,0-.03,.02-.05,.03Z"
          fill="#ececec"
        />
        <path
          d="M201.28,272.88h-.17c.06,.37,.11,.75,.17,1.13v-1.13Z"
          fill="#5e95a3"
        />
        <path
          d="M113.31,317.05h-.04v.74h0c.01-.25,.02-.49,.04-.74Z"
          fill="#828282"
        />
        <path
          d="M204.17,318.19h0c-.02-.38-.04-.77-.06-1.14h0c.02,.38,.04,.76,.06,1.14Z"
          fill="#828282"
        />
        <path
          d="M202.74,286.27s0-.02,0-.03c0,0,0,.02,0,.03h0Z"
          fill="#828282"
        />
        <path
          d="M203.44,295.07s0-.02,0-.02c0,0,0,.02,0,.02h0Z"
          fill="#828282"
        />
        <path d="M203.13,290.6s0-.02,0-.03h0s0,.02,0,.03Z" fill="#828282" />
        <path
          d="M203.74,308.91h0c0-.21-.02-.44-.03-.65h0c0,.21,.02,.43,.03,.65Z"
          fill="#828282"
        />
        <path
          d="M203.91,312.75h0c-.05-1.07-.09-2.06-.13-3.03h0c.04,.96,.09,1.97,.14,3.03Z"
          fill="#828282"
        />
        <path
          d="M204.27,320.03h0c-.03-.62-.06-1.23-.09-1.83h0c.03,.6,.06,1.22,.09,1.83Z"
          fill="#828282"
        />
        <path
          d="M203.77,309.72h0c-.01-.28-.02-.55-.03-.82h0c.01,.27,.02,.54,.03,.82Z"
          fill="#828282"
        />
        <path
          d="M203.55,300.61s0-.02,0-.02c.01-.17,.02-.37,.02-.59,0,.21-.01,.41-.02,.59,0,0,0,.02,0,.02Z"
          fill="#828282"
        />
        <path
          d="M203.56,303.95c-.02-.57-.03-1.08-.03-1.53,0,.45,.02,.96,.03,1.53h0Z"
          fill="#828282"
        />
        <path d="M202.26,281.7s0-.01,0-.02h0s0,.01,0,.02Z" fill="#828282" />
        <path d="M113.27,317.79v.05s0-.04,0-.05h0Z" fill="#828282" />
        <path
          d="M113.88,303.63c0,.07,0,.14,0,.22,0-.07,0-.15,0-.22h0Z"
          fill="#828282"
        />
        <path
          d="M113.72,308.27c0,.07,0,.16,0,.23h0c0-.08,0-.15,0-.23Z"
          fill="#828282"
        />
        <path d="M113.86,300s0,.08,0,.12h0s0-.08,0-.12Z" fill="#828282" />
        <path
          d="M115.36,284.09h0s0,.03,0,.04c0-.01,0-.03,0-.04Z"
          fill="#828282"
        />
        <path
          d="M113.71,308.5c-.02,.59-.05,1.21-.08,1.85,.03-.64,.05-1.26,.08-1.85h0Z"
          fill="#828282"
        />
        <path
          d="M113.86,300.13c0,.15,0,.29,.02,.41,0-.13-.01-.27-.01-.42h0Z"
          fill="#828282"
        />
        <path
          d="M113.89,302.87c0,.24-.01,.5-.02,.77h0c0-.27,.01-.53,.02-.77Z"
          fill="#828282"
        />
        <path
          d="M115.39,283.87c-.01,.07-.02,.15-.03,.22h0c.01-.07,.02-.15,.03-.22Z"
          fill="#828282"
        />
        <path
          d="M135.07,301.97c-.02,.18-.03,.37-.05,.55h0s0,0,0,0c-.02,.18-.04,.36-.07,.54-.03,.3-.06,.6-.1,.89h.4v-3.74c-.05,.5-.11,1.01-.16,1.51,0,.08-.02,.16-.02,.25Z"
          fill="#828282"
        />
        <rect x="178.97" y="303.95" width="4.5" height="4.3" fill="#828282" />
        <rect x="170.08" y="303.95" width="4.59" height="4.3" fill="#828282" />
        <path
          d="M183.46,302.64v1.32h.15c-.05-.44-.1-.88-.15-1.32Z"
          fill="#828282"
        />
        <rect x="144.06" y="303.95" width="4.59" height="4.3" fill="#828282" />
        <rect x="135.26" y="303.95" width="4.5" height="4.3" fill="#828282" />
        <rect x="164.23" y="303.95" width="1.54" height="4.3" fill="#828282" />
        <rect x="152.95" y="303.95" width="1.43" height="4.3" fill="#828282" />
        <rect x="148.65" y="281.68" width="4.3" height="4.59" fill="#828282" />
        <rect x="165.78" y="290.57" width="4.3" height="4.5" fill="#828282" />
        <rect x="174.67" y="290.57" width="4.3" height="4.5" fill="#828282" />
        <path
          d="M122.45,258.69s0,0,0,0c0,0,0,0,0,0,.33-.02,.65-.02,.96-.01,.1,0,.2,0,.3,.01,.05,0,.1,0,.16,0,.02,0,.05,0,.08,0,.14,0,.27,.02,.4,.04,.11,.01,.22,.03,.33,.04,.2,.03,.39,.06,.58,.1,0,0,.02,0,.02,0,0,0,.01,0,.02,0h0c.09,.02,.18,.03,.27,.06,.24,.06,.48,.12,.71,.2,.03,0,.06,.01,.08,.02v-2.8c-.4,.17-.79,.33-1.17,.5,0,0,0,0-.01,0-.38,.17-.74,.33-1.1,.5-.02,0-.04,.02-.06,.03-.34,.16-.67,.32-.99,.49-.01,0-.03,.01-.04,.02-.3,.16-.59,.31-.87,.47-.02,.01-.04,.02-.05,.03v.32c.13-.02,.25-.04,.38-.05Z"
          fill="#828282"
        />
        <path
          d="M126.37,256.36c-.4,.17-.79,.33-1.17,.5,.38-.17,.77-.34,1.17-.5h0Z"
          fill="#828282"
        />
        <path
          d="M122.07,258.4h0s.04-.02,.05-.03c-.02,0-.04,.02-.05,.03Z"
          fill="#828282"
        />
        <rect x="139.76" y="290.57" width="4.3" height="4.5" fill="#828282" />
        <path
          d="M187.94,261.96s.04-.05,.06-.07c0-.01,.02-.02,.03-.03,.1-.11,.19-.21,.29-.31,.06-.06,.12-.12,.18-.18,.18-.18,.37-.35,.57-.51,0,0,0,0,.01-.01h0s.1-.08,.15-.12c.09-.07,.18-.15,.27-.21,.12-.09,.24-.17,.36-.25,0,0,.01,0,.02-.01h-2.12v1.92c.06-.07,.12-.14,.18-.2Z"
          fill="#828282"
        />
        <rect x="144.06" y="295.07" width="4.59" height="4.3" fill="#828282" />
        <rect x="152.95" y="295.07" width="1.43" height="4.3" fill="#828282" />
        <path
          d="M180.46,279.44c-.21-.7-.33-1.38-.41-2.06h-1.08v4.3h2.2c-.27-.83-.51-1.58-.71-2.24Z"
          fill="#828282"
        />
        <path
          d="M135.24,253.06c-.16,.06-.33,.12-.49,.17-1.19,.42-2.45,.86-3.74,1.33,0,0-.01,0-.02,0l4.25-1.51Z"
          fill="#828282"
        />
        <path
          d="M135.25,253.06c-.16,.06-.34,.12-.5,.17,.16-.06,.34-.12,.49-.17h0Z"
          fill="#828282"
        />
        <path
          d="M131.01,254.56s-.03,.01-.05,.02h.03s.01-.01,.02-.02Z"
          fill="#828282"
        />
        <path
          d="M135.47,297.91c0,.06-.01,.11-.02,.17h0s0,.05,0,.07c-.04,.41-.07,.81-.11,1.22h4.42v-4.3h-4.06c-.06,.91-.14,1.82-.22,2.74,0,.04,0,.07,0,.11Z"
          fill="#828282"
        />
        <rect x="170.08" y="286.27" width="4.59" height="4.3" fill="#828282" />
        <path
          d="M182.52,290.57c-.02-.61-.05-1.22-.06-1.83,0,0,0,0,0,0-.02-.83-.03-1.65-.04-2.47h-3.46v4.3h3.56Z"
          fill="#828282"
        />
        <path
          d="M136.01,288.74c0,.31-.03,.63-.04,.94,0,.3,0,.59-.02,.89h3.81v-4.3h-3.71c0,.81-.04,1.64-.06,2.46h.02Z"
          fill="#828282"
        />
        <path
          d="M139.76,267.76v.82h.32c-.1-.27-.21-.54-.32-.82Z"
          fill="#828282"
        />
        <rect x="183.46" y="255.66" width="4.3" height="4.59" fill="#828282" />
        <rect x="144.06" y="286.27" width="4.59" height="4.3" fill="#828282" />
        <rect x="152.95" y="286.27" width="1.43" height="4.3" fill="#828282" />
        <path
          d="M144.04,277.38c-.76-1.42-1.47-2.87-2.19-4.5h-2.09v4.5h4.28Z"
          fill="#828282"
        />
        <rect x="164.23" y="286.27" width="1.54" height="4.3" fill="#828282" />
        <rect x="164.23" y="295.07" width="1.54" height="4.3" fill="#828282" />
        <rect x="165.78" y="299.37" width="4.3" height="4.59" fill="#828282" />
        <rect x="148.65" y="299.37" width="4.3" height="4.59" fill="#828282" />
        <path
          d="M178.97,272.88h-1.35c-.72,1.63-1.42,3.08-2.19,4.5h3.54v-4.5Z"
          fill="#828282"
        />
        <path
          d="M174.67,281.68v-2.94c-.33,.57-.67,1.15-1.03,1.74-.73-.97-1.54-1.99-2.45-3.1h-1.11v4.3h4.59Z"
          fill="#828282"
        />
        <path
          d="M144.06,277.41v4.27h4.59v-4.3h-.37c-.91,1.1-1.72,2.12-2.45,3.1-.64-1.04-1.22-2.04-1.77-3.06Z"
          fill="#828282"
        />
        <rect x="152.95" y="277.38" width="1.43" height="4.3" fill="#828282" />
        <rect x="139.76" y="299.37" width="4.3" height="4.59" fill="#828282" />
        <rect x="164.23" y="277.38" width="1.54" height="4.3" fill="#828282" />
        <rect x="174.67" y="299.37" width="4.3" height="4.59" fill="#828282" />
        <rect x="170.08" y="295.07" width="4.59" height="4.3" fill="#828282" />
        <rect x="165.78" y="281.68" width="4.3" height="4.59" fill="#828282" />
        <rect x="174.67" y="281.68" width="4.3" height="4.59" fill="#828282" />
        <path
          d="M183.13,299.37c-.04-.4-.07-.81-.11-1.21,0-.03,0-.05,0-.08h0c0-.05,0-.1-.01-.16,0-.04,0-.08-.01-.13-.08-.91-.15-1.82-.21-2.73h-3.8v4.3h4.16Z"
          fill="#828282"
        />
        <path
          d="M128.96,260.51c.09,.07,.17,.14,.26,.21,.05,.04,.1,.08,.15,.12h0s0,0,.01,.01c.2,.16,.39,.34,.58,.52,.06,.06,.12,.11,.18,.17,.1,.1,.2,.21,.3,.31,0,.01,.02,.02,.03,.03,.02,.02,.04,.05,.06,.07,.06,.07,.12,.13,.18,.2,.09,.1,.17,.2,.26,.3v-2.22h-2.38s0,0,.01,.01c.12,.08,.25,.16,.37,.25Z"
          fill="#828282"
        />
        <path
          d="M137.2,281.68h2.56v-4.3h-1.44c-.08,.68-.2,1.37-.41,2.06-.2,.66-.44,1.41-.71,2.24Z"
          fill="#828282"
        />
        <path d="M135.26,255.66h-4.3v4.59h4.3v-4.59Z" fill="#828282" />
        <rect x="139.76" y="281.68" width="4.3" height="4.59" fill="#828282" />
        <rect x="148.65" y="290.57" width="4.3" height="4.5" fill="#828282" />
        <rect x="152.95" y="312.75" width="1.43" height="4.3" fill="#828282" />
        <path
          d="M165.78,272.88v-1.58c-.52-.51-1.04-.98-1.54-1.42v3h1.54Z"
          fill="#828282"
        />
        <path
          d="M135.26,312.75v-4.5h-.95c-.21,1.51-.42,3.01-.65,4.5h1.6Z"
          fill="#828282"
        />
        <rect x="165.78" y="308.25" width="4.3" height="4.5" fill="#828282" />
        <path
          d="M192.88,258.94c.09-.02,.18-.04,.27-.05h0s.01,0,.02,0c0,0,0,0,0,0,0,0,.01,0,.02,0,.19-.04,.38-.07,.58-.1,.11-.02,.22-.03,.33-.04,.13-.01,.27-.03,.4-.04,.02,0,.05,0,.08,0,.05,0,.1,0,.16,0,.1,0,.2-.01,.3-.01,.31,0,.64,0,.96,.01,0,0,0,0,0,0,0,0,0,0,0,0,.25,.01,.51,.05,.76,.1v-.53s-.03-.01-.04-.02c-.24-.11-.5-.23-.78-.35-.06-.03-.12-.05-.17-.08-.3-.13-.6-.26-.93-.39,0,0-.01,0-.02,0-.35-.14-.72-.29-1.1-.44-.02,0-.04-.02-.07-.03-.38-.15-.78-.3-1.18-.45,0,0,0,0,0,0v2.55c.13-.04,.27-.08,.4-.11Z"
          fill="#828282"
        />
        <path
          d="M196.78,258.25s-.03-.01-.04-.02c.02,0,.03,.01,.04,.02h0Z"
          fill="#828282"
        />
        <rect x="174.67" y="308.25" width="4.3" height="4.5" fill="#828282" />
        <path
          d="M187.76,254.81c-.76-.26-1.5-.51-2.22-.75-.01,0-.02,0-.03-.01-.71-.24-1.39-.46-2.02-.67,0,0,0,0-.01,0l4.29,1.44Z"
          fill="#828282"
        />
        <path
          d="M183.48,253.37c.63,.21,1.31,.43,2.02,.67-.71-.24-1.39-.46-2.02-.67Z"
          fill="#828282"
        />
        <path d="M183.48,253.37s-.01,0-.02,0h0s0,0,.01,0Z" fill="#828282" />
        <path
          d="M183.46,317.05v2.97h2.57c-.18-.98-.35-1.97-.52-2.97h-2.05Z"
          fill="#828282"
        />
        <rect x="148.65" y="308.25" width="4.3" height="4.5" fill="#828282" />
        <path
          d="M185.59,265.65c.14-.3,.29-.58,.44-.86h0c.03-.07,.07-.13,.1-.19,0-.01,.01-.03,.02-.04h-2.68v3.06c.64-.72,1.36-1.37,2.13-1.97Z"
          fill="#828282"
        />
        <path
          d="M165.78,277.38h4.3v-1.32c-.81-.95-1.7-1.97-2.7-3.09-.03-.03-.05-.06-.08-.08h-1.52v4.5Z"
          fill="#828282"
        />
        <path
          d="M132.45,264.77h0c.17,.33,.34,.65,.49,.99,.85,.68,1.63,1.44,2.33,2.27v-3.48h-2.94s.01,.03,.02,.04c.03,.06,.07,.12,.1,.18Z"
          fill="#828282"
        />
        <path
          d="M139.76,272.88v-4.3h-4.05c.99,1.3,1.76,2.75,2.21,4.3h1.83Z"
          fill="#828282"
        />
        <rect x="139.76" y="308.25" width="4.3" height="4.5" fill="#828282" />
        <rect x="164.23" y="312.75" width="1.54" height="4.3" fill="#828282" />
        <path
          d="M132.96,317.05c-.17,1-.35,2-.52,2.97h2.83v-2.97h-2.3Z"
          fill="#828282"
        />
        <rect x="139.76" y="317.05" width="4.3" height="2.97" fill="#828282" />
        <rect x="135.26" y="312.75" width="4.5" height="4.3" fill="#828282" />
        <path
          d="M178.97,272.88h1.48c.46-1.55,1.22-3,2.21-4.3h-3.27c-.14,.37-.28,.72-.42,1.07v3.23Z"
          fill="#828282"
        />
        <rect x="174.67" y="317.05" width="4.3" height="2.97" fill="#828282" />
        <rect x="144.06" y="312.75" width="4.59" height="4.3" fill="#828282" />
        <rect x="148.65" y="317.05" width="4.3" height="2.97" fill="#828282" />
        <rect x="178.97" y="312.75" width="4.5" height="4.3" fill="#828282" />
        <path
          d="M137.27,260.25h-2.01v4.3h3.29c-.65-1.79-.95-2.82-1.29-4.3Z"
          fill="#828282"
        />
        <path
          d="M183.46,264.55v-4.3h-1.26c-.33,1.48-.64,2.51-1.29,4.3h2.55Z"
          fill="#828282"
        />
        <path
          d="M184.81,312.75c-.23-1.49-.45-2.99-.65-4.5h-.7v4.5h1.35Z"
          fill="#828282"
        />
        <path
          d="M154.38,272.88v-2.23c-.47,.44-.95,.9-1.43,1.4v.84h1.43Z"
          fill="#828282"
        />
        <rect x="170.08" y="312.75" width="4.59" height="4.3" fill="#828282" />
        <path
          d="M148.65,276.94v.44h4.3v-4.5h-.78s-.05,.06-.08,.08c-1.32,1.48-2.45,2.78-3.44,3.97Z"
          fill="#828282"
        />
        <rect x="165.78" y="317.05" width="4.3" height="2.97" fill="#828282" />
        <path
          d="M135.26,268.58v-.55c-.69-.83-1.47-1.59-2.33-2.27,.4,.87,.75,1.82,1.07,2.82h1.26Z"
          fill="#828282"
        />
        <path
          d="M135.71,277.82c.04,.46,.07,.92,.11,1.39h0c.01,.17,.02,.34,.03,.51,0,0,0,.01,0,.02,0,.03,0,.06,0,.09,0,0,0,0,0,.01,0,.13,.02,.27,.03,.4h0c.03,.49,.06,.96,.08,1.45h1.23c.27-.83,.51-1.58,.71-2.24,.21-.7,.33-1.38,.41-2.06h-2.64c.01,.13,.02,.27,.04,.41,0,0,0,.02,0,.03Z"
          fill="#828282"
        />
        <path
          d="M135.24,274.02s0,.01,0,.02c0,.02,0,.05,.01,.07v-1.23h-.21c.07,.37,.13,.76,.19,1.14Z"
          fill="#828282"
        />
        <path
          d="M135.26,272.88h2.67c-.46-1.55-1.22-3-2.21-4.3h-.45v4.3Z"
          fill="#828282"
        />
        <path
          d="M183.42,272.88c.02-.08,.03-.16,.05-.24v-4.06h-.81c-.99,1.3-1.76,2.75-2.21,4.3h2.97Z"
          fill="#828282"
        />
        <path
          d="M184.46,268.58c.33-1.05,.7-2.03,1.12-2.94-.76,.6-1.48,1.25-2.13,1.97v.97h1Z"
          fill="#828282"
        />
        <path
          d="M181.17,281.68h1.33c.02-.49,.05-.96,.08-1.44h0c0-.15,.02-.28,.03-.42,0,0,0,0,0,0,0-.04,0-.07,0-.11,0,0,0,0,0,0,.01-.17,.02-.34,.03-.5h0c.03-.46,.07-.93,.11-1.38,0-.02,0-.03,0-.05,.01-.13,.02-.27,.04-.4h-2.74c.08,.68,.2,1.37,.41,2.06,.2,.66,.44,1.41,.71,2.24Z"
          fill="#828282"
        />
        <path
          d="M135.26,287.34v1.1l.73,.29c.02-.82,.05-1.65,.06-2.46h-.41c-.12,.35-.25,.71-.38,1.07Z"
          fill="#828282"
        />
        <path
          d="M135.94,290.57c.01-.3,.01-.59,.02-.89-.01,.3-.03,.59-.04,.89h.02Z"
          fill="#828282"
        />
        <path
          d="M128.45,263.18l.44-1.1-2.52-.99v1.44c.7,.17,1.4,.39,2.08,.66Z"
          fill="#828282"
        />
        <path
          d="M134.87,295.07l.38-.97v-1.03l-1.8-.71c-.32,.88-.65,1.78-.99,2.71h2.4Z"
          fill="#828282"
        />
        <path
          d="M130.43,261.86c-.1-.11-.19-.21-.3-.31,.09,.09,.17,.18,.25,.27,.01,.01,.03,.03,.04,.04Z"
          fill="#828282"
        />
        <path
          d="M135.1,301.72c.05-.5,.11-1.01,.16-1.51v-.14c-.05,.55-.11,1.1-.16,1.64Z"
          fill="#828282"
        />
        <path
          d="M134.85,303.95c.03-.3,.06-.6,.1-.89-.04,.3-.07,.59-.11,.89h.01Z"
          fill="#828282"
        />
        <path
          d="M130.96,304.98v-1.03h-1.78c-.12,.32-.24,.64-.36,.96l1.87,.74,.27-.67Z"
          fill="#828282"
        />
        <path
          d="M126.37,259.16s-.06-.01-.08-.02c.03,0,.06,.02,.08,.02h0Z"
          fill="#828282"
        />
        <path
          d="M125.85,317.92l-1.69-.67c-.35,.92-.7,1.85-1.05,2.77h1.91l.83-2.11Z"
          fill="#828282"
        />
        <path
          d="M130.53,261.96s-.04-.05-.06-.07c0,0,.01,.02,.02,.03,.01,.02,.03,.03,.04,.05Z"
          fill="#828282"
        />
        <path
          d="M125.87,312.75h.5v-1.33c-.17,.44-.34,.89-.5,1.33Z"
          fill="#828282"
        />
        <path
          d="M130.96,262.47c-.08-.1-.17-.2-.26-.3,.09,.1,.17,.21,.26,.32h0Z"
          fill="#828282"
        />
        <polygon
          points="132.35 301.47 130.96 300.92 130.96 303.95 131.36 303.95 132.35 301.47"
          fill="#828282"
        />
        <path
          d="M133.08,311.22h.04s-.29,.75-.29,.75l-.31,.78h1.14c.23-1.49,.45-2.99,.65-4.5h-.23c-.33,.96-.66,1.94-1.01,2.96Z"
          fill="#828282"
        />
        <polygon
          points="127.89 312.75 126.37 312.75 126.37 313.5 127.43 313.92 127.89 312.75"
          fill="#828282"
        />
        <path
          d="M135.34,299.37c.04-.41,.07-.81,.11-1.22-.04,.41-.08,.81-.12,1.22h.01Z"
          fill="#828282"
        />
        <path
          d="M135.46,298.08c0-.06,.01-.11,.02-.17,0,.05-.01,.11-.02,.17h0Z"
          fill="#828282"
        />
        <path
          d="M132.93,265.76c-.16-.34-.32-.66-.49-.98l-.18,.46c.23,.17,.45,.34,.68,.52Z"
          fill="#828282"
        />
        <path
          d="M132.34,264.59s-.01-.03-.02-.04h0s.02,.03,.02,.04Z"
          fill="#828282"
        />
        <path
          d="M131.11,317.05c-.05,.15-.1,.31-.15,.46v2.51h1.47c.18-.98,.35-1.97,.52-2.97h-1.84Z"
          fill="#828282"
        />
        <path
          d="M135.48,297.8c.08-.92,.15-1.83,.22-2.74h-.02c-.06,.91-.12,1.82-.2,2.74Z"
          fill="#828282"
        />
        <polygon
          points="122.46 258.69 122.45 258.69 122.45 258.69 122.45 258.69 122.46 258.69"
          fill="#828282"
        />
        <polygon
          points="115.27 308.25 114.98 309 117.57 310.03 117.57 308.25 115.27 308.25"
          fill="#828282"
        />
        <path
          d="M130.96,295.07h1.51c.34-.93,.67-1.83,.99-2.71l-2.04-.8-.47,1.18v2.33Z"
          fill="#828282"
        />
        <path
          d="M131.24,267.84l1.89,.75h.88c-.31-1-.67-1.95-1.07-2.82-.22-.18-.45-.35-.68-.52l-1.02,2.59Z"
          fill="#828282"
        />
        <path
          d="M115.86,295.07l.04-.09-1.73-.68c-.02,.25-.05,.52-.07,.76,0,0,0,.01,0,.01h1.77Z"
          fill="#828282"
        />
        <path d="M114.09,295.05s0,.01,0,.01h0s0-.01,0-.01Z" fill="#828282" />
        <path
          d="M117.57,286.27v-.19l-2.36-.93c-.03,.21-.06,.42-.09,.63-.02,.16-.04,.32-.06,.49h2.51Z"
          fill="#828282"
        />
        <path
          d="M115.13,285.78c-.02,.16-.04,.33-.07,.49h0c.02-.16,.04-.32,.06-.49Z"
          fill="#828282"
        />
        <path
          d="M128.45,263.18c-.68-.27-1.38-.49-2.08-.66v2.03h1.54l.54-1.37Z"
          fill="#828282"
        />
        <polygon
          points="126.37 265.92 126.37 264.55 123.08 264.55 123.05 264.61 126.37 265.92"
          fill="#828282"
        />
        <polygon
          points="122.07 272.88 122.07 268.84 121.47 268.6 119.79 272.87 119.81 272.88 122.07 272.88"
          fill="#828282"
        />
        <polygon
          points="122.07 316.43 121.67 316.27 121.36 317.05 122.07 317.05 122.07 316.43"
          fill="#828282"
        />
        <polygon
          points="133.51 286.27 135.26 286.27 135.26 283.61 134.66 283.37 133.51 286.27"
          fill="#828282"
        />
        <path
          d="M126.37,311.42v-2.85l-.8-.32h-.74l-1.59,4.01,1.22,.48h1.4c.17-.44,.34-.89,.5-1.33Z"
          fill="#828282"
        />
        <polygon
          points="127.43 289.97 126.37 289.55 126.37 290.57 127.19 290.57 127.43 289.97"
          fill="#828282"
        />
        <polygon
          points="130.96 295.07 130.04 295.07 129.74 295.82 130.96 296.3 130.96 295.07"
          fill="#828282"
        />
        <path
          d="M124.16,317.25l-.51-.2h-1.58v2.97h1.04c.35-.92,.7-1.85,1.05-2.77Z"
          fill="#828282"
        />
        <polygon
          points="125.74 294.24 126.37 292.64 126.37 290.57 122.26 290.57 122.07 291.04 122.07 292.79 125.74 294.24"
          fill="#828282"
        />
        <path
          d="M129.18,303.95h-2.65l-.02,.05,2.31,.91c.12-.32,.24-.64,.36-.96Z"
          fill="#828282"
        />
        <path
          d="M116.01,318.87l.72-1.82h-3.42c-.01,.25-.02,.49-.04,.74l2.74,1.08Z"
          fill="#828282"
        />
        <path
          d="M135.64,286.27h-.38v1.07c.13-.36,.25-.72,.38-1.07Z"
          fill="#828282"
        />
        <path
          d="M135.86,279.73s0-.01,0-.02c0,0,0,0,0,0,0,0,0,0,0,.01Z"
          fill="#828282"
        />
        <path
          d="M135.82,279.21c-.03-.47-.07-.93-.11-1.39,.04,.46,.07,.92,.11,1.39h0Z"
          fill="#828282"
        />
        <polygon
          points="124.62 272.88 122.07 272.88 122.07 273.77 123.97 274.53 124.62 272.88"
          fill="#828282"
        />
        <polygon
          points="122.07 297.41 119.9 296.55 118.78 299.37 122.07 299.37 122.07 297.41"
          fill="#828282"
        />
        <polygon
          points="117.57 290.57 116.45 290.57 117.48 290.97 117.57 290.73 117.57 290.57"
          fill="#828282"
        />
        <path
          d="M135.97,281.68h0c-.02-.49-.05-.96-.08-1.44h0c.03,.48,.05,.95,.07,1.44Z"
          fill="#828282"
        />
        <path
          d="M135.87,279.83s0,0,0-.01c0,0,0,0,0,0,0,0,0,0,0,0Z"
          fill="#828282"
        />
        <polygon
          points="119.16 286.71 118.05 286.27 117.57 286.27 117.57 290.57 117.64 290.57 119.16 286.71"
          fill="#828282"
        />
        <polygon
          points="129.24 272.88 130.96 272.88 130.96 272.35 129.66 271.84 129.24 272.88"
          fill="#828282"
        />
        <polygon
          points="117.57 305.1 117.57 308.25 120.21 308.25 120.93 306.42 117.57 305.1"
          fill="#828282"
        />
        <polygon
          points="123.72 299.37 122.07 299.37 122.07 302.25 122.51 302.42 123.72 299.37"
          fill="#828282"
        />
        <polygon
          points="117.57 314.65 117.57 314.92 117.67 314.69 117.57 314.65"
          fill="#828282"
        />
        <polygon
          points="130.96 277.28 131.2 277.38 132.4 277.38 133.92 273.52 132.31 272.88 130.96 272.88 130.96 277.28"
          fill="#828282"
        />
        <path
          d="M135.71,277.79c-.01-.14-.02-.27-.04-.41h0c.01,.14,.03,.27,.04,.41Z"
          fill="#828282"
        />
        <polygon
          points="130.38 281.68 126.39 280.1 126.37 280.15 126.37 281.68 130.38 281.68"
          fill="#828282"
        />
        <path
          d="M135.26,274.11s0-.05-.01-.07c0,.03,0,.05,.01,.08h0Z"
          fill="#828282"
        />
        <polygon
          points="118.14 281.68 121.15 281.68 122.07 279.34 122.07 278.4 119.49 277.38 118.01 277.38 117.57 278.48 117.57 281.46 118.14 281.68"
          fill="#828282"
        />
        <path
          d="M135.24,274.02c-.06-.39-.13-.77-.19-1.14h0c.07,.38,.14,.75,.2,1.14Z"
          fill="#828282"
        />
        <polygon
          points="126.37 284.93 126.37 281.68 125.77 281.68 124.74 284.29 126.37 284.93"
          fill="#828282"
        />
        <path
          d="M182.79,295.07h-.02c.06,.91,.14,1.82,.21,2.73-.08-.92-.14-1.82-.2-2.73Z"
          fill="#828282"
        />
        <path
          d="M187.76,303.95v1.7s1.8-.71,1.8-.71c-.12-.33-.25-.66-.37-.99h-1.43Z"
          fill="#828282"
        />
        <polygon
          points="196.02 258.69 196.01 258.69 196.01 258.69 196.01 258.69 196.02 258.69"
          fill="#828282"
        />
        <path
          d="M183.62,303.95c-.05-.44-.11-.88-.16-1.32h0c.05,.45,.1,.89,.15,1.32h.01Z"
          fill="#828282"
        />
        <path
          d="M188.32,261.54c-.1,.1-.2,.21-.29,.31,.01-.01,.03-.03,.04-.04,.08-.09,.17-.18,.25-.27Z"
          fill="#828282"
        />
        <path
          d="M187.35,317.05h-1.84c.17,1,.35,2,.52,2.97h1.73v-1.75c-.14-.41-.27-.82-.41-1.22Z"
          fill="#828282"
        />
        <path
          d="M182.46,288.74c.02,.61,.04,1.22,.06,1.83h.02c-.02-.61-.06-1.23-.08-1.83Z"
          fill="#828282"
        />
        <polygon
          points="191.04 313.92 192.48 313.35 192.48 312.75 190.58 312.75 191.04 313.92"
          fill="#828282"
        />
        <polygon
          points="186.12 301.47 187.1 303.95 187.76 303.95 187.76 300.82 186.12 301.47"
          fill="#828282"
        />
        <path
          d="M195.26,320.03c-.35-.91-.69-1.83-1.04-2.74l-1.6,.63,.83,2.11h1.81Z"
          fill="#828282"
        />
        <path
          d="M198.88,261.69c-.16-.53-.32-1.02-.48-1.44,0,0,0,0,0,0h-.09l.57,1.44Z"
          fill="#828282"
        />
        <path
          d="M183,297.92c0,.05,0,.1,.01,.16h0c0-.05-.01-.1-.02-.16Z"
          fill="#828282"
        />
        <path
          d="M183.02,298.15c.04,.4,.07,.81,.11,1.21h.01c-.04-.4-.08-.81-.12-1.21Z"
          fill="#828282"
        />
        <path
          d="M185.64,311.97l-.29-.74h.04c-.35-1.04-.68-2.02-1.01-2.98h-.22c.21,1.51,.42,3.01,.65,4.5h1.14l-.31-.78Z"
          fill="#828282"
        />
        <path
          d="M186.02,264.78c-.15,.28-.3,.56-.44,.86,.2-.15,.39-.31,.6-.46l-.16-.41Z"
          fill="#828282"
        />
        <path
          d="M186.15,264.55h0s-.01,.03-.02,.04c0-.01,.02-.03,.02-.04Z"
          fill="#828282"
        />
        <path
          d="M192.48,262.43v-1.5l-2.9,1.15,.42,1.07c.81-.31,1.64-.55,2.48-.72Z"
          fill="#828282"
        />
        <path
          d="M185.89,295.07c-.34-.91-.66-1.81-.98-2.68l-1.46,.58v1.77l.13,.33h2.3Z"
          fill="#828282"
        />
        <path
          d="M183.46,288.34h0c-.25-.72-.5-1.41-.73-2.07h-.31c0,.81,.02,1.64,.04,2.47l1-.4Z"
          fill="#828282"
        />
        <path
          d="M188,261.89s-.04,.05-.06,.07c.01-.01,.03-.03,.04-.04,0,0,.01-.02,.02-.03Z"
          fill="#828282"
        />
        <path d="M192.5,312.75s-.01-.03-.02-.05v.05h.02Z" fill="#828282" />
        <polygon
          points="183.81 283.37 183.46 283.5 183.46 286.27 184.95 286.27 183.81 283.37"
          fill="#828282"
        />
        <polygon
          points="188.08 281.68 192.48 281.68 192.48 281.13 192.07 280.1 188.08 281.68"
          fill="#828282"
        />
        <polygon
          points="199.31 286.71 200.83 290.57 201.28 290.57 201.28 286.27 200.42 286.27 199.31 286.71"
          fill="#828282"
        />
        <polygon
          points="192.48 284.78 193.73 284.29 192.7 281.68 192.48 281.68 192.48 284.78"
          fill="#828282"
        />
        <polygon
          points="195.41 264.61 195.39 264.55 192.48 264.55 192.48 265.76 195.41 264.61"
          fill="#828282"
        />
        <polygon
          points="196.78 297.26 196.78 299.37 199.68 299.37 198.57 296.55 196.78 297.26"
          fill="#828282"
        />
        <path
          d="M192.48,312.7s.01,.03,.02,.05h1.5l1.22-.48-1.59-4.01h-.74l-.41,.16v4.28Z"
          fill="#828282"
        />
        <polygon
          points="201.28 315.9 201.28 314.5 200.8 314.69 201.28 315.9"
          fill="#828282"
        />
        <path
          d="M195.26,320.03h1.52v-2.97h-1.96l-.6,.24c.35,.91,.69,1.83,1.04,2.74Z"
          fill="#828282"
        />
        <path
          d="M182.73,286.27c.23,.66,.48,1.36,.73,2.07v-2.07h-.73Z"
          fill="#828282"
        />
        <path
          d="M187.76,295.07v-1.69l-.72-1.83-2.12,.84c.32,.87,.64,1.76,.98,2.68h1.87Z"
          fill="#828282"
        />
        <path
          d="M202.45,318.87l1.72-.68c-.02-.38-.04-.76-.06-1.14h-2.38l.72,1.82Z"
          fill="#828282"
        />
        <polygon
          points="198.26 308.25 201.28 308.25 201.28 304.94 197.53 306.42 198.26 308.25"
          fill="#828282"
        />
        <polygon
          points="194.75 299.37 195.96 302.42 196.78 302.1 196.78 299.37 194.75 299.37"
          fill="#828282"
        />
        <polygon
          points="192.48 290.57 192.48 293.62 192.72 294.24 196.78 292.64 196.78 292.02 196.21 290.57 192.48 290.57"
          fill="#828282"
        />
        <path
          d="M182.57,280.24h0c-.03,.47-.06,.95-.08,1.43h0c.02-.48,.05-.96,.07-1.43Z"
          fill="#828282"
        />
        <polygon
          points="182.6 279.82 182.6 279.83 182.6 279.82 182.6 279.82"
          fill="#828282"
        />
        <path
          d="M185.34,268.58l1.89-.75-1.05-2.65c-.2,.15-.4,.3-.6,.46-.42,.91-.8,1.89-1.12,2.94h.88Z"
          fill="#828282"
        />
        <polygon
          points="196.78 317.05 197.11 317.05 196.8 316.27 196.78 316.28 196.78 317.05"
          fill="#828282"
        />
        <path
          d="M192.48,262.43c-.84,.17-1.66,.41-2.48,.72l.55,1.4h1.93v-2.12Z"
          fill="#828282"
        />
        <polygon
          points="182.6 279.71 182.6 279.72 182.6 279.71 182.6 279.71"
          fill="#828282"
        />
        <polygon
          points="186.07 277.38 187.27 277.38 187.76 277.18 187.76 272.88 186.16 272.88 184.54 273.52 186.07 277.38"
          fill="#828282"
        />
        <polygon
          points="189.22 272.88 188.81 271.84 187.76 272.25 187.76 272.88 189.22 272.88"
          fill="#828282"
        />
        <path
          d="M201.28,285.93v.34h1.47s0-.02,0-.03c-.03-.28-.06-.57-.09-.86l-1.38,.54Z"
          fill="#828282"
        />
        <polygon
          points="201.28 309.88 203.49 309 203.19 308.25 201.28 308.25 201.28 309.88"
          fill="#828282"
        />
        <polygon
          points="202.02 290.57 201.28 290.57 201.28 290.86 202.02 290.57"
          fill="#828282"
        />
        <polygon
          points="196.78 272.88 198.65 272.88 198.68 272.87 196.99 268.6 196.78 268.69 196.78 272.88"
          fill="#828282"
        />
        <path
          d="M202.57,294.97l.04,.09h.84s0-.02,0-.02c0-.13-.02-.27-.02-.4l-.85,.33Z"
          fill="#828282"
        />
        <polygon
          points="188.72 295.82 188.43 295.07 187.76 295.07 187.76 296.2 188.72 295.82"
          fill="#828282"
        />
        <path
          d="M189.56,304.95l2.4-.95-.02-.05h-2.75c.12,.33,.25,.66,.37,.99Z"
          fill="#828282"
        />
        <path
          d="M183.46,272.67v-.03c-.02,.08-.03,.16-.05,.24h0c.01-.07,.02-.14,.04-.21Z"
          fill="#828282"
        />
        <polygon
          points="191.27 290.57 192.48 290.57 192.48 289.4 191.04 289.97 191.27 290.57"
          fill="#828282"
        />
        <polygon
          points="194.49 274.53 196.78 273.62 196.78 272.88 193.85 272.88 194.49 274.53"
          fill="#828282"
        />
        <path
          d="M182.8,277.38h0c-.01,.13-.02,.27-.04,.4,.01-.14,.03-.27,.04-.4Z"
          fill="#828282"
        />
        <polygon
          points="196.78 280.31 197.32 281.68 200.33 281.68 201.28 281.31 201.28 279.45 200.46 277.38 198.97 277.38 196.78 278.25 196.78 280.31"
          fill="#828282"
        />
        <path
          d="M189.88,260.25h0s-.01,0-.02,.01c0,0,.01,0,.02-.01Z"
          fill="#828282"
        />
        <path
          d="M192.88,258.94c-.14,.03-.27,.07-.4,.11h0c.13-.03,.27-.08,.4-.11Z"
          fill="#828282"
        />
        <path
          d="M194.74,258.68c-.05,0-.1,0-.16,0,.02,0,.04,0,.06,0,.03,0,.06,0,.09,0Z"
          fill="#828282"
        />
        <path
          d="M194.51,258.7c-.14,0-.27,.02-.4,.04,.1-.01,.2-.01,.3-.02,.04,0,.07-.01,.11-.01Z"
          fill="#828282"
        />
        <path
          d="M187.94,261.96c-.06,.07-.12,.13-.18,.2h0c.06-.07,.12-.14,.18-.2Z"
          fill="#828282"
        />
        <path
          d="M184.92,292.39c-.23-.62-.44-1.23-.66-1.82h-.8v2.4l1.46-.58Z"
          fill="#828282"
        />
        <path
          d="M183.46,297.9v-2.83h-.68c.06,.91,.12,1.81,.2,2.73,0,.04,0,.08,.01,.13,0,.05,.01,.1,.02,.16l.45-.18Z"
          fill="#828282"
        />
        <polygon
          points="187.76 310.28 185.39 311.22 185.35 311.23 185.64 311.97 185.95 312.75 187.76 312.75 187.76 310.28"
          fill="#828282"
        />
        <path
          d="M187.76,317.33l-.11-.28h-.3c.14,.41,.27,.81,.41,1.22v-.94Z"
          fill="#828282"
        />
        <polygon
          points="191.04 313.92 190.58 312.75 187.76 312.75 187.76 315.21 191.04 313.92"
          fill="#828282"
        />
        <path
          d="M196.01,258.69s0,0,0,0c-.33-.02-.65-.02-.96-.01-.1,0-.2,0-.3,.01-.03,0-.06,0-.09,0,.44-.03,.9-.03,1.37,0Z"
          fill="#828282"
        />
        <path
          d="M187.76,300.82v-.7c-.09-.25-.19-.51-.28-.76h-2.19l.83,2.1,1.64-.65Z"
          fill="#828282"
        />
        <path
          d="M188.93,261c-.14,.12-.29,.24-.42,.37-.06,.06-.12,.12-.18,.18-.09,.09-.17,.18-.25,.27,.27-.3,.56-.56,.86-.82Z"
          fill="#828282"
        />
        <path
          d="M189.08,260.86c-.19,.16-.38,.33-.57,.51,.14-.13,.28-.25,.42-.37,.05-.04,.09-.1,.15-.14Z"
          fill="#828282"
        />
        <path
          d="M189.58,262.08l2.9-1.15v-.68h-2.6s-.01,0-.02,.01c-.12,.08-.24,.16-.36,.25-.09,.07-.18,.14-.27,.21-.05,.04-.09,.09-.14,.13l.48,1.22Z"
          fill="#828282"
        />
        <path
          d="M189.24,260.73s-.1,.08-.15,.12h0s.09-.08,.14-.12Z"
          fill="#828282"
        />
        <path
          d="M194.4,258.71c-.1,0-.2,.01-.3,.02-.11,.01-.22,.03-.33,.04-.2,.03-.39,.06-.58,.1,0,0-.01,0-.02,0,.4-.08,.81-.13,1.23-.17Z"
          fill="#828282"
        />
        <path d="M193.19,258.87s-.01,0-.02,0h0s.01,0,.02,0Z" fill="#828282" />
        <polygon
          points="183.46 294.74 183.46 295.07 183.59 295.07 183.46 294.74"
          fill="#828282"
        />
        <path
          d="M189.58,262.08l-1.82,.72v1.41c.72-.41,1.47-.76,2.24-1.05l-.42-1.07Z"
          fill="#828282"
        />
        <path
          d="M192.48,317.57l.14,.35,1.6-.63c-.03-.08-.06-.16-.09-.24h-1.65v.52Z"
          fill="#828282"
        />
        <polygon
          points="187.77 305.65 187.76 305.63 187.76 305.66 187.77 305.65"
          fill="#828282"
        />
        <path
          d="M188.8,308.25h2c-.42-1.11-.83-2.22-1.24-3.31l-1.79,.71,1.03,2.6Z"
          fill="#828282"
        />
        <path
          d="M192.48,260.25h1.21l-.54-1.37c-.09,.02-.18,.03-.27,.05-.14,.03-.27,.07-.4,.11v1.2Z"
          fill="#828282"
        />
        <path
          d="M199.22,262.91c-.07-.27-.14-.53-.2-.78,0,0,0,0,0,0-.04-.16-.09-.29-.13-.44l-.57-1.44h-1.54v2.01c.84,.12,1.66,.34,2.44,.66Z"
          fill="#828282"
        />
        <polygon
          points="192.27 317.05 192.48 317.05 192.48 313.35 191.04 313.92 192.27 317.05"
          fill="#828282"
        />
        <path
          d="M187.76,262.19c.07-.09,.14-.19,.22-.27-.01,.01-.03,.03-.04,.04-.06,.07-.12,.13-.18,.2v.03Z"
          fill="#828282"
        />
        <polygon
          points="192.48 320.03 193.45 320.03 192.62 317.92 192.48 317.97 192.48 320.03"
          fill="#828282"
        />
        <path
          d="M183.46,290.57v-2.23l-1,.4s0,0,0,0c.02,.6,.05,1.22,.08,1.83h.92Z"
          fill="#828282"
        />
        <polygon
          points="196.78 259.23 194.2 260.25 196.78 260.25 196.78 259.23"
          fill="#828282"
        />
        <path
          d="M186.12,301.47l-2.66,1.05v.11c.05,.44,.11,.88,.16,1.32h3.48l-.98-2.48Z"
          fill="#828282"
        />
        <path
          d="M187.16,264.55h-1.01s-.02,.03-.02,.04c-.03,.06-.06,.13-.1,.19l.16,.41c.32-.23,.64-.44,.97-.64Z"
          fill="#828282"
        />
        <path
          d="M186.02,264.77h0c.03-.05,.06-.12,.1-.18-.03,.06-.07,.12-.1,.18Z"
          fill="#828282"
        />
        <path
          d="M182.6,279.71s0,0,0,0c0,.04,0,.07,0,.11,0,0,0,0,0,0,0-.04,0-.07,0-.11Z"
          fill="#828282"
        />
        <polygon
          points="184.54 273.52 183.46 273.95 183.46 277.38 186.07 277.38 184.54 273.52"
          fill="#828282"
        />
        <path
          d="M183.46,272.75v-.08c-.01,.07-.02,.14-.04,.21h.01s.02-.09,.03-.14Z"
          fill="#828282"
        />
        <path
          d="M199.27,263.08c-.02-.06-.03-.11-.05-.17-.78-.32-1.6-.54-2.44-.66v1.81l2.49-.98Z"
          fill="#828282"
        />
        <polygon
          points="186.16 272.88 184.29 272.88 184.54 273.52 186.16 272.88"
          fill="#828282"
        />
        <polygon
          points="192.48 268.58 192.15 268.58 192.48 269.43 192.48 268.58"
          fill="#828282"
        />
        <path
          d="M201.28,285.93l1.38-.54c-.04-.42-.08-.84-.13-1.26,0-.09-.02-.19-.03-.28-.06-.6-.13-1.2-.2-1.81l-.14-.36h-.88v4.25Z"
          fill="#828282"
        />
        <polygon
          points="201.28 277.38 200.46 277.38 201.28 279.45 201.28 277.38"
          fill="#828282"
        />
        <polygon
          points="201.28 319.34 202.45 318.87 201.73 317.05 201.28 317.05 201.28 319.34"
          fill="#828282"
        />
        <path
          d="M187.76,299.37h-.28c.09,.25,.19,.51,.28,.76v-.76Z"
          fill="#828282"
        />
        <polygon
          points="197.11 317.05 201.28 317.05 201.28 315.9 200.8 314.69 196.8 316.27 197.11 317.05"
          fill="#828282"
        />
        <polygon
          points="198.68 272.88 198.68 272.87 198.65 272.88 198.68 272.88"
          fill="#828282"
        />
        <polygon
          points="187.76 269.18 187.76 272.25 188.81 271.84 187.76 269.18"
          fill="#828282"
        />
        <path
          d="M183.46,277.38h-.66c-.01,.14-.03,.27-.04,.4,0,.02,0,.03,0,.05-.04,.45-.07,.92-.11,1.38l.82-.32v-1.5Z"
          fill="#828282"
        />
        <polygon
          points="201.28 281.31 200.33 281.68 201.28 281.68 201.28 281.31"
          fill="#828282"
        />
        <polygon
          points="202.61 295.07 202.57 294.97 202.33 295.07 202.61 295.07"
          fill="#828282"
        />
        <path
          d="M201.28,300.32l2.31-.91s0-.03,0-.04h0s-2.31,0-2.31,0v.95Z"
          fill="#828282"
        />
        <polygon
          points="187.76 277.18 187.27 277.38 187.76 277.38 187.76 277.18"
          fill="#828282"
        />
        <path
          d="M187.23,267.84l.53-.21v-3.08h-.6c-.33,.2-.66,.42-.97,.64l1.05,2.65Z"
          fill="#828282"
        />
        <polygon
          points="201.49 303.95 201.28 303.41 201.28 303.95 201.49 303.95"
          fill="#828282"
        />
        <path
          d="M194.82,317.05h-.69c.03,.08,.06,.16,.09,.24l.6-.24Z"
          fill="#828282"
        />
        <path
          d="M201.28,309.88v2.88h2.63c-.05-1.06-.09-2.07-.14-3.03l-.28-.72-2.21,.87Z"
          fill="#828282"
        />
        <path
          d="M203.74,308.91c0-.22-.02-.44-.03-.65h-.52l.3,.75,.25-.1Z"
          fill="#828282"
        />
        <path
          d="M187.04,291.55l-.39-.98h-2.39c.21,.6,.43,1.2,.66,1.82l2.12-.84Z"
          fill="#828282"
        />
        <polygon
          points="187.76 281.81 183.81 283.37 184.95 286.27 187.76 286.27 187.76 281.81"
          fill="#828282"
        />
        <polygon
          points="196.78 283.08 196.78 281.68 192.7 281.68 193.73 284.29 196.78 283.08"
          fill="#828282"
        />
        <polygon
          points="198.97 277.38 196.78 277.38 196.78 278.25 198.97 277.38"
          fill="#828282"
        />
        <polygon
          points="195.62 277.38 196.78 277.38 196.78 273.62 194.49 274.53 195.62 277.38"
          fill="#828282"
        />
        <polygon
          points="196.78 308.25 198.26 308.25 197.53 306.42 196.78 306.72 196.78 308.25"
          fill="#828282"
        />
        <polygon
          points="192.48 275.32 194.49 274.53 193.85 272.88 192.48 272.88 192.48 275.32"
          fill="#828282"
        />
        <polygon
          points="192.48 270.39 188.81 271.84 189.22 272.88 192.48 272.88 192.48 270.39"
          fill="#828282"
        />
        <polygon
          points="192.48 303.79 195.96 302.42 194.75 299.37 192.48 299.37 192.48 303.79"
          fill="#828282"
        />
        <polygon
          points="196.78 292.02 196.78 290.57 196.21 290.57 196.78 292.02"
          fill="#828282"
        />
        <polygon
          points="193.05 295.07 196.78 295.07 196.78 292.64 192.72 294.24 193.05 295.07"
          fill="#828282"
        />
        <polygon
          points="192.89 308.25 192.48 308.25 192.48 308.42 192.89 308.25"
          fill="#828282"
        />
        <polygon
          points="187.76 299.37 190.13 299.37 188.72 295.82 187.76 296.2 187.76 299.37"
          fill="#828282"
        />
        <path
          d="M201.73,277.38c-.03-.21-.05-.43-.08-.64-.02-.13-.04-.26-.05-.4l-.32,.13v.91h.45Z"
          fill="#828282"
        />
        <path
          d="M201.74,277.38c-.03-.22-.06-.43-.09-.64,.03,.21,.05,.43,.08,.64h0Z"
          fill="#828282"
        />
        <polygon
          points="200.8 314.69 201.28 314.5 201.28 312.75 200.04 312.75 200.8 314.69"
          fill="#828282"
        />
        <polygon
          points="200.42 286.27 199.13 286.27 199.31 286.71 200.42 286.27"
          fill="#828282"
        />
        <polygon
          points="192.48 281.13 192.48 279.94 192.07 280.1 192.48 281.13"
          fill="#828282"
        />
        <polygon
          points="187.76 286.27 187.76 286.64 188.71 286.27 187.76 286.27"
          fill="#828282"
        />
        <path
          d="M202.91,320.03h1.36c-.03-.62-.06-1.23-.09-1.83l-1.72,.68,.46,1.15Z"
          fill="#828282"
        />
        <path
          d="M196.99,268.6l1.69,4.27,2.29-.9c-.06-.4-.13-.79-.19-1.18-.04-.24-.08-.49-.12-.73-.05-.32-.11-.63-.16-.94-.03-.18-.06-.35-.1-.53h-3.36l-.05,.02Z"
          fill="#828282"
        />
        <path
          d="M200.41,268.58h0c.03,.18,.06,.35,.1,.53-.03-.18-.06-.36-.09-.53Z"
          fill="#828282"
        />
        <polygon
          points="196.78 268.69 196.99 268.6 196.98 268.58 196.78 268.58 196.78 268.69"
          fill="#828282"
        />
        <polygon
          points="195.56 264.55 195.39 264.55 195.41 264.61 195.56 264.55"
          fill="#828282"
        />
        <polygon
          points="194.51 286.27 193.73 284.29 192.48 284.78 192.48 286.27 194.51 286.27"
          fill="#828282"
        />
        <polygon
          points="192.48 265.76 192.48 268.58 196.78 268.58 196.78 268.07 195.41 264.61 192.48 265.76"
          fill="#828282"
        />
        <path
          d="M190.55,264.55l-.55-1.4c-.77,.29-1.51,.65-2.24,1.05v.35h2.79Z"
          fill="#828282"
        />
        <polygon
          points="188.08 281.68 192.07 280.1 191 277.38 187.76 277.38 187.76 281.67 187.76 281.68 188.08 281.68"
          fill="#828282"
        />
        <polygon
          points="199.68 299.37 201.28 299.37 201.28 295.48 198.57 296.55 199.68 299.37"
          fill="#828282"
        />
        <polygon
          points="196.78 297.26 198.57 296.55 197.98 295.07 196.78 295.07 196.78 297.26"
          fill="#828282"
        />
        <polygon
          points="196.78 290.57 200.83 290.57 199.31 286.71 196.78 287.7 196.78 290.57"
          fill="#828282"
        />
        <path
          d="M202.02,290.57l-.74,.29v.84l1.29,3.27,.85-.33c-.07-1.24-.17-2.59-.29-4.04,0-.01,0-.02,0-.03h-1.11Z"
          fill="#828282"
        />
        <polygon
          points="183.46 282.49 183.46 283.5 183.81 283.37 183.46 282.49"
          fill="#828282"
        />
        <path
          d="M182.57,280.24c-.03,.47-.05,.95-.07,1.43h.64l-.57-1.43Z"
          fill="#828282"
        />
        <polygon
          points="196.56 303.95 196.78 303.95 196.78 302.1 195.96 302.42 196.56 303.95"
          fill="#828282"
        />
        <polygon
          points="197.53 306.42 201.28 304.94 201.28 303.95 196.78 303.95 196.78 304.51 197.53 306.42"
          fill="#828282"
        />
        <polygon
          points="187.76 291.27 187.04 291.55 187.76 293.38 187.76 291.27"
          fill="#828282"
        />
        <polygon
          points="197.32 281.68 196.78 280.31 196.78 281.68 197.32 281.68"
          fill="#828282"
        />
        <polygon
          points="190.63 295.07 188.43 295.07 188.72 295.82 190.63 295.07"
          fill="#828282"
        />
        <path
          d="M189.56,304.95c.41,1.09,.82,2.19,1.24,3.31h1.68v-2.93l-.52-1.33-2.4,.95Z"
          fill="#828282"
        />
        <polygon
          points="191.04 289.97 189.53 290.57 191.27 290.57 191.04 289.97"
          fill="#828282"
        />
        <polygon
          points="195.41 312.75 195.22 312.27 194 312.75 195.41 312.75"
          fill="#828282"
        />
        <polygon
          points="192.08 303.95 191.94 303.95 191.96 304 192.08 303.95"
          fill="#828282"
        />
        <polygon
          points="192.48 289.4 192.48 286.27 189.58 286.27 191.04 289.97 192.48 289.4"
          fill="#828282"
        />
        <polygon
          points="196.8 316.27 196.78 316.22 196.78 316.28 196.8 316.27"
          fill="#828282"
        />
        <polygon
          points="195.22 312.27 196.78 311.65 196.78 308.25 193.64 308.25 195.22 312.27"
          fill="#828282"
        />
        <polygon
          points="192.72 294.24 192.48 293.62 192.48 294.34 192.72 294.24"
          fill="#828282"
        />
        <polygon
          points="192.48 299.37 192.48 298.96 191.45 299.37 192.48 299.37"
          fill="#828282"
        />
        <polygon
          points="187.23 267.84 185.34 268.58 187.52 268.58 187.23 267.84"
          fill="#828282"
        />
        <polygon
          points="201.28 320.03 202.91 320.03 202.45 318.87 201.28 319.34 201.28 320.03"
          fill="#828282"
        />
        <polygon
          points="187.76 317.05 192.27 317.05 191.04 313.92 187.76 315.21 187.76 317.05"
          fill="#828282"
        />
        <polygon
          points="187.76 317.33 187.76 317.05 187.65 317.05 187.76 317.33"
          fill="#828282"
        />
        <polygon
          points="192.62 317.92 192.48 317.57 192.48 317.97 192.62 317.92"
          fill="#828282"
        />
        <polygon
          points="195.41 312.75 196.78 312.75 196.78 311.65 195.22 312.27 195.41 312.75"
          fill="#828282"
        />
        <polygon
          points="196.78 316.22 196.8 316.27 200.8 314.69 200.04 312.75 196.78 312.75 196.78 316.22"
          fill="#828282"
        />
        <path
          d="M203.77,309.72c-.01-.28-.02-.55-.03-.82l-.25,.1,.28,.72Z"
          fill="#828282"
        />
        <path
          d="M187.76,308.25h-3.38c.33,.96,.66,1.94,1.01,2.96l2.37-.94v-2.03Z"
          fill="#828282"
        />
        <polygon
          points="187.76 308.25 188.8 308.25 187.77 305.65 187.76 305.66 187.76 308.25"
          fill="#828282"
        />
        <polygon
          points="191.96 304 192.48 305.33 192.48 303.95 192.08 303.95 191.96 304"
          fill="#828282"
        />
        <polygon
          points="192.48 303.95 196.56 303.95 195.96 302.42 192.48 303.79 192.48 303.95"
          fill="#828282"
        />
        <polygon
          points="197.53 306.42 196.78 304.51 196.78 306.72 197.53 306.42"
          fill="#828282"
        />
        <path
          d="M201.28,300.32v3.09l.22,.55h2.07c-.02-.57-.03-1.08-.03-1.53,0-.05,0-.1,0-.15,0-.11,0-.2,0-.3,0-.06,0-.13,0-.19,0-.08,0-.16,0-.24,0-.07,0-.14,0-.2,0-.06,0-.12,0-.18,0-.07,0-.14,0-.2,0-.04,0-.09,0-.13,0-.09,0-.17,.01-.24,0,0,0-.02,0-.02,.01-.17,.02-.38,.02-.59,0-.18,0-.38,0-.59l-2.31,.91Z"
          fill="#828282"
        />
        <path
          d="M183.14,299.37c-.04-.43-.09-.86-.13-1.29h0s0,.05,0,.08c.04,.4,.08,.81,.12,1.21h0Z"
          fill="#828282"
        />
        <path
          d="M183.01,298.08s0,.05,0,.08c0-.03,0-.05,0-.08h0Z"
          fill="#828282"
        />
        <path
          d="M183.46,297.9l-.45,.18c.04,.43,.09,.86,.13,1.29h.32v-1.47Z"
          fill="#828282"
        />
        <polygon
          points="185.29 299.37 183.46 299.37 183.46 302.52 186.12 301.47 185.29 299.37"
          fill="#828282"
        />
        <polygon
          points="192.48 295.07 193.05 295.07 192.72 294.24 192.48 294.34 192.48 295.07"
          fill="#828282"
        />
        <polygon
          points="190.63 295.07 188.72 295.82 190.13 299.37 191.45 299.37 192.48 298.96 192.48 295.07 190.63 295.07"
          fill="#828282"
        />
        <polygon
          points="201.28 295.48 201.28 295.07 197.98 295.07 198.57 296.55 201.28 295.48"
          fill="#828282"
        />
        <polygon
          points="202.33 295.07 202.57 294.97 201.28 291.7 201.28 295.07 202.33 295.07"
          fill="#828282"
        />
        <polygon
          points="187.76 290.57 186.65 290.57 187.04 291.55 187.76 291.27 187.76 290.57"
          fill="#828282"
        />
        <polygon
          points="191.04 289.97 189.58 286.27 188.71 286.27 187.76 286.64 187.76 290.57 189.53 290.57 191.04 289.97"
          fill="#828282"
        />
        <polygon
          points="196.78 287.7 199.31 286.71 199.13 286.27 196.78 286.27 196.78 287.7"
          fill="#828282"
        />
        <polygon
          points="194.51 286.27 196.78 286.27 196.78 283.08 193.73 284.29 194.51 286.27"
          fill="#828282"
        />
        <path
          d="M202.16,281.68l.14,.36c-.01-.11-.02-.23-.04-.34,0,0,0-.01,0-.02h-.1Z"
          fill="#828282"
        />
        <path
          d="M182.64,279.21c-.01,.17-.03,.33-.04,.5,0,0,0,0,0,0,.01-.17,.03-.34,.04-.51Z"
          fill="#828282"
        />
        <path
          d="M182.64,279.21c-.01,.17-.02,.34-.03,.5,.01-.17,.03-.34,.04-.5h0Z"
          fill="#828282"
        />
        <path
          d="M182.6,279.82h0c0,.14-.01,.28-.02,.42h0c0-.14,.01-.28,.02-.42Z"
          fill="#828282"
        />
        <path
          d="M182.57,280.23h0c0-.13,.01-.27,.02-.4,0,.13-.02,.27-.03,.4Z"
          fill="#828282"
        />
        <polygon
          points="187.76 281.68 187.76 281.67 187.76 281.68 187.76 281.68"
          fill="#828282"
        />
        <polygon
          points="183.81 283.37 187.76 281.81 187.76 281.68 183.46 281.68 183.46 282.49 183.81 283.37"
          fill="#828282"
        />
        <path
          d="M182.6,279.82c0,.14-.01,.28-.02,.42l.57,1.43h.32v-2.8l-.82,.32c-.01,.17-.03,.34-.04,.51,0,.04,0,.07,0,.11Z"
          fill="#828282"
        />
        <polygon
          points="192.48 277.38 195.62 277.38 194.49 274.53 192.48 275.32 192.48 277.38"
          fill="#828282"
        />
        <polygon
          points="192.48 279.94 192.48 277.38 191 277.38 192.07 280.1 192.48 279.94"
          fill="#828282"
        />
        <path
          d="M201.6,276.34c-.1-.78-.21-1.57-.32-2.33,0,0,0,0,0,0v2.46l.32-.13Z"
          fill="#828282"
        />
        <path
          d="M198.68,272.87h0s2.43,0,2.43,0c0,0,0,0,0,0-.05-.31-.09-.61-.14-.91l-2.29,.9Z"
          fill="#828282"
        />
        <polygon
          points="183.46 273.95 184.54 273.52 184.29 272.88 183.46 272.88 183.46 273.95"
          fill="#828282"
        />
        <path d="M183.46,272.75s-.02,.09-.03,.14h.03v-.14Z" fill="#828282" />
        <polygon
          points="187.76 268.58 187.76 267.63 187.23 267.84 187.52 268.58 187.76 268.58"
          fill="#828282"
        />
        <polygon
          points="192.48 270.39 192.48 269.43 192.15 268.58 187.76 268.58 187.76 269.18 188.81 271.84 192.48 270.39"
          fill="#828282"
        />
        <polygon
          points="196.78 268.07 196.78 264.55 195.56 264.55 195.41 264.61 196.78 268.07"
          fill="#828282"
        />
        <path
          d="M196.78,264.55h2.83s-.02-.09-.03-.13c-.09-.39-.18-.77-.27-1.13,0,0,0-.02,0-.03-.02-.06-.03-.11-.05-.17l-2.49,.98v.48Z"
          fill="#828282"
        />
        <path
          d="M199.62,264.55s-.02-.09-.03-.13c0,.04,.02,.09,.03,.13h0Z"
          fill="#828282"
        />
        <polygon
          points="197.05 268.58 196.98 268.58 196.99 268.6 197.05 268.58"
          fill="#828282"
        />
        <path
          d="M189.09,260.84s0,0-.01,.01c0,0,0,0,.01-.01h0Z"
          fill="#828282"
        />
        <path
          d="M188.07,261.82s-.03,.03-.04,.04c0,.01-.02,.02-.03,.03,0,0-.01,.02-.02,.03,.03-.03,.06-.07,.09-.1Z"
          fill="#828282"
        />
        <path
          d="M189.09,260.85c-.06,.05-.11,.1-.16,.14-.3,.26-.58,.53-.86,.82-.03,.03-.06,.07-.09,.1-.08,.08-.14,.19-.22,.27v.6l1.82-.72-.48-1.22Z"
          fill="#828282"
        />
        <path
          d="M189.09,260.85h0s0,0-.01,0c-.05,.04-.1,.1-.15,.14,.05-.05,.11-.1,.16-.14Z"
          fill="#828282"
        />
        <path
          d="M196.78,258.79h0c-.25-.05-.51-.09-.76-.1,0,0,0,0,0,0,.25,.02,.5,.06,.75,.1Z"
          fill="#828282"
        />
        <path
          d="M193.15,258.88h0s.01,0,.02,0c0,0-.01,0-.02,0Z"
          fill="#828282"
        />
        <polygon
          points="196.02 258.69 196.02 258.69 196.01 258.69 196.02 258.69"
          fill="#828282"
        />
        <path
          d="M194.65,258.69s-.04,0-.06,0c-.02,0-.05,0-.08,0-.04,0-.07,.01-.11,.01,.08,0,.16-.01,.24-.02Z"
          fill="#828282"
        />
        <path
          d="M196.02,258.69c.25,.02,.5,.07,.75,.11h0c-.25-.05-.5-.09-.75-.11Z"
          fill="#828282"
        />
        <path
          d="M194.2,260.25l2.58-1.02v-.44c-.25-.04-.5-.09-.75-.11,0,0,0,0-.01,0-.47-.03-.93-.02-1.37,0-.08,0-.16,.01-.24,.02-.42,.04-.84,.09-1.23,.17,0,0,0,0,0,0,0,0-.01,0-.02,0l.54,1.37h.51Z"
          fill="#828282"
        />
        <polygon
          points="193.17 258.88 193.17 258.88 193.17 258.88 193.17 258.88"
          fill="#828282"
        />
        <polygon
          points="193.17 258.88 193.17 258.88 193.17 258.88 193.17 258.88"
          fill="#828282"
        />
        <path
          d="M193.17,258.88s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
          fill="#828282"
        />
        <path d="M128.6,260.26s0,0-.01-.01h0s.01,0,.02,.01Z" fill="#828282" />
        <path
          d="M123.88,258.69c-.05,0-.1,0-.16,0,.03,0,.06,0,.09,0,.02,0,.04,0,.06,0Z"
          fill="#828282"
        />
        <path
          d="M124.36,258.73c-.13-.01-.27-.03-.4-.04,.04,0,.07,.01,.11,.01,.1,0,.2,.01,.3,.02Z"
          fill="#828282"
        />
        <path
          d="M130.69,305.65l-1.87-.74c-.41,1.1-.83,2.22-1.25,3.34h2.1l1.03-2.6Z"
          fill="#828282"
        />
        <path
          d="M130.96,262.51v-.03c-.08-.11-.17-.21-.26-.32-.06-.07-.12-.14-.18-.2-.01-.02-.03-.03-.04-.05,.17,.18,.32,.39,.47,.59Z"
          fill="#828282"
        />
        <path
          d="M126.37,260.25v-1.09s-.06-.02-.08-.02c-.23-.07-.47-.14-.71-.2-.09-.02-.18-.04-.27-.05l-.54,1.37h1.6Z"
          fill="#828282"
        />
        <path
          d="M130.39,261.82c-.08-.09-.17-.19-.25-.27-.06-.06-.12-.11-.18-.17-.14-.13-.28-.25-.42-.37,.29,.26,.58,.52,.85,.82Z"
          fill="#828282"
        />
        <path
          d="M129.96,261.37c-.19-.18-.38-.35-.58-.52,.05,.04,.1,.1,.15,.15,.14,.12,.29,.24,.42,.37Z"
          fill="#828282"
        />
        <polygon
          points="130.96 304.98 130.69 305.65 130.96 305.76 130.96 304.98"
          fill="#828282"
        />
        <path
          d="M130.96,299.17c-.02,.06-.05,.13-.07,.19h.07v-.19Z"
          fill="#828282"
        />
        <polygon
          points="133.18 299.37 130.96 299.37 130.96 300.92 132.35 301.47 133.18 299.37"
          fill="#828282"
        />
        <polygon
          points="130.96 316.69 130.81 317.05 130.96 317.05 130.96 316.69"
          fill="#828282"
        />
        <polygon
          points="127.89 312.75 127.43 313.92 130.96 315.32 130.96 312.75 127.89 312.75"
          fill="#828282"
        />
        <path
          d="M132.44,264.79c-.03-.06-.06-.13-.1-.19,0-.01-.02-.03-.02-.04h-1.11c.36,.22,.71,.45,1.05,.7l.18-.46Z"
          fill="#828282"
        />
        <path
          d="M132.45,264.77c-.03-.06-.07-.12-.1-.18,.03,.06,.06,.13,.1,.19h0Z"
          fill="#828282"
        />
        <path
          d="M132.35,301.47l-.98,2.48h3.48c.03-.3,.07-.6,.11-.89,.02-.18,.04-.36,.06-.54l-2.66-1.05Z"
          fill="#828282"
        />
        <path
          d="M134.95,303.06c.02-.18,.05-.36,.07-.54h0c-.02,.18-.04,.36-.06,.54Z"
          fill="#828282"
        />
        <path
          d="M135.46,298.08c0-.05,.01-.11,.02-.17,0-.04,0-.07,0-.11,.08-.92,.14-1.83,.2-2.74h-.42v2.93l.2,.08Z"
          fill="#828282"
        />
        <path
          d="M135.93,290.57c.01-.3,.02-.59,.04-.89,.01-.32,.01-.63,.02-.95l-.73-.29v2.13h.67Z"
          fill="#828282"
        />
        <path
          d="M136.01,288.74h-.02c0,.31-.01,.62-.02,.94,.02-.32,.03-.63,.04-.94Z"
          fill="#828282"
        />
        <path
          d="M135.26,293.06v-2.5h-1.15c-.21,.58-.42,1.18-.65,1.79l1.8,.71Z"
          fill="#828282"
        />
        <polygon
          points="135.26 295.07 135.26 294.09 134.87 295.07 135.26 295.07"
          fill="#828282"
        />
        <polygon
          points="126.37 313.5 126.37 316.6 127.43 313.92 126.37 313.5"
          fill="#828282"
        />
        <path
          d="M122.07,262.21v-1.96h-1.73s-.03,.05-.04,.08c-.1,.22-.2,.47-.3,.74-.01,.04-.03,.08-.04,.12-.1,.27-.2,.57-.3,.88,0,.03-.02,.06-.03,.09-.06,.19-.12,.41-.18,.62,.84-.31,1.72-.49,2.62-.57Z"
          fill="#828282"
        />
        <path
          d="M120.34,260.25s-.02,.06-.03,.08c.01-.03,.03-.05,.04-.08h0Z"
          fill="#828282"
        />
        <path
          d="M125.3,258.88s-.01,0-.02,0c-.19-.04-.38-.07-.58-.1-.11-.02-.22-.03-.33-.04-.1-.01-.2-.01-.3-.02,.42,.04,.84,.09,1.23,.17Z"
          fill="#828282"
        />
        <path
          d="M125.3,258.88s-.02,0-.02,0c0,0,.01,0,.02,0,0,0,0,0,0,0Z"
          fill="#828282"
        />
        <polygon
          points="126.37 320.03 126.37 318.13 125.85 317.92 125.02 320.03 126.37 320.03"
          fill="#828282"
        />
        <path
          d="M125.85,317.92l.34-.87h-1.95c-.03,.07-.05,.13-.08,.2l1.69,.67Z"
          fill="#828282"
        />
        <polygon
          points="124.26 260.25 122.07 259.38 122.07 260.25 124.26 260.25"
          fill="#828282"
        />
        <polygon
          points="130.96 312.75 132.51 312.75 132.82 311.97 133.11 311.23 133.08 311.22 130.96 310.38 130.96 312.75"
          fill="#828282"
        />
        <path
          d="M130.96,264.4v-1.5l-2.07-.82-.44,1.1c.86,.33,1.7,.74,2.51,1.22Z"
          fill="#828282"
        />
        <path
          d="M128.89,262.08l.48-1.22c-.05-.04-.1-.09-.15-.13-.09-.07-.17-.14-.26-.21-.12-.09-.24-.17-.37-.25,0,0-.01,0-.02-.01h-2.21v.83l2.52,.99Z"
          fill="#828282"
        />
        <path
          d="M129.37,260.84c-.05-.04-.1-.08-.15-.12,.05,.04,.1,.09,.15,.13h0Z"
          fill="#828282"
        />
        <path
          d="M130.96,317.05v.46c.05-.15,.1-.31,.15-.46h-.15Z"
          fill="#828282"
        />
        <path
          d="M123.82,258.69s-.06,0-.09,0c-.1,0-.2-.01-.3-.01-.32,0-.64,0-.96,.01,0,0,0,0,0,0,.47-.03,.93-.02,1.37,0Z"
          fill="#828282"
        />
        <polygon
          points="128.89 286.27 126.37 286.27 126.37 289.55 127.43 289.97 128.89 286.27"
          fill="#828282"
        />
        <polygon
          points="122.07 292.79 122.07 295.07 125.42 295.07 125.74 294.24 122.07 292.79"
          fill="#828282"
        />
        <path
          d="M127.91,264.55h3.05v-.15c-.81-.48-1.65-.88-2.51-1.22l-.54,1.37Z"
          fill="#828282"
        />
        <polygon
          points="117.57 281.46 117.57 281.68 118.14 281.68 117.57 281.46"
          fill="#828282"
        />
        <path
          d="M127.57,308.25c.42-1.13,.84-2.24,1.25-3.34l-2.31-.91-.14,.35v3.9h1.19Z"
          fill="#828282"
        />
        <polygon
          points="117.57 277.38 117.57 278.48 118.01 277.38 117.57 277.38"
          fill="#828282"
        />
        <polygon
          points="119.79 272.87 119.78 272.88 119.81 272.88 119.79 272.87"
          fill="#828282"
        />
        <path
          d="M119.79,272.87l1.69-4.27-.05-.02h-3.4c-.04,.19-.08,.37-.12,.56-.06,.31-.13,.62-.19,.94-.1,.48-.19,.96-.29,1.45-.02,.13-.05,.25-.07,.38l2.44,.96Z"
          fill="#828282"
        />
        <path
          d="M118.02,268.58c-.04,.18-.08,.38-.11,.56,.04-.19,.08-.37,.12-.56h0Z"
          fill="#828282"
        />
        <path
          d="M117.57,270.75c-.05,.26-.1,.52-.15,.79,.09-.49,.19-.97,.29-1.45-.05,.22-.09,.44-.14,.66Z"
          fill="#828282"
        />
        <path
          d="M135.97,281.68c-.02-.48-.05-.96-.07-1.43l-.57,1.43h.64Z"
          fill="#828282"
        />
        <polygon
          points="126.37 272.88 124.62 272.88 123.97 274.53 126.37 275.47 126.37 272.88"
          fill="#828282"
        />
        <polygon
          points="117.57 302.43 116.97 303.95 117.57 303.95 117.57 302.43"
          fill="#828282"
        />
        <polygon
          points="134.66 283.37 135.26 283.61 135.26 281.85 134.66 283.37"
          fill="#828282"
        />
        <polygon
          points="130.96 268.58 133.12 268.58 131.24 267.84 130.96 268.54 130.96 268.58"
          fill="#828282"
        />
        <polygon
          points="122.07 279.34 121.15 281.68 122.07 281.68 122.07 279.34"
          fill="#828282"
        />
        <path
          d="M113.27,320.03h2.28l.46-1.15-2.74-1.08s0,.04,0,.05h0v2.18Z"
          fill="#828282"
        />
        <polygon
          points="126.37 280.1 126.37 280.15 126.39 280.1 126.37 280.1"
          fill="#828282"
        />
        <polygon
          points="129.24 272.88 129.66 271.84 126.37 270.54 126.37 272.88 129.24 272.88"
          fill="#828282"
        />
        <path
          d="M135.87,279.82s0,0,0,0c0-.03,0-.06,0-.09,0,0,0,0,0-.01,0,.04,0,.07,0,.11Z"
          fill="#828282"
        />
        <polygon
          points="122.07 268.58 121.48 268.58 121.47 268.6 122.07 268.84 122.07 268.58"
          fill="#828282"
        />
        <path
          d="M117.57,277.38v-.76l-1-.39c-.02,.14-.05,.29-.07,.43-.04,.24-.08,.48-.12,.72h1.19Z"
          fill="#828282"
        />
        <path
          d="M116.5,276.66c-.04,.24-.08,.48-.12,.72h0c.04-.24,.08-.48,.12-.72Z"
          fill="#828282"
        />
        <polygon
          points="130.96 286.74 130.96 286.27 129.76 286.27 130.96 286.74"
          fill="#828282"
        />
        <polygon
          points="126.32 268.58 126.37 268.45 126.37 265.92 123.05 264.61 122.07 267.09 122.07 268.58 126.32 268.58"
          fill="#828282"
        />
        <polygon
          points="125.77 281.68 122.07 281.68 122.07 283.23 124.74 284.29 125.77 281.68"
          fill="#828282"
        />
        <path
          d="M117.57,312.75v-2.72l-2.6-1.03-1.45,3.68s0,.04,0,.07h4.05Z"
          fill="#828282"
        />
        <polygon
          points="131.2 277.38 130.96 277.28 130.96 277.38 131.2 277.38"
          fill="#828282"
        />
        <polygon
          points="130.96 292.73 131.43 291.55 130.96 291.37 130.96 292.73"
          fill="#828282"
        />
        <path
          d="M135.82,279.21c-.03-.47-.07-.93-.11-1.39,0,0,0-.02,0-.03-.01-.14-.03-.27-.04-.41h-.41v1.6l.56,.22Z"
          fill="#828282"
        />
        <polygon
          points="122.07 315.24 121.67 316.27 122.07 316.43 122.07 315.24"
          fill="#828282"
        />
        <path
          d="M114.98,309l.3-.75h-1.56s0,.01,0,.02c0,.08,0,.15,0,.23l1.27,.5Z"
          fill="#828282"
        />
        <polygon
          points="114.77 299.37 117.57 300.47 117.57 299.37 114.77 299.37"
          fill="#828282"
        />
        <polygon
          points="130.96 286.27 133.51 286.27 134.66 283.37 130.96 281.91 130.96 286.27"
          fill="#828282"
        />
        <polygon
          points="121.36 317.05 121.67 316.27 117.67 314.69 117.57 314.92 117.57 317.05 121.36 317.05"
          fill="#828282"
        />
        <path
          d="M114.68,303.95l-.81-.32c0,.07,0,.14,0,.22,0,.03,0,.07,0,.1h.82Z"
          fill="#828282"
        />
        <polygon
          points="126.37 284.93 124.74 284.29 123.96 286.27 126.37 286.27 126.37 284.93"
          fill="#828282"
        />
        <polygon
          points="120.48 295.07 119.9 296.55 122.07 297.41 122.07 295.07 120.48 295.07"
          fill="#828282"
        />
        <polygon
          points="123.72 299.37 122.51 302.42 126.37 303.95 126.37 299.37 123.72 299.37"
          fill="#828282"
        />
        <path
          d="M131.43,291.55l2.04,.8c.22-.61,.44-1.2,.65-1.79h-2.29l-.39,.98Z"
          fill="#828282"
        />
        <polygon
          points="122.07 287.86 119.16 286.71 117.64 290.57 122.07 290.57 122.07 287.86"
          fill="#828282"
        />
        <polygon
          points="117.67 314.69 118.43 312.75 117.57 312.75 117.57 314.65 117.67 314.69"
          fill="#828282"
        />
        <polygon
          points="121.91 303.95 117.57 303.95 117.57 305.1 120.93 306.42 121.91 303.95"
          fill="#828282"
        />
        <polygon
          points="134.18 272.88 132.31 272.88 133.92 273.52 134.18 272.88"
          fill="#828282"
        />
        <polygon
          points="130.96 272.35 130.96 268.58 130.94 268.58 129.66 271.84 130.96 272.35"
          fill="#828282"
        />
        <polygon
          points="115.9 294.97 115.86 295.07 116.13 295.07 115.9 294.97"
          fill="#828282"
        />
        <polygon
          points="123.97 274.53 122.07 273.77 122.07 277.38 122.84 277.38 123.97 274.53"
          fill="#828282"
        />
        <path
          d="M135.03,272.88c.07,.39,.16,.76,.22,1.16l-1.32-.52-1.52,3.86h2.86v-3.26s0-.05-.01-.08c0,0,0-.01,0-.02-.06-.39-.13-.76-.2-1.14h-.01Z"
          fill="#828282"
        />
        <polygon
          points="117.57 317.05 116.73 317.05 116.01 318.87 117.57 319.49 117.57 317.05"
          fill="#828282"
        />
        <polygon
          points="122.07 277.38 119.49 277.38 122.07 278.4 122.07 277.38"
          fill="#828282"
        />
        <polygon
          points="126.39 303.95 126.51 304 126.53 303.95 126.39 303.95"
          fill="#828282"
        />
        <polygon
          points="130.38 281.68 130.7 281.68 130.96 281.03 130.96 277.38 127.47 277.38 126.39 280.1 130.38 281.68"
          fill="#828282"
        />
        <path
          d="M114.16,299.37h-.31c0,.22,0,.44,0,.64,0,.04,0,.08,0,.12l.3-.76Z"
          fill="#828282"
        />
        <path
          d="M117.57,286.08v-4.4h-1.26l-.95,2.41s0,.03,0,.04c-.05,.34-.09,.68-.14,1.02l2.36,.93Z"
          fill="#828282"
        />
        <path
          d="M122.07,262.21c-.9,.09-1.78,.27-2.62,.57-.04,.12-.07,.24-.11,.36l2.73,1.08v-2.01Z"
          fill="#828282"
        />
        <polygon
          points="123.08 264.55 122.91 264.55 123.05 264.61 123.08 264.55"
          fill="#828282"
        />
        <polygon
          points="126.37 299.37 127.02 299.37 126.37 299.11 126.37 299.37"
          fill="#828282"
        />
        <path
          d="M130.96,267.73l.28,.11,1.02-2.59c-.34-.25-.69-.48-1.05-.7h-.25v3.18Z"
          fill="#828282"
        />
        <polygon
          points="117.57 295.64 117.57 299.37 118.78 299.37 119.9 296.55 117.57 295.64"
          fill="#828282"
        />
        <path
          d="M115.9,294.97l1.58-4-1.03-.41h-1.91c-.02,.17-.04,.33-.06,.5-.12,1.13-.23,2.21-.32,3.22l1.73,.68Z"
          fill="#828282"
        />
        <path
          d="M114.54,290.57c-.02,.17-.03,.33-.05,.5,.02-.17,.04-.33,.06-.5h0Z"
          fill="#828282"
        />
        <polygon
          points="117.57 290.73 117.48 290.97 117.57 291.01 117.57 290.73"
          fill="#828282"
        />
        <polygon
          points="118.05 286.27 119.16 286.71 119.33 286.27 118.05 286.27"
          fill="#828282"
        />
        <polygon
          points="122.07 306.87 120.93 306.42 120.21 308.25 122.07 308.25 122.07 306.87"
          fill="#828282"
        />
        <polygon
          points="127.19 290.57 128.94 290.57 127.43 289.97 127.19 290.57"
          fill="#828282"
        />
        <polygon
          points="124.83 308.25 122.07 308.25 122.07 311.81 123.24 312.27 124.83 308.25"
          fill="#828282"
        />
        <polygon
          points="127.84 295.07 129.74 295.82 130.04 295.07 127.84 295.07"
          fill="#828282"
        />
        <path
          d="M124.24,317.05h-.59l.51,.2c.03-.07,.05-.13,.08-.2Z"
          fill="#828282"
        />
        <polygon
          points="122.07 290.57 122.07 291.04 122.26 290.57 122.07 290.57"
          fill="#828282"
        />
        <path
          d="M130.96,296.3l-1.22-.48-1.4,3.55h2.55c.02-.06,.05-.13,.07-.19v-2.87Z"
          fill="#828282"
        />
        <polygon
          points="122.07 302.25 122.07 303.53 122.51 302.42 122.07 302.25"
          fill="#828282"
        />
        <polygon
          points="126.37 292.64 125.74 294.24 126.37 294.49 126.37 292.64"
          fill="#828282"
        />
        <polygon
          points="123.05 312.75 124.47 312.75 123.24 312.27 123.05 312.75"
          fill="#828282"
        />
        <polygon
          points="125.57 308.25 126.37 308.57 126.37 308.25 125.57 308.25"
          fill="#828282"
        />
        <polygon
          points="117.57 319.49 116.01 318.87 115.56 320.03 117.57 320.03 117.57 319.49"
          fill="#828282"
        />
        <polygon
          points="130.81 317.05 130.96 316.69 130.96 315.32 127.43 313.92 126.37 316.6 126.37 317.05 130.81 317.05"
          fill="#828282"
        />
        <polygon
          points="126.37 317.05 126.19 317.05 125.85 317.92 126.37 318.13 126.37 317.05"
          fill="#828282"
        />
        <polygon
          points="123.24 312.27 122.07 311.81 122.07 312.75 123.05 312.75 123.24 312.27"
          fill="#828282"
        />
        <polygon
          points="122.07 315.24 122.07 312.75 118.43 312.75 117.67 314.69 121.67 316.27 122.07 315.24"
          fill="#828282"
        />
        <path
          d="M113.71,308.5c-.02,.59-.05,1.21-.08,1.85,0,.03,0,.07,0,.1-.03,.71-.07,1.46-.1,2.22,0,0,0,0,0,.01l1.45-3.68-1.27-.5Z"
          fill="#828282"
        />
        <path
          d="M130.96,310.38l2.12,.84c.35-1.02,.68-2,1.01-2.96h-3.12v2.13Z"
          fill="#828282"
        />
        <polygon
          points="130.96 305.76 130.69 305.65 129.67 308.25 130.96 308.25 130.96 305.76"
          fill="#828282"
        />
        <polygon
          points="126.51 304 126.39 303.95 126.37 303.95 126.37 304.35 126.51 304"
          fill="#828282"
        />
        <polygon
          points="126.37 303.95 126.37 303.95 122.51 302.42 122.07 303.53 122.07 303.95 126.37 303.95"
          fill="#828282"
        />
        <polygon
          points="122.07 306.87 122.07 303.95 121.91 303.95 120.93 306.42 122.07 306.87"
          fill="#828282"
        />
        <path
          d="M114.68,303.95h2.29l.6-1.52v-1.96l-2.8-1.11h-.61l-.3,.76c0,.14,0,.29,.01,.42,0,.01,0,.03,0,.05,0,.08,0,.17,.01,.26,0,.03,0,.07,0,.1,0,.07,0,.15,0,.23,0,.05,0,.1,0,.16,0,.08,0,.15,0,.24,0,.06,0,.13,0,.2,0,.08,0,.16,0,.25,0,.08,0,.16,0,.24,0,.08,0,.17,0,.25,0,.1,0,.2,0,.3,0,.02,0,.04,0,.06,0,.24,0,.5-.02,.77l.81,.32Z"
          fill="#828282"
        />
        <path
          d="M135.09,301.73s0,0,0-.01c.06-.55,.11-1.1,.16-1.64h0c-.05,.55-.11,1.1-.16,1.66Z"
          fill="#828282"
        />
        <path
          d="M135.07,301.97c0-.08,.02-.16,.02-.25,0,0,0,0,0,.01,0,.08-.01,.16-.02,.23Z"
          fill="#828282"
        />
        <path
          d="M135.33,299.37h0c.04-.41,.08-.81,.12-1.22,0-.02,0-.05,0-.07h0c-.04,.43-.09,.86-.13,1.29Z"
          fill="#828282"
        />
        <path
          d="M135.46,298.08h0s0,.05,0,.07c0-.02,0-.05,0-.07Z"
          fill="#828282"
        />
        <polygon
          points="135.02 302.52 135.02 302.52 135.02 302.52 135.02 302.52"
          fill="#828282"
        />
        <path
          d="M135.33,299.37c.04-.43,.09-.86,.13-1.29l-.2-.08v1.37h.07Z"
          fill="#828282"
        />
        <path
          d="M135.01,302.52c.03-.26,.06-.53,.09-.79,.06-.56,.11-1.11,.16-1.67v-.7h-2.08l-.83,2.1,2.66,1.05Z"
          fill="#828282"
        />
        <path
          d="M135.01,302.52h0s0,0,0,0c.02-.18,.03-.37,.05-.55,0-.08,.01-.16,.02-.23-.03,.26-.06,.53-.09,.79Z"
          fill="#828282"
        />
        <polygon
          points="126.37 294.49 125.74 294.24 125.42 295.07 126.37 295.07 126.37 294.49"
          fill="#828282"
        />
        <polygon
          points="129.74 295.82 127.84 295.07 126.37 295.07 126.37 299.11 127.02 299.37 128.34 299.37 129.74 295.82"
          fill="#828282"
        />
        <polygon
          points="117.57 295.07 117.57 291.01 117.48 290.97 115.9 294.97 116.13 295.07 117.57 295.07"
          fill="#828282"
        />
        <polygon
          points="120.48 295.07 117.57 295.07 117.57 295.64 119.9 296.55 120.48 295.07"
          fill="#828282"
        />
        <polygon
          points="128.94 290.57 130.96 290.57 130.96 286.74 129.76 286.27 128.89 286.27 127.43 289.97 128.94 290.57"
          fill="#828282"
        />
        <polygon
          points="131.43 291.55 131.81 290.57 130.96 290.57 130.96 291.37 131.43 291.55"
          fill="#828282"
        />
        <polygon
          points="123.96 286.27 124.74 284.29 122.07 283.23 122.07 286.27 123.96 286.27"
          fill="#828282"
        />
        <polygon
          points="122.07 286.27 119.33 286.27 119.16 286.71 122.07 287.86 122.07 286.27"
          fill="#828282"
        />
        <path
          d="M116.31,281.68h-.6c-.11,.73-.22,1.47-.32,2.19-.01,.07-.02,.15-.03,.22l.95-2.41Z"
          fill="#828282"
        />
        <path
          d="M115.7,281.68c-.11,.74-.21,1.47-.32,2.19,.1-.73,.21-1.46,.32-2.19h0Z"
          fill="#828282"
        />
        <path
          d="M135.89,280.24h0c0-.14-.01-.28-.02-.42,0,0,0,0,0,0,0,.14,.01,.28,.02,.42Z"
          fill="#828282"
        />
        <path
          d="M135.9,280.23c0-.14-.02-.27-.03-.4,0,.14,.01,.28,.02,.42h0Z"
          fill="#828282"
        />
        <path
          d="M135.86,279.71s0,0,0,0c-.01-.17-.03-.34-.04-.51h0c.01,.17,.03,.34,.04,.51Z"
          fill="#828282"
        />
        <path
          d="M135.83,279.21h0c.01,.17,.03,.33,.04,.5-.01-.17-.02-.34-.03-.5Z"
          fill="#828282"
        />
        <polygon
          points="130.96 281.68 130.96 281.03 130.7 281.68 130.96 281.68"
          fill="#828282"
        />
        <path
          d="M135.32,281.68l.57-1.43c0-.14-.01-.28-.02-.42,0-.04,0-.07,0-.11-.01-.17-.03-.34-.04-.51l-.56-.22v2.7h.07Z"
          fill="#828282"
        />
        <polygon
          points="134.66 283.37 135.26 281.85 135.26 281.68 130.96 281.68 130.96 281.91 134.66 283.37"
          fill="#828282"
        />
        <polygon
          points="126.37 275.47 123.97 274.53 122.84 277.38 126.37 277.38 126.37 275.47"
          fill="#828282"
        />
        <polygon
          points="127.47 277.38 126.37 277.38 126.37 280.1 126.39 280.1 127.47 277.38"
          fill="#828282"
        />
        <path
          d="M117.57,276.62v-3.74h2.21s-2.44-.97-2.44-.97c-.02,.08-.03,.17-.05,.25-.18,.93-.35,1.88-.52,2.85-.01,.07-.03,.15-.04,.22-.06,.33-.11,.66-.17,.99l1,.39Z"
          fill="#828282"
        />
        <path
          d="M117.16,272.88c-.13,.7-.26,1.41-.38,2.13,.17-.97,.34-1.92,.52-2.85-.05,.24-.09,.48-.14,.72Z"
          fill="#828282"
        />
        <path
          d="M135.25,274.04c-.06-.4-.15-.77-.22-1.16h-.85l-.25,.64,1.32,.52Z"
          fill="#828282"
        />
        <polygon
          points="126.37 268.45 126.32 268.58 126.37 268.58 126.37 268.45"
          fill="#828282"
        />
        <polygon
          points="129.66 271.84 130.94 268.58 126.37 268.58 126.37 270.54 129.66 271.84"
          fill="#828282"
        />
        <polygon
          points="131.24 267.84 130.96 267.73 130.96 268.54 131.24 267.84"
          fill="#828282"
        />
        <polygon
          points="122.91 264.55 122.07 264.55 122.07 267.09 123.05 264.61 122.91 264.55"
          fill="#828282"
        />
        <path
          d="M122.07,264.22l-2.73-1.08s-.02,.07-.03,.1c0,0,0,.02,0,.02-.1,.37-.21,.76-.32,1.17,0,.04-.02,.08-.03,.11h3.11v-.33Z"
          fill="#828282"
        />
        <path
          d="M118.96,264.55h0s.02-.08,.03-.11c-.01,.04-.02,.07-.03,.11Z"
          fill="#828282"
        />
        <polygon
          points="121.42 268.58 121.47 268.6 121.48 268.58 121.42 268.58"
          fill="#828282"
        />
        <path
          d="M130.48,261.92s-.01-.02-.02-.03c0-.01-.02-.02-.03-.03-.01-.01-.03-.03-.04-.04,.03,.03,.06,.07,.09,.1Z"
          fill="#828282"
        />
        <path
          d="M129.38,260.84h0s0,0,.01,.01c0,0,0,0-.01-.01Z"
          fill="#828282"
        />
        <path
          d="M130.96,262.51c-.16-.2-.31-.41-.47-.59-.03-.03-.06-.07-.09-.1-.27-.29-.56-.56-.85-.82-.06-.05-.11-.1-.17-.15l-.48,1.22,2.07,.82v-.38Z"
          fill="#828282"
        />
        <path
          d="M129.54,261c-.05-.05-.1-.1-.15-.15,0,0,0,0-.01-.01h0c.06,.06,.11,.11,.17,.16Z"
          fill="#828282"
        />
        <path
          d="M122.44,258.69s0,0,0,0c-.13,0-.25,.03-.38,.05h0c.12-.01,.25-.04,.37-.05Z"
          fill="#828282"
        />
        <path
          d="M125.31,258.88s-.01,0-.02,0c0,0,.01,0,.02,0h0Z"
          fill="#828282"
        />
        <polygon
          points="122.45 258.69 122.45 258.69 122.44 258.69 122.45 258.69"
          fill="#828282"
        />
        <path
          d="M122.07,258.74h0c.12-.01,.25-.04,.37-.05-.12,0-.25,.04-.37,.05Z"
          fill="#828282"
        />
        <path
          d="M124.06,258.71s-.07-.01-.11-.01c-.02,0-.05,0-.08,0-.02,0-.04,0-.06,0,.08,0,.16,.01,.24,.02Z"
          fill="#828282"
        />
        <path
          d="M124.06,258.71c-.08,0-.16-.01-.24-.02-.44-.03-.9-.03-1.37,0,0,0,0,0,0,0-.12,0-.25,.04-.37,.05v.64l2.19,.87h.51l.54-1.37s-.01,0-.02,0c-.4-.08-.81-.13-1.23-.17Z"
          fill="#828282"
        />
        <path
          d="M125.31,258.88s-.01,0-.02,0c0,0,0,0,0,0,0,0,.01,0,.02,0Z"
          fill="#828282"
        />
        <path
          d="M113.51,313.05c-.03,.55-.05,1.11-.08,1.69,.03-.57,.05-1.14,.08-1.69h0Z"
          fill="#292929"
        />
        <path
          d="M113.52,312.8c0,.08,0,.17-.01,.25h0c0-.08,0-.17,.01-.25Z"
          fill="#292929"
        />
        <path
          d="M116.73,317.05l.84-2.13v-.27l-4.07-1.61c-.03,.55-.05,1.11-.08,1.69,0,.07,0,.14-.01,.22-.03,.66-.07,1.34-.1,2.04,0,.02,0,.04,0,.07h3.42Z"
          fill="#292929"
        />
        <polygon
          points="117.57 314.92 116.73 317.05 117.57 317.05 117.57 314.92"
          fill="#292929"
        />
        <path
          d="M117.57,314.65v-1.9h-4.05s0,.03,0,.05c0,.08,0,.16-.01,.25l4.07,1.61Z"
          fill="#292929"
        />
        <path
          d="M126.37,312.75h-.5c-.06,.16-.12,.32-.18,.48l.69,.27v-.75Z"
          fill="#292929"
        />
        <path
          d="M124.47,312.75l1.22,.48c.06-.16,.12-.32,.18-.48h-1.4Z"
          fill="#292929"
        />
        <polygon
          points="122.07 316.43 122.07 317.05 123.65 317.05 122.07 316.43"
          fill="#292929"
        />
        <path
          d="M126.37,316.6v-3.09l-.69-.27c-.48,1.27-.96,2.54-1.45,3.82h1.95l.18-.46Z"
          fill="#292929"
        />
        <path
          d="M123.65,317.05h.59c.48-1.28,.97-2.55,1.45-3.82l-1.22-.48h-1.42l-.98,2.49v1.19l1.58,.62Z"
          fill="#292929"
        />
        <polygon
          points="126.37 316.6 126.19 317.05 126.37 317.05 126.37 316.6"
          fill="#292929"
        />
        <polygon
          points="122.07 312.75 122.07 315.24 123.05 312.75 122.07 312.75"
          fill="#292929"
        />
        <path
          d="M135.26,317.05v-4.3h-1.6c-.22,1.45-.46,2.89-.7,4.3h2.3Z"
          fill="#292929"
        />
        <path
          d="M131.61,315.57c-.16,.48-.33,.99-.5,1.48h1.84c.24-1.41,.48-2.85,.7-4.3h-1.14l-1.09,2.75,.18,.07Z"
          fill="#292929"
        />
        <path
          d="M131.11,317.05c.16-.49,.33-1,.5-1.48l-.18-.07-.47,1.19v.37h.15Z"
          fill="#292929"
        />
        <polygon
          points="132.51 312.75 130.96 312.75 130.96 315.32 131.43 315.5 132.51 312.75"
          fill="#292929"
        />
        <polygon
          points="130.96 315.32 130.96 316.69 131.43 315.5 130.96 315.32"
          fill="#292929"
        />
        <rect x="139.76" y="312.75" width="4.3" height="4.3" fill="#292929" />
        <rect x="148.65" y="312.75" width="4.3" height="4.3" fill="#292929" />
        <rect x="165.78" y="312.75" width="4.3" height="4.3" fill="#292929" />
        <rect x="174.67" y="312.75" width="4.3" height="4.3" fill="#292929" />
        <path
          d="M185.51,317.05c-.24-1.41-.48-2.85-.7-4.3h-1.35v4.3h2.05Z"
          fill="#292929"
        />
        <path
          d="M187.35,317.05c-.16-.49-.33-1-.5-1.48l.18-.07-1.09-2.75h-1.14c.22,1.45,.46,2.89,.7,4.3h1.84Z"
          fill="#292929"
        />
        <polygon
          points="187.76 312.75 185.95 312.75 187.04 315.5 187.76 315.21 187.76 312.75"
          fill="#292929"
        />
        <path
          d="M187.04,315.5l-.18,.07c.16,.48,.33,.99,.5,1.48h.3l-.61-1.55Z"
          fill="#292929"
        />
        <polygon
          points="187.76 317.05 187.76 315.21 187.04 315.5 187.65 317.05 187.76 317.05"
          fill="#292929"
        />
        <polygon
          points="117.57 305.1 116.66 304.74 115.27 308.25 117.57 308.25 117.57 305.1"
          fill="#292929"
        />
        <polygon
          points="117.57 303.95 116.97 303.95 116.66 304.74 117.57 305.1 117.57 303.95"
          fill="#292929"
        />
        <path
          d="M115.27,308.25l1.39-3.52-1.98-.78h-.82s0,0,0,.01c-.02,.59-.04,1.23-.06,1.93,0,.04,0,.08,0,.12-.01,.3-.02,.62-.03,.94,0,.06,0,.12,0,.18-.01,.34-.03,.7-.04,1.06,0,.02,0,.03,0,.05h1.56Z"
          fill="#292929"
        />
        <polygon
          points="114.68 303.95 116.66 304.74 116.97 303.95 114.68 303.95"
          fill="#292929"
        />
        <polygon
          points="124.93 308 124.83 308.25 125.57 308.25 124.93 308"
          fill="#292929"
        />
        <polygon
          points="124.93 308 122.07 306.87 122.07 308.25 124.83 308.25 124.93 308"
          fill="#292929"
        />
        <polygon
          points="126.37 308.25 126.37 304.35 124.93 308 125.57 308.25 126.37 308.25"
          fill="#292929"
        />
        <polygon
          points="126.37 304.35 126.37 303.95 122.07 303.95 122.07 306.87 124.93 308 126.37 304.35"
          fill="#292929"
        />
        <path
          d="M134.46,307.14h0s0,.02,0,.02c-.05,.36-.1,.73-.15,1.09h.95v-4.3h-.4c-.12,1.06-.26,2.13-.4,3.19Z"
          fill="#292929"
        />
        <path
          d="M134.08,308.25h.23c.05-.36,.1-.73,.15-1.09,0,0,0,0,0,0-.12,.35-.25,.73-.37,1.09Z"
          fill="#292929"
        />
        <path
          d="M134.46,307.14h0s0,0,0,0c.14-1.06,.27-2.12,.4-3.19h-.01c-.12,1.06-.25,2.13-.39,3.19Z"
          fill="#292929"
        />
        <polygon
          points="130.96 303.95 130.96 304.98 131.36 303.95 130.96 303.95"
          fill="#292929"
        />
        <path
          d="M134.46,307.14c.14-1.06,.26-2.12,.39-3.19h-3.48l-.4,1.03v.78l3.5,1.38Z"
          fill="#292929"
        />
        <path
          d="M134.46,307.14h0s0,.01,0,.02c0,0,0-.01,0-.02Z"
          fill="#292929"
        />
        <path
          d="M134.45,307.16s0,0,0,0c0,0,0-.02,0-.02h0s0,.02,0,.02Z"
          fill="#292929"
        />
        <path
          d="M134.46,307.14h0s0,.02,0,.02c0,0,0-.02,0-.02Z"
          fill="#292929"
        />
        <path
          d="M130.96,308.25h3.12c.12-.36,.25-.74,.37-1.09,0,0,0-.02,0-.02l-3.5-1.38v2.5Z"
          fill="#292929"
        />
        <rect x="139.76" y="303.95" width="4.3" height="4.3" fill="#292929" />
        <rect x="148.65" y="303.95" width="4.3" height="4.3" fill="#292929" />
        <rect x="165.78" y="303.95" width="4.3" height="4.3" fill="#292929" />
        <rect x="174.67" y="303.95" width="4.3" height="4.3" fill="#292929" />
        <path
          d="M184.01,307.16s0-.02,0-.02h0c-.14-1.06-.27-2.12-.4-3.19h-.15v4.3h.7c-.05-.36-.1-.73-.15-1.09Z"
          fill="#292929"
        />
        <path
          d="M184.01,307.14c-.14-1.06-.26-2.12-.39-3.19h-.01c.12,1.06,.26,2.13,.4,3.19h0Z"
          fill="#292929"
        />
        <polygon
          points="187.76 305.63 187.76 303.95 187.1 303.95 187.76 305.63"
          fill="#292929"
        />
        <path
          d="M184.01,307.16s0,0,0,0c.05,.36,.1,.73,.15,1.09h.22c-.12-.36-.25-.74-.37-1.09Z"
          fill="#292929"
        />
        <path
          d="M187.76,305.66v-.03l-.66-1.67h-3.48c.12,1.06,.25,2.13,.39,3.19l3.75-1.48Z"
          fill="#292929"
        />
        <path d="M184,307.14s0,.02,0,.02c0,0,0-.02,0-.02h0Z" fill="#292929" />
        <path
          d="M184.01,307.14h0s0,.02,0,.02c0,0,0,0,0,0,0,0,0-.02,0-.02Z"
          fill="#292929"
        />
        <path
          d="M184.01,307.14s0,.02,0,.02c0,0,0-.02,0-.02h0Z"
          fill="#292929"
        />
        <path
          d="M187.76,305.66l-3.75,1.48s0,.02,0,.02c.12,.35,.25,.73,.37,1.09h3.38v-2.6Z"
          fill="#292929"
        />
        <path
          d="M114.24,299.16l1.62-4.09h-1.77s0,0,0,.01c-.03,.42-.07,.83-.09,1.22h0c-.03,.4-.05,.77-.07,1.13,0,0,0,0,0,0-.03,.58-.05,1.09-.06,1.57l.38,.15Z"
          fill="#292929"
        />
        <path d="M114.09,295.07s0,0,0,.01c0,0,0,0,0-.01h0Z" fill="#292929" />
        <polygon
          points="117.57 295.64 116.13 295.07 115.86 295.07 114.24 299.16 114.77 299.37 117.57 299.37 117.57 295.64"
          fill="#292929"
        />
        <path
          d="M113.86,299.01c0,.12,0,.25,0,.36h.31l.08-.21-.38-.15Z"
          fill="#292929"
        />
        <polygon
          points="114.16 299.37 114.77 299.37 114.24 299.16 114.16 299.37"
          fill="#292929"
        />
        <polygon
          points="116.13 295.07 117.57 295.64 117.57 295.07 116.13 295.07"
          fill="#292929"
        />
        <polygon
          points="122.07 297.41 122.07 299.37 123.72 299.37 124.16 298.24 122.07 297.41"
          fill="#292929"
        />
        <polygon
          points="126.37 299.11 124.16 298.24 123.72 299.37 126.37 299.37 126.37 299.11"
          fill="#292929"
        />
        <polygon
          points="125.42 295.07 122.07 295.07 122.07 297.41 124.16 298.24 125.42 295.07"
          fill="#292929"
        />
        <polygon
          points="125.42 295.07 124.16 298.24 126.37 299.11 126.37 295.07 125.42 295.07"
          fill="#292929"
        />
        <path
          d="M133.92,297.47l.95-2.4h-2.4c-.19,.53-.39,1.06-.59,1.6l2.04,.81Z"
          fill="#292929"
        />
        <path
          d="M131.89,296.67c.2-.54,.39-1.07,.59-1.6h-1.51v1.23l.93,.37Z"
          fill="#292929"
        />
        <path
          d="M130.96,299.17v.19h2.22l.75-1.9-2.04-.81c-.3,.82-.61,1.66-.93,2.51Z"
          fill="#292929"
        />
        <polygon
          points="133.92 297.47 135.26 298 135.26 295.07 134.87 295.07 133.92 297.47"
          fill="#292929"
        />
        <path
          d="M130.96,296.3v2.87c.31-.85,.62-1.69,.93-2.51l-.93-.37Z"
          fill="#292929"
        />
        <polygon
          points="135.26 299.37 135.26 298 133.92 297.47 133.18 299.37 135.26 299.37"
          fill="#292929"
        />
        <rect x="139.76" y="295.07" width="4.3" height="4.3" fill="#292929" />
        <rect x="148.65" y="295.07" width="4.3" height="4.3" fill="#292929" />
        <rect x="165.78" y="295.07" width="4.3" height="4.3" fill="#292929" />
        <rect x="174.67" y="295.07" width="4.3" height="4.3" fill="#292929" />
        <path
          d="M185.89,295.07h-2.3l.95,2.4,1.95-.77c-.2-.55-.4-1.1-.6-1.63Z"
          fill="#292929"
        />
        <path
          d="M187.76,296.2v-1.13h-1.87c.2,.54,.4,1.08,.6,1.63l1.27-.5Z"
          fill="#292929"
        />
        <path
          d="M187.48,299.37c-.34-.91-.66-1.79-.99-2.67l-1.95,.77,.75,1.9h2.19Z"
          fill="#292929"
        />
        <polygon
          points="184.54 297.47 183.59 295.07 183.46 295.07 183.46 297.9 184.54 297.47"
          fill="#292929"
        />
        <path
          d="M187.76,296.2l-1.27,.5c.32,.87,.65,1.76,.99,2.67h.28v-3.17Z"
          fill="#292929"
        />
        <polygon
          points="185.29 299.37 184.54 297.47 183.46 297.9 183.46 299.37 185.29 299.37"
          fill="#292929"
        />
        <path
          d="M192.48,312.75v.6l.21-.08c-.06-.17-.13-.34-.19-.51h-.02Z"
          fill="#292929"
        />
        <path
          d="M192.69,313.27l1.3-.51h-1.5c.06,.17,.13,.34,.19,.51Z"
          fill="#292929"
        />
        <polygon
          points="196.78 316.28 194.82 317.05 196.78 317.05 196.78 316.28"
          fill="#292929"
        />
        <path
          d="M192.48,317.05h1.65c-.48-1.27-.96-2.53-1.43-3.79l-.21,.08v3.7Z"
          fill="#292929"
        />
        <path
          d="M194,312.75l-1.3,.51c.48,1.26,.95,2.52,1.43,3.79h.69l1.96-.78v-.06l-1.37-3.46h-1.42Z"
          fill="#292929"
        />
        <polygon
          points="196.78 316.22 196.78 312.75 195.41 312.75 196.78 316.22"
          fill="#292929"
        />
        <polygon
          points="193.64 308.25 193.54 308 192.89 308.25 193.64 308.25"
          fill="#292929"
        />
        <polygon
          points="196.78 304.51 196.78 303.95 196.56 303.95 196.78 304.51"
          fill="#292929"
        />
        <polygon
          points="196.78 308.25 196.78 306.72 193.54 308 193.64 308.25 196.78 308.25"
          fill="#292929"
        />
        <polygon
          points="192.89 308.25 193.54 308 192.48 305.33 192.48 308.25 192.89 308.25"
          fill="#292929"
        />
        <polygon
          points="192.48 305.33 193.54 308 196.78 306.72 196.78 304.51 196.56 303.95 192.48 303.95 192.48 305.33"
          fill="#292929"
        />
        <polygon
          points="194.75 299.37 196.78 299.37 196.78 297.26 194.3 298.24 194.75 299.37"
          fill="#292929"
        />
        <polygon
          points="194.3 298.24 196.78 297.26 196.78 295.07 193.05 295.07 194.3 298.24"
          fill="#292929"
        />
        <polygon
          points="192.48 298.96 192.48 299.37 194.75 299.37 194.3 298.24 192.48 298.96"
          fill="#292929"
        />
        <polygon
          points="192.48 298.96 194.3 298.24 193.05 295.07 192.48 295.07 192.48 298.96"
          fill="#292929"
        />
        <path
          d="M204.12,317.05h0c-.06-1.25-.12-2.45-.17-3.6h0c.05,1.15,.11,2.36,.18,3.6Z"
          fill="#292929"
        />
        <path
          d="M203.94,313.45c-.01-.23-.02-.47-.03-.7h0c.01,.23,.02,.46,.03,.7h0Z"
          fill="#292929"
        />
        <path
          d="M201.73,317.05h2.38c-.06-1.25-.12-2.45-.18-3.6l-2.66,1.05v1.4l.46,1.16Z"
          fill="#292929"
        />
        <polygon
          points="201.73 317.05 201.28 315.9 201.28 317.05 201.73 317.05"
          fill="#292929"
        />
        <path
          d="M201.28,314.5l2.66-1.05c-.01-.23-.02-.47-.03-.7h-2.63v1.75Z"
          fill="#292929"
        />
        <path
          d="M116.45,290.57h1.13v-4.3h-2.51c-.02,.18-.05,.37-.07,.55-.05,.41-.11,.82-.16,1.23,0,.05-.01,.09-.02,.14-.07,.56-.13,1.11-.2,1.66l1.83,.72Z"
          fill="#292929"
        />
        <path
          d="M115.06,286.27c-.02,.19-.05,.37-.07,.55,.02-.18,.05-.37,.07-.55h0Z"
          fill="#292929"
        />
        <path
          d="M116.45,290.57l-1.83-.72c-.02,.15-.04,.3-.05,.46-.01,.09-.02,.17-.03,.26h1.91Z"
          fill="#292929"
        />
        <path
          d="M114.57,290.3c-.01,.09-.02,.18-.03,.26h0c.01-.09,.02-.17,.03-.26Z"
          fill="#292929"
        />
        <polygon
          points="123.16 288.29 122.26 290.57 126.37 290.57 126.37 289.55 123.16 288.29"
          fill="#292929"
        />
        <polygon
          points="126.37 289.55 126.37 286.27 123.96 286.27 123.16 288.29 126.37 289.55"
          fill="#292929"
        />
        <polygon
          points="123.16 288.29 122.07 287.86 122.07 290.57 122.26 290.57 123.16 288.29"
          fill="#292929"
        />
        <polygon
          points="123.96 286.27 122.07 286.27 122.07 287.86 123.16 288.29 123.96 286.27"
          fill="#292929"
        />
        <path
          d="M135.26,288.44v-1.1c-.11,.32-.23,.64-.34,.97l.34,.14Z"
          fill="#292929"
        />
        <path
          d="M133.01,287.55l1.91,.75c.12-.33,.23-.65,.34-.97v-1.07h-1.75l-.51,1.28Z"
          fill="#292929"
        />
        <path
          d="M134.11,290.57h1.15v-2.13l-.34-.14c-.26,.73-.53,1.48-.81,2.26Z"
          fill="#292929"
        />
        <polygon
          points="130.96 286.74 133.01 287.55 133.51 286.27 130.96 286.27 130.96 286.74"
          fill="#292929"
        />
        <path
          d="M134.11,290.57c.28-.78,.55-1.53,.81-2.26l-1.91-.75-1.19,3.02h2.29Z"
          fill="#292929"
        />
        <polygon
          points="130.96 290.57 131.81 290.57 133.01 287.55 130.96 286.74 130.96 290.57"
          fill="#292929"
        />
        <rect x="139.76" y="286.27" width="4.3" height="4.3" fill="#292929" />
        <rect x="148.65" y="286.27" width="4.3" height="4.3" fill="#292929" />
        <rect x="165.78" y="286.27" width="4.3" height="4.3" fill="#292929" />
        <rect x="174.67" y="286.27" width="4.3" height="4.3" fill="#292929" />
        <polygon
          points="183.46 288.34 183.46 288.34 183.46 288.34 183.46 288.34"
          fill="#292929"
        />
        <polygon
          points="185.46 287.55 184.95 286.27 183.46 286.27 183.46 288.34 183.46 288.34 185.46 287.55"
          fill="#292929"
        />
        <path
          d="M184.26,290.57c-.28-.77-.54-1.51-.8-2.23h0v2.23h.8Z"
          fill="#292929"
        />
        <polygon
          points="187.76 286.27 184.95 286.27 185.46 287.55 187.76 286.64 187.76 286.27"
          fill="#292929"
        />
        <path
          d="M185.46,287.55l-2,.79c.26,.72,.52,1.46,.8,2.23h2.39l-1.19-3.02Z"
          fill="#292929"
        />
        <polygon
          points="187.76 290.57 187.76 286.64 185.46 287.55 186.65 290.57 187.76 290.57"
          fill="#292929"
        />
        <polygon
          points="117.57 278.48 116.56 281.06 117.57 281.46 117.57 278.48"
          fill="#292929"
        />
        <polygon
          points="117.57 281.46 116.56 281.06 116.31 281.68 117.57 281.68 117.57 281.46"
          fill="#292929"
        />
        <path
          d="M116.56,281.06l1.02-2.58v-1.1h-1.19c-.1,.63-.2,1.26-.3,1.9-.08,.5-.16,1-.23,1.5l.71,.28Z"
          fill="#292929"
        />
        <path
          d="M116.38,277.38c-.1,.63-.2,1.26-.3,1.9,.1-.63,.2-1.27,.3-1.9h0Z"
          fill="#292929"
        />
        <path
          d="M116.31,281.68l.25-.62-.71-.28c-.02,.16-.05,.33-.08,.49-.02,.14-.04,.28-.06,.41h.6Z"
          fill="#292929"
        />
        <path
          d="M115.77,281.27c-.02,.14-.04,.28-.07,.41h0c.02-.14,.04-.28,.06-.41Z"
          fill="#292929"
        />
        <polygon
          points="122.07 278.4 122.07 279.34 122.39 278.52 122.07 278.4"
          fill="#292929"
        />
        <polygon
          points="126.37 280.15 125.77 281.68 126.37 281.68 126.37 280.15"
          fill="#292929"
        />
        <polygon
          points="125.77 281.68 126.37 280.15 126.37 280.1 122.39 278.52 122.07 279.34 122.07 281.68 125.77 281.68"
          fill="#292929"
        />
        <polygon
          points="122.39 278.52 122.84 277.38 122.07 277.38 122.07 278.4 122.39 278.52"
          fill="#292929"
        />
        <polygon
          points="126.37 277.38 122.84 277.38 122.39 278.52 126.37 280.1 126.37 277.38"
          fill="#292929"
        />
        <polygon
          points="132.4 277.38 131.2 277.38 132.24 277.79 132.4 277.38"
          fill="#292929"
        />
        <polygon
          points="135.26 278.98 135.26 277.38 132.4 277.38 132.24 277.79 135.26 278.98"
          fill="#292929"
        />
        <polygon
          points="130.96 281.03 132.24 277.79 131.2 277.38 130.96 277.38 130.96 281.03"
          fill="#292929"
        />
        <polygon
          points="135.26 281.68 135.26 278.98 132.24 277.79 130.96 281.03 130.96 281.68 135.26 281.68"
          fill="#292929"
        />
        <path
          d="M139.76,281.68h4.3v-4.27s-.01-.02-.02-.03h-4.28v4.3Z"
          fill="#292929"
        />
        <rect x="148.65" y="277.38" width="4.3" height="4.3" fill="#292929" />
        <rect x="165.78" y="277.38" width="4.3" height="4.3" fill="#292929" />
        <path
          d="M174.67,281.68h4.3v-4.3h-3.54c-.25,.46-.5,.91-.76,1.36v2.94Z"
          fill="#292929"
        />
        <polygon
          points="187.27 277.38 186.07 277.38 186.23 277.79 187.27 277.38"
          fill="#292929"
        />
        <polygon
          points="186.23 277.79 186.07 277.38 183.46 277.38 183.46 278.88 186.23 277.79"
          fill="#292929"
        />
        <polygon
          points="187.76 281.67 187.76 277.38 187.27 277.38 186.23 277.79 187.76 281.67"
          fill="#292929"
        />
        <polygon
          points="187.76 281.67 186.23 277.79 183.46 278.88 183.46 281.68 187.76 281.68 187.76 281.67"
          fill="#292929"
        />
        <polygon
          points="125.66 270.26 122.07 268.84 122.07 272.88 124.62 272.88 125.66 270.26"
          fill="#292929"
        />
        <polygon
          points="126.32 268.58 122.07 268.58 122.07 268.84 125.66 270.26 126.32 268.58"
          fill="#292929"
        />
        <polygon
          points="126.37 270.54 125.66 270.26 124.62 272.88 126.37 272.88 126.37 270.54"
          fill="#292929"
        />
        <polygon
          points="126.37 270.54 126.37 268.58 126.32 268.58 125.66 270.26 126.37 270.54"
          fill="#292929"
        />
        <path
          d="M134.12,268.98c.12,.39,.23,.8,.33,1.21,.08,.32,.16,.66,.23,.99,.02,.09,.04,.17,.06,.26v-.02c.03,.09,.04,.2,.06,.29,.04,.18,.08,.36,.12,.54,0,0,0,.01,0,.02,.04,.2,.08,.4,.12,.6h.21v-4.3h-1.26c.04,.13,.07,.26,.11,.39h.01Z"
          fill="#292929"
        />
        <path
          d="M134,268.58h-.88l.99,.39c-.04-.13-.07-.26-.11-.39Z"
          fill="#292929"
        />
        <path
          d="M135.05,272.88c-.04-.2-.08-.4-.12-.6,.04,.2,.07,.4,.11,.6h0Z"
          fill="#292929"
        />
        <polygon
          points="132.31 272.88 130.96 272.35 130.96 272.88 132.31 272.88"
          fill="#292929"
        />
        <path
          d="M135.03,272.88h.01c-.04-.2-.07-.41-.11-.6,0,0,0-.01,0-.02-.03-.17-.08-.33-.11-.49,.08,.36,.14,.74,.21,1.12Z"
          fill="#292929"
        />
        <path
          d="M134.93,272.26c-.04-.19-.08-.36-.12-.54,0,.02,0,.03,0,.05,.04,.17,.08,.32,.11,.49Z"
          fill="#292929"
        />
        <path
          d="M130.96,272.35l1.35,.53h1.87l.57-1.44c-.02-.09-.04-.18-.06-.26-.08-.33-.15-.67-.23-.99-.11-.42-.22-.82-.34-1.21l-.99-.39h-2.17v3.77Z"
          fill="#292929"
        />
        <path
          d="M134.69,271.18c.02,.09,.04,.18,.06,.26h0c-.02-.09-.04-.18-.06-.26Z"
          fill="#292929"
        />
        <path
          d="M134.11,268.97c.12,.4,.24,.8,.34,1.21-.1-.41-.21-.82-.33-1.21h-.01Z"
          fill="#292929"
        />
        <path
          d="M134.75,271.42v.02c.01,.09,.04,.18,.06,.28-.02-.1-.03-.2-.06-.29Z"
          fill="#292929"
        />
        <path
          d="M134.82,271.76c-.02-.11-.05-.22-.07-.32l-.57,1.44h.85c-.07-.37-.13-.75-.21-1.12Z"
          fill="#292929"
        />
        <path
          d="M134.81,271.71c-.02-.09-.04-.19-.06-.28h0c.02,.11,.05,.22,.07,.33,0-.02,0-.03,0-.05Z"
          fill="#292929"
        />
        <path
          d="M141.85,272.88c-.57-1.3-1.15-2.71-1.78-4.3h-.32v4.3h2.09Z"
          fill="#292929"
        />
        <path
          d="M152.95,272.05c-.26,.27-.52,.55-.78,.84h.78v-.84Z"
          fill="#292929"
        />
        <path
          d="M167.29,272.88c-.51-.56-1.01-1.09-1.52-1.58v1.58h1.52Z"
          fill="#292929"
        />
        <path
          d="M178.97,269.65c-.47,1.16-.91,2.23-1.35,3.23h1.35v-3.23Z"
          fill="#292929"
        />
        <path
          d="M183.54,272.25c.04-.18,.08-.36,.12-.54,.02-.1,.03-.2,.06-.29v.02s0,0,0,0c.09-.4,.18-.79,.27-1.17,.11-.44,.22-.87,.35-1.28,0,0,0,0,0,0,.04-.13,.08-.26,.12-.39h-1v4.06c.02-.12,.05-.24,.07-.35,0-.01,0-.02,0-.03Z"
          fill="#292929"
        />
        <polygon
          points="187.76 272.25 186.16 272.88 187.76 272.88 187.76 272.25"
          fill="#292929"
        />
        <path
          d="M185.34,268.58h-.88c-.04,.13-.08,.26-.12,.39l1-.39Z"
          fill="#292929"
        />
        <path
          d="M183.53,272.29c-.02,.12-.05,.23-.07,.35v.03c.02-.13,.04-.26,.07-.38Z"
          fill="#292929"
        />
        <path
          d="M183.66,271.72c-.04,.18-.08,.35-.12,.54,0,.01,0,.02,0,.03-.02,.13-.04,.26-.07,.38v.08c.06-.34,.12-.7,.19-1.03Z"
          fill="#292929"
        />
        <path
          d="M183.66,271.71c-.04,.18-.08,.36-.12,.54,.04-.18,.08-.36,.12-.54,0,0,0,0,0,0Z"
          fill="#292929"
        />
        <path
          d="M184.34,268.98c-.12,.41-.24,.84-.35,1.28-.1,.38-.19,.77-.27,1.17,0,0,0,0,0,0l.57,1.45h1.87l1.6-.63v-3.07l-.24-.6h-2.18l-1,.39s0,0,0,0Z"
          fill="#292929"
        />
        <polygon
          points="183.72 271.43 183.72 271.44 183.72 271.44 183.72 271.43"
          fill="#292929"
        />
        <path
          d="M183.71,271.42c-.02,.09-.04,.2-.06,.29,.02-.09,.04-.19,.06-.28v-.02Z"
          fill="#292929"
        />
        <path
          d="M183.46,272.75v.14h.83l-.57-1.45c-.02,.09-.04,.19-.06,.28-.07,.33-.13,.69-.19,1.03Z"
          fill="#292929"
        />
        <path
          d="M183.72,271.44h0c-.02,.09-.04,.18-.06,.28,0,0,0,0,0,0,.02-.09,.04-.19,.06-.28Z"
          fill="#292929"
        />
        <polygon
          points="187.52 268.58 187.76 269.18 187.76 268.58 187.52 268.58"
          fill="#292929"
        />
        <polygon
          points="196.21 290.57 195.31 288.29 192.48 289.4 192.48 290.57 196.21 290.57"
          fill="#292929"
        />
        <polygon
          points="196.21 290.57 196.78 290.57 196.78 287.7 195.31 288.29 196.21 290.57"
          fill="#292929"
        />
        <polygon
          points="192.48 289.4 195.31 288.29 194.51 286.27 192.48 286.27 192.48 289.4"
          fill="#292929"
        />
        <polygon
          points="196.78 287.7 196.78 286.27 194.51 286.27 195.31 288.29 196.78 287.7"
          fill="#292929"
        />
        <polygon
          points="192.7 281.68 192.48 281.13 192.48 281.68 192.7 281.68"
          fill="#292929"
        />
        <polygon
          points="196.78 278.25 196.07 278.52 196.78 280.31 196.78 278.25"
          fill="#292929"
        />
        <polygon
          points="192.48 281.13 192.7 281.68 196.78 281.68 196.78 280.31 196.07 278.52 192.48 279.94 192.48 281.13"
          fill="#292929"
        />
        <polygon
          points="196.07 278.52 196.78 278.25 196.78 277.38 195.62 277.38 196.07 278.52"
          fill="#292929"
        />
        <polygon
          points="192.48 279.94 196.07 278.52 195.62 277.38 192.48 277.38 192.48 279.94"
          fill="#292929"
        />
        <polygon
          points="193.85 272.88 196.78 272.88 196.78 268.69 192.81 270.26 193.85 272.88"
          fill="#292929"
        />
        <polygon
          points="192.81 270.26 196.78 268.69 196.78 268.58 192.48 268.58 192.48 269.43 192.81 270.26"
          fill="#292929"
        />
        <polygon
          points="193.85 272.88 192.81 270.26 192.48 270.39 192.48 272.88 193.85 272.88"
          fill="#292929"
        />
        <polygon
          points="192.48 269.43 192.48 270.39 192.81 270.26 192.48 269.43"
          fill="#292929"
        />
        <path
          d="M203.62,305.93c-.02-.68-.04-1.31-.06-1.89h0c.02,.57,.04,1.21,.06,1.89Z"
          fill="#292929"
        />
        <path
          d="M203.71,308.25c-.02-.4-.03-.79-.05-1.17,.01,.38,.03,.77,.05,1.17h0Z"
          fill="#292929"
        />
        <path d="M203.56,304.04h0s0-.06,0-.09h0s0,.06,0,.09Z" fill="#292929" />
        <polygon
          points="201.28 308.25 203.19 308.25 201.8 304.74 201.28 304.94 201.28 308.25"
          fill="#292929"
        />
        <polygon
          points="201.28 304.94 201.8 304.74 201.49 303.95 201.28 303.95 201.28 304.94"
          fill="#292929"
        />
        <path
          d="M201.8,304.74l1.39,3.52h.52c-.02-.4-.03-.79-.05-1.17,0-.02,0-.04,0-.05-.01-.37-.03-.74-.04-1.09,0,0,0,0,0-.01-.02-.68-.04-1.32-.06-1.89l-1.76,.7Z"
          fill="#292929"
        />
        <path
          d="M203.56,304.04s0-.06,0-.09h-2.07l.31,.78,1.76-.7Z"
          fill="#292929"
        />
        <path d="M203.44,295.08s0-.01,0-.02h0s0,.01,0,.02Z" fill="#292929" />
        <path
          d="M202.61,295.07l.95,2.39s0,0,0,0c0,0,0-.01,0-.02-.01-.35-.03-.72-.04-1.11,0-.01,0-.02,0-.03-.02-.39-.04-.79-.06-1.21,0,0,0-.01,0-.02h-.84Z"
          fill="#292929"
        />
        <path
          d="M201.28,295.48v3.88h2.31c0-.28,0-.58,0-.9,0,0,0,0,0,0,0-.31-.01-.65-.03-1l-.95-2.39h-.27l-1.06,.42Z"
          fill="#292929"
        />
        <polygon
          points="202.33 295.07 201.28 295.07 201.28 295.48 202.33 295.07"
          fill="#292929"
        />
        <polygon
          points="202.75 286.28 202.74 286.27 202.74 286.27 202.75 286.28"
          fill="#292929"
        />
        <path
          d="M203.13,290.57s0-.01,0-.02c0,0,0,.01,0,.02h0Z"
          fill="#292929"
        />
        <path
          d="M201.28,286.27v4.3h.74l1.08-.42c-.1-1.24-.22-2.53-.35-3.87,0,0,0,0,0,0h-1.47Z"
          fill="#292929"
        />
        <path
          d="M202.02,290.57h1.11s0-.01,0-.02c-.01-.13-.02-.27-.03-.41l-1.08,.42Z"
          fill="#292929"
        />
        <polygon
          points="202.26 281.68 202.26 281.67 202.26 281.68 202.26 281.68"
          fill="#292929"
        />
        <polygon
          points="201.91 281.06 201.28 279.45 201.28 281.31 201.91 281.06"
          fill="#292929"
        />
        <path
          d="M201.28,277.38v2.07l.63,1.6,.26-.1c-.06-.48-.12-.95-.17-1.43-.09-.72-.18-1.43-.27-2.14h-.45Z"
          fill="#292929"
        />
        <path
          d="M202,279.52c-.09-.72-.17-1.43-.26-2.14h0c.09,.71,.18,1.43,.27,2.14Z"
          fill="#292929"
        />
        <polygon
          points="201.28 281.68 202.16 281.68 201.91 281.06 201.28 281.31 201.28 281.68"
          fill="#292929"
        />
        <path
          d="M201.91,281.06l.25,.62h.1s0,0,0,0c-.03-.24-.06-.48-.09-.72l-.26,.1Z"
          fill="#292929"
        />
        <path
          d="M126.37,261.08l-1.67-.66-.69,1.74c.78,.05,1.57,.17,2.35,.36v-1.44Z"
          fill="#292929"
        />
        <path
          d="M126.37,264.55v-2.03c-.78-.19-1.57-.31-2.35-.36l-.94,2.38h3.3Z"
          fill="#292929"
        />
        <path
          d="M122.07,262.21c.64-.06,1.29-.08,1.95-.04l.69-1.74-.44-.17h-2.19v1.96Z"
          fill="#292929"
        />
        <polygon
          points="126.37 261.08 126.37 260.25 124.77 260.25 124.7 260.42 126.37 261.08"
          fill="#292929"
        />
        <path
          d="M122.91,264.55h.17l.94-2.38c-.66-.04-1.3-.02-1.95,.04v2.01l.84,.33Z"
          fill="#292929"
        />
        <polygon
          points="122.07 264.22 122.07 264.55 122.91 264.55 122.07 264.22"
          fill="#292929"
        />
        <polygon
          points="124.77 260.25 124.26 260.25 124.7 260.42 124.77 260.25"
          fill="#292929"
        />
        <path
          d="M131.08,262.63c.05,.06,.09,.12,.13,.18,.04,.05,.08,.11,.12,.17,.02,.03,.05,.06,.07,.09h-.01s.04,.07,.06,.1c.3,.44,.59,.89,.86,1.38h2.94v-4.3h-4.3v2.22c.04,.05,.08,.11,.12,.16Z"
          fill="#292929"
        />
        <path
          d="M132.32,264.55c-.27-.49-.56-.95-.86-1.38,.3,.43,.59,.89,.86,1.38h0Z"
          fill="#292929"
        />
        <path
          d="M131.08,262.63c-.04-.05-.08-.11-.12-.16h0c.04,.06,.08,.11,.12,.16Z"
          fill="#292929"
        />
        <path
          d="M130.96,262.89v1.5c.08,.05,.17,.1,.25,.15h1.11c-.27-.49-.56-.95-.86-1.38-.02-.04-.05-.07-.07-.11l-.43-.17Z"
          fill="#292929"
        />
        <path
          d="M131.46,263.17s-.04-.07-.06-.1h0s.05,.07,.07,.1Z"
          fill="#292929"
        />
        <path
          d="M130.96,262.51c.11,.14,.23,.28,.34,.43-.03-.04-.06-.09-.09-.13-.04-.06-.09-.12-.13-.18-.04-.05-.08-.1-.12-.15v.03Z"
          fill="#292929"
        />
        <path
          d="M131.33,262.98c-.04-.06-.08-.11-.12-.17,.03,.04,.06,.09,.09,.13,0,.01,.02,.02,.03,.04Z"
          fill="#292929"
        />
        <path
          d="M131.21,264.55c-.08-.05-.17-.1-.25-.15v.15h.25Z"
          fill="#292929"
        />
        <path
          d="M131.41,263.07s-.05-.06-.07-.09c.02,.03,.04,.06,.06,.09h.01Z"
          fill="#292929"
        />
        <path
          d="M131.39,263.06s-.06-.08-.09-.12c-.11-.15-.23-.28-.34-.43v.38l.43,.17Z"
          fill="#292929"
        />
        <path
          d="M131.39,263.06h0s-.04-.06-.06-.09c0-.01-.02-.03-.03-.04,.03,.04,.06,.08,.09,.12Z"
          fill="#292929"
        />
        <path
          d="M183.46,264.55h2.68c.27-.49,.56-.95,.86-1.38,.02-.03,.04-.07,.06-.1h-.01s.05-.06,.07-.09c.04-.05,.08-.11,.12-.16,.05-.06,.09-.12,.14-.19,.12-.16,.25-.31,.37-.46,0,0,0,0,0,0v-1.92h-4.3v4.3Z"
          fill="#292929"
        />
        <path
          d="M187.01,263.17c-.3,.44-.59,.89-.86,1.38h0c.27-.49,.56-.95,.86-1.38Z"
          fill="#292929"
        />
        <polygon
          points="187.76 262.17 187.76 262.17 187.76 262.17 187.76 262.17"
          fill="#292929"
        />
        <path
          d="M187.76,262.19v-.03s0,0,0,0c-.13,.15-.25,.3-.37,.46-.05,.06-.09,.12-.14,.19-.03,.04-.06,.09-.09,.13,.19-.26,.39-.51,.6-.75Z"
          fill="#292929"
        />
        <path
          d="M187.25,262.81c-.04,.05-.08,.11-.12,.16,0-.01,.02-.02,.03-.04,.03-.04,.06-.09,.09-.13Z"
          fill="#292929"
        />
        <path
          d="M187.16,264.55c.2-.12,.4-.23,.6-.35v-1.41l-.68,.27s-.05,.07-.07,.11c-.3,.43-.59,.89-.86,1.38h1.01Z"
          fill="#292929"
        />
        <path
          d="M187.07,263.07s-.04,.07-.06,.1c.02-.04,.05-.07,.07-.11h0Z"
          fill="#292929"
        />
        <path
          d="M187.76,264.2c-.2,.11-.41,.23-.6,.35h.6v-.35Z"
          fill="#292929"
        />
        <path
          d="M187.06,263.07h.01s.04-.06,.06-.09c-.02,.03-.05,.06-.07,.09Z"
          fill="#292929"
        />
        <path
          d="M187.16,262.94s-.06,.08-.08,.12l.68-.27v-.6c-.2,.24-.41,.49-.6,.75Z"
          fill="#292929"
        />
        <path
          d="M187.16,262.94s-.02,.02-.03,.04c-.02,.03-.04,.06-.06,.09h0s.06-.09,.08-.13Z"
          fill="#292929"
        />
        <path
          d="M190.2,255.66s0,0,0,0c-.81-.29-1.62-.57-2.43-.85,0,0,0,0,0,0v.85h2.43Z"
          fill="#828282"
        />
        <path
          d="M130.96,254.58h-.03c-.93,.35-1.86,.7-2.78,1.06-.02,0-.04,.01-.05,.02h2.86v-1.08Z"
          fill="#828282"
        />
        <path d="M130.96,254.58s-.02,0-.03,.01h.03Z" fill="#828282" />
        <path
          d="M128.1,255.66h0s.04-.01,.05-.02c-.02,0-.04,.01-.06,.02Z"
          fill="#828282"
        />
        <path
          d="M194.45,262.16l-.69-1.74-1.28,.51v1.5c.66-.13,1.31-.23,1.97-.26Z"
          fill="#292929"
        />
        <path
          d="M192.48,264.55h2.91l-.94-2.39c-.65,.04-1.31,.13-1.97,.26v2.12Z"
          fill="#292929"
        />
        <polygon
          points="193.76 260.42 193.69 260.25 192.48 260.25 192.48 260.93 193.76 260.42"
          fill="#292929"
        />
        <path
          d="M194.45,262.16c.79-.04,1.57-.02,2.33,.09v-2.01h-2.58l-.44,.17,.69,1.74Z"
          fill="#292929"
        />
        <path
          d="M195.56,264.55l1.22-.48v-1.81c-.76-.11-1.54-.14-2.33-.09l.94,2.39h.17Z"
          fill="#292929"
        />
        <polygon
          points="196.78 264.07 195.56 264.55 196.78 264.55 196.78 264.07"
          fill="#292929"
        />
        <polygon
          points="194.2 260.25 193.69 260.25 193.76 260.42 194.2 260.25"
          fill="#292929"
        />
        <rect x="154.38" y="299.37" width="1" height="4.59" fill="#292929" />
        <rect x="154.38" y="281.68" width="1" height="4.59" fill="#292929" />
        <rect x="154.38" y="317.05" width="1" height="2.97" fill="#292929" />
        <rect x="154.38" y="290.57" width="1" height="4.5" fill="#292929" />
        <rect x="154.38" y="308.25" width="1" height="4.5" fill="#292929" />
        <rect x="154.38" y="295.07" width="1" height="4.3" fill="#292929" />
        <rect x="154.38" y="277.38" width="1" height="4.3" fill="#292929" />
        <rect x="154.38" y="312.75" width="1" height="4.3" fill="#292929" />
        <rect x="154.38" y="286.27" width="1" height="4.3" fill="#292929" />
        <rect x="154.38" y="303.95" width="1" height="4.3" fill="#292929" />
        <rect x="163.23" y="317.05" width="1" height="2.97" fill="#363636" />
        <rect x="163.23" y="308.25" width="1" height="4.5" fill="#363636" />
        <rect x="163.23" y="281.68" width="1" height="4.59" fill="#363636" />
        <rect x="163.23" y="299.37" width="1" height="4.59" fill="#363636" />
        <rect x="163.23" y="312.75" width="1" height="4.3" fill="#363636" />
        <rect x="163.23" y="295.07" width="1" height="4.3" fill="#363636" />
        <rect x="163.23" y="303.95" width="1" height="4.3" fill="#363636" />
        <rect x="161.74" y="308.25" width="1.49" height="4.5" fill="#363636" />
        <rect x="155.38" y="317.05" width="2.06" height="2.97" fill="#363636" />
        <rect x="155.38" y="308.25" width="2.06" height="4.5" fill="#363636" />
        <rect x="161.74" y="317.05" width="1.49" height="2.97" fill="#363636" />
        <path
          d="M159.77,268.68c.17,.02,.34,.04,.5,.04s.33-.02,.5-.04c.17-.02,.34-.06,.51-.1,0,0,0,0,0,0h-2.01s0,0,0,0c.17,.04,.35,.08,.51,.1Z"
          fill="#363636"
        />
        <path
          d="M159.26,268.58c-.53-.13-1.1-.35-1.71-.64h0c.61,.3,1.19,.51,1.72,.64Z"
          fill="#363636"
        />
        <rect x="161.74" y="312.75" width="1.49" height="4.3" fill="#363636" />
        <rect x="157.44" y="308.25" width="4.3" height="4.5" fill="#363636" />
        <rect x="157.44" y="317.05" width="4.3" height="2.97" fill="#363636" />
        <rect x="155.38" y="312.75" width="2.06" height="4.3" fill="#363636" />
        <path
          d="M161.74,268.44s0,0,0,0c-.16,.05-.31,.1-.47,.14h.47v-.14Z"
          fill="#363636"
        />
        <rect x="157.44" y="312.75" width="4.3" height="4.3" fill="#363636" />
        <path
          d="M161.74,304.67v-.72h-.75c.3,.18,.56,.42,.75,.72Z"
          fill="#363636"
        />
        <path
          d="M161.74,308.25v-1.06c-.41,.63-1.12,1.05-1.94,1.05-1.28,0-2.31-1.04-2.31-2.31,0-.84,.46-1.57,1.13-1.98h-1.18v4.3h4.3Z"
          fill="#363636"
        />
        <path
          d="M161.74,289.66c-.27,.41-.67,.73-1.14,.9h1.14v-.9Z"
          fill="#363636"
        />
        <path
          d="M161.74,287.15v-.88h-1.06c.44,.18,.8,.49,1.06,.88Z"
          fill="#363636"
        />
        <path
          d="M182.83,254.36c.03,.41,.03,.86,.02,1.3h.61v-2.3h0s-.83-.27-.83-.27c.11,.41,.18,.82,.21,1.27Z"
          fill="#828282"
        />
        <path
          d="M137.04,252.43l-1.78,.63c.62-.22,1.22-.42,1.78-.62,0,0,0,0,0,0Z"
          fill="#828282"
        />
        <path
          d="M136.61,255.66c0-.44,0-.88,.02-1.3,.05-.7,.19-1.29,.41-1.93-.56,.2-1.16,.41-1.78,.62v2.6h1.35Z"
          fill="#828282"
        />
        <path
          d="M171.18,277.38h3.48v-4.5h-4.59v3.18c.39,.46,.76,.89,1.11,1.32Z"
          fill="#ececec"
        />
        <path
          d="M165.78,268.58v-2.48c-.52,.4-1.04,.76-1.54,1.09v1.39h1.54Z"
          fill="#ececec"
        />
        <path
          d="M174.67,260.25v-2.77s0,0,0,0c-.79,.89-1.65,1.83-2.55,2.78,0,0,0,0,0,0h2.54Z"
          fill="#ececec"
        />
        <path
          d="M176.26,255.65s0,0-.01,.01c0,0,0,0,0,0,0,0,0,0,0,0Z"
          fill="#474747"
        />
        <path
          d="M178.97,252.4s-.06,.07-.09,.11c.03-.03,.06-.08,.09-.11h0Z"
          fill="#474747"
        />
        <rect x="170.08" y="264.55" width="4.59" height="4.03" fill="#ececec" />
        <path
          d="M182.62,253.09s0,0,0,0c-.39-.13-.76-.25-1.09-.35l1.09,.36Z"
          fill="#474747"
        />
        <path
          d="M178.97,260.25h3.23c.12-.53,.24-1.12,.39-1.83,.08-.37,.13-.75,.17-1.13,.05-.51,.09-1.07,.1-1.64h-3.89v4.59Z"
          fill="#ececec"
        />
        <path
          d="M180.32,266.14c.23-.6,.42-1.12,.59-1.59h-1.95v4.03h.42c.3-.77,.61-1.58,.93-2.44Z"
          fill="#ececec"
        />
        <path
          d="M176.26,255.65c.61-.71,1.15-1.36,1.6-1.91-.45,.55-.99,1.19-1.6,1.91Z"
          fill="#474747"
        />
        <path
          d="M179.39,268.58h-.42v1.07c.14-.35,.28-.71,.42-1.07Z"
          fill="#828282"
        />
        <path
          d="M174.67,264.55v-4.3h-2.54s0,0,0,0c-.66,.7-1.35,1.4-2.04,2.08v2.22h4.59Z"
          fill="#828282"
        />
        <path
          d="M175.42,277.38c.76-1.42,1.47-2.87,2.19-4.5h-2.95v4.5h.76Z"
          fill="#828282"
        />
        <path
          d="M170.08,276.06v-3.18h-2.78s.05,.06,.08,.08c1,1.12,1.9,2.14,2.7,3.09Z"
          fill="#828282"
        />
        <path
          d="M170.08,268.58v-4.03h-2.39c-.31,.27-.62,.53-.92,.78-.03,.02-.05,.04-.08,.06-.3,.25-.61,.49-.91,.72v2.48h4.3Z"
          fill="#828282"
        />
        <path
          d="M180.91,264.55c.65-1.79,.95-2.82,1.29-4.3h-3.23v4.3h1.95Z"
          fill="#828282"
        />
        <rect x="174.67" y="264.55" width="4.3" height="4.03" fill="#828282" />
        <rect x="170.08" y="268.58" width="4.59" height="4.3" fill="#828282" />
        <path
          d="M165.78,271.31v-2.72h-1.54v1.3c.5,.44,1.02,.91,1.54,1.42Z"
          fill="#828282"
        />
        <path
          d="M174.67,260.25h4.3v-7.84s-.06,.08-.09,.11c-.1,.12-.21,.26-.34,.42-.01,.01-.02,.03-.04,.04-.17,.21-.37,.45-.59,.71-.02,.02-.03,.04-.05,.06-.45,.55-.99,1.19-1.6,1.91,0,0,0,0,0,0,0,0,0,0,0,0-.49,.57-1.02,1.18-1.58,1.81,0,0,0,0,0,0v2.77Z"
          fill="#828282"
        />
        <path
          d="M174.67,278.74v-1.36h-3.48c.91,1.1,1.72,2.12,2.45,3.1,.36-.59,.7-1.16,1.03-1.74Z"
          fill="#828282"
        />
        <path
          d="M175.42,277.38h-.76v1.36c.26-.45,.51-.9,.76-1.36Z"
          fill="#292929"
        />
        <path
          d="M167.29,272.88h2.78v-4.3h-4.3v2.72c.5,.49,1.01,1.01,1.52,1.58Z"
          fill="#292929"
        />
        <path
          d="M178.97,269.65v-1.07h-4.3v4.3h2.95c.44-1,.89-2.07,1.35-3.23Z"
          fill="#292929"
        />
        <path
          d="M170.08,262.33c-.36,.36-.73,.71-1.1,1.05-.05,.05-.11,.1-.16,.15-.38,.35-.76,.69-1.13,1.02h2.39v-2.22Z"
          fill="#292929"
        />
        <rect x="174.67" y="260.25" width="4.3" height="4.3" fill="#292929" />
        <path
          d="M181.53,252.73l-2.56-.83v.51c.14-.18,.25-.31,.32-.39,0,0,.87,.27,2.24,.72Z"
          fill="#474747"
        />
        <path
          d="M178.97,255.66h3.89c0-.44,0-.88-.02-1.3-.03-.45-.1-.86-.21-1.27l-1.09-.36c-1.37-.44-2.24-.72-2.24-.72-.07,.08-.17,.21-.32,.39h0v3.26Z"
          fill="#828282"
        />
        <polygon
          points="142.81 255.66 142.81 255.66 142.81 255.66 142.81 255.66"
          fill="#474747"
        />
        <path
          d="M147.46,260.25c-1.21-1.13-2.36-2.26-3.41-3.31v3.31h3.41Z"
          fill="#ececec"
        />
        <path
          d="M139.12,251.69c-.2,.08-.42,.16-.65,.24l.65-.23s0,0,0,0Z"
          fill="#474747"
        />
        <polygon
          points="148.65 261.34 148.64 261.34 148.65 261.34 148.65 261.34"
          fill="#474747"
        />
        <rect x="144.06" y="264.55" width="4.59" height="4.03" fill="#ececec" />
        <path
          d="M148.28,277.38c.12-.15,.24-.29,.37-.44v-4.06h-4.59v4.5h4.22Z"
          fill="#ececec"
        />
        <path
          d="M138.55,264.55c.17,.47,.36,.99,.59,1.59,.21,.56,.42,1.1,.62,1.62v-3.21h-1.21Z"
          fill="#ececec"
        />
        <path
          d="M152.95,268.58h1.43v-1.94h.9c-.77-.51-1.57-1.08-2.39-1.72,.02,.02,.04,.03,.06,.05v3.61Z"
          fill="#ececec"
        />
        <path
          d="M136.88,258.42c.14,.71,.27,1.29,.39,1.83h2.49v-4.59h-3.15c.01,.57,.05,1.13,.1,1.64,.04,.38,.1,.75,.17,1.13Z"
          fill="#ececec"
        />
        <path
          d="M152.89,264.93c-.16-.12-.32-.25-.48-.38h0c.16,.13,.32,.25,.48,.38Z"
          fill="#474747"
        />
        <path
          d="M140.33,253.04c.63,.69,1.48,1.59,2.48,2.62-1-1.03-1.84-1.93-2.48-2.62Z"
          fill="#474747"
        />
        <path
          d="M148.65,264.55v4.03h4.3v-3.61s-.04-.03-.06-.05c-.16-.12-.32-.25-.48-.38h-3.76Z"
          fill="#828282"
        />
        <path
          d="M144.06,264.55h4.59v-3.21s0,0,0,0c-.4-.36-.79-.72-1.18-1.09h-3.41v4.3Z"
          fill="#828282"
        />
        <path
          d="M152.09,272.97s.05-.06,.08-.08h-3.52v4.06c1-1.19,2.12-2.49,3.44-3.97Z"
          fill="#828282"
        />
        <path
          d="M139.76,260.25h4.3v-3.31c-.44-.44-.85-.87-1.25-1.27,0,0,0,0,0,0,0,0,0,0,0,0-1-1.03-1.84-1.93-2.48-2.62,0-.01-.02-.02-.03-.03-.2-.22-.39-.42-.54-.6v7.84Z"
          fill="#828282"
        />
        <path
          d="M139.76,267.76c.11,.28,.21,.55,.32,.82h3.98v-4.03h-4.3v3.21Z"
          fill="#828282"
        />
        <path
          d="M139.76,264.55v-4.3h-2.49c.33,1.48,.64,2.51,1.29,4.3h1.21Z"
          fill="#828282"
        />
        <rect x="144.06" y="268.58" width="4.59" height="4.3" fill="#828282" />
        <path
          d="M144.04,277.38h.02v-4.5h-2.21c.72,1.63,1.42,3.08,2.19,4.5Z"
          fill="#828282"
        />
        <path
          d="M145.83,280.48c.73-.97,1.54-1.99,2.45-3.1h-4.22v.03c.55,1.02,1.14,2.03,1.77,3.06Z"
          fill="#828282"
        />
        <path
          d="M154.38,270.65v-2.07h-1.43v3.46c.48-.5,.96-.96,1.43-1.4Z"
          fill="#828282"
        />
        <path d="M144.06,277.38h-.02s.01,.02,.02,.03v-.03Z" fill="#474747" />
        <path
          d="M144.06,272.88v-4.3h-3.98c.62,1.59,1.2,3,1.78,4.3h2.21Z"
          fill="#292929"
        />
        <path
          d="M152.17,272.88c.26-.29,.52-.57,.78-.84v-3.46h-4.3v4.3h3.52Z"
          fill="#292929"
        />
        <rect x="139.76" y="260.25" width="4.3" height="4.3" fill="#292929" />
        <path
          d="M152.41,264.55c-.62-.5-1.26-1.02-1.88-1.55,.63,.54,1.26,1.06,1.88,1.55h0Z"
          fill="#474747"
        />
        <path
          d="M148.65,264.55h3.76c-.62-.5-1.26-1.02-1.88-1.55-.63-.54-1.26-1.09-1.88-1.65,0,0,0,0,0,0v3.21Z"
          fill="#292929"
        />
        <path d="M155.38,266.64h-.1s.07,.05,.1,.07v-.07Z" fill="#474747" />
        <path
          d="M155.28,266.64h-.9v10.74h1v-10.67s-.07-.05-.1-.07Z"
          fill="#292929"
        />
        <path
          d="M157.55,267.94s-.07-.03-.1-.05c.03,.02,.07,.03,.1,.05h0Z"
          fill="#474747"
        />
        <path
          d="M157.54,267.94s-.07-.03-.1-.05v.13s.07-.05,.1-.08Z"
          fill="#474747"
        />
        <path
          d="M139.76,251.47l-.63,.22c.09,.11,.31,.36,.63,.72v-.94Z"
          fill="#474747"
        />
        <path
          d="M138.47,251.92l-1.43,.5s0,0,0,0c.51-.18,.99-.35,1.43-.51Z"
          fill="#474747"
        />
        <path
          d="M139.76,252.41c-.32-.36-.54-.61-.63-.72l-.65,.23c-.44,.16-.92,.33-1.43,.51-.22,.63-.36,1.23-.41,1.93-.03,.41-.03,.86-.02,1.3h3.15v-3.25Z"
          fill="#828282"
        />
        <path
          d="M135.25,253.06s0,0,0,0h0s0,0,0,0l-4.25,1.51s-.02,0-.03,.01v1.08h4.3v-2.6s0,0,0,0h0Z"
          fill="#292929"
        />
        <polygon
          points="135.25 253.06 135.25 253.06 135.24 253.06 135.25 253.06"
          fill="#292929"
        />
        <path d="M130.99,254.57h-.03s.02,0,.03,0Z" fill="#292929" />
        <polygon
          points="135.26 253.06 135.26 253.06 135.25 253.06 135.26 253.06"
          fill="#292929"
        />
        <polygon
          points="135.25 253.06 135.25 253.06 135.25 253.06 135.25 253.06"
          fill="#292929"
        />
        <polygon
          points="135.25 253.06 135.25 253.06 135.25 253.06 135.25 253.06"
          fill="#292929"
        />
        <polygon
          points="135.25 253.06 135.25 253.06 135.25 253.06 135.25 253.06"
          fill="#292929"
        />
        <polygon
          points="135.26 253.06 135.25 253.06 135.25 253.06 135.26 253.06"
          fill="#292929"
        />
        <polygon
          points="135.25 253.06 135.25 253.06 135.25 253.06 135.25 253.06"
          fill="#292929"
        />
        <polygon
          points="135.25 253.06 135.25 253.06 135.25 253.06 135.25 253.06"
          fill="#292929"
        />
        <polygon
          points="135.25 253.06 135.25 253.06 135.25 253.06 135.25 253.06"
          fill="#292929"
        />
        <polygon
          points="187.76 255.66 187.76 254.81 187.76 254.81 187.76 254.81 183.47 253.37 183.46 253.36 183.46 255.66 187.76 255.66"
          fill="#292929"
        />
        <polygon
          points="187.76 254.81 187.76 254.81 187.76 254.81 187.76 254.81"
          fill="#292929"
        />
        <polygon
          points="183.47 253.36 183.46 253.36 183.47 253.37 183.47 253.36"
          fill="#292929"
        />
        <polygon
          points="187.76 254.81 187.76 254.81 187.76 254.81 187.76 254.81"
          fill="#292929"
        />
        <polygon
          points="187.76 254.81 187.76 254.81 187.76 254.81 187.76 254.81"
          fill="#292929"
        />
      </g>
      <path d="M155.38,268.58v13.1h8.86v-14.04h-8.86v.94Z" fill="#363636" />
      <path
        d="M163.23,286.27v-4.59h-7.86v26.57h2.06v-4.3h1.18c-.67,.4-1.13,1.13-1.13,1.98,0,1.28,1.04,2.31,2.31,2.31,.81,0,1.52-.42,1.94-1.05v1.06h1.49v-13.19h1v-8.8h-1Zm-1.49,18.41c-.19-.3-.45-.54-.75-.72h.75v.72Zm0-14.11h-1.14c.47-.17,.87-.49,1.14-.9v.9Zm0-3.42c-.25-.39-.62-.7-1.06-.88h1.06v.88Z"
        fill="#363636"
      />
      <path
        d="M136.71,260.51c.04,.32,.1,.65,.17,.97,.65,2.74,.87,3.46,2.26,6.65,2.44,5.59,4.12,8.75,6.69,12.35,1.6-1.84,3.52-3.82,6.26-6.47,2.34-2.26,4.71-3.79,6.51-5.07,.36-.25,.35-.72,0-.98-7.46-5.4-9.8-7.64-9.8-7.64-6.31-6.02-6.54-9.39-6.05-10.38,.07-.14,.5-.91,.33-1.05-.11-.08-.37,.18-.83,.44-2.81,1.59-3.91,3.4-3.91,3.4-1.77,2.79-1.59,3.94-1.7,5.25-.07,.81-.01,1.75,.08,2.53Z"
        fill="#474747"
      />
      <path
        d="M181.76,260.51c-.04,.32-.1,.65-.17,.97-.65,2.74-.87,3.46-2.26,6.65-2.44,5.59-4.12,8.75-6.69,12.35-1.6-1.84-3.52-3.82-6.26-6.47-2.34-2.26-4.71-3.79-6.51-5.07-.36-.25-.35-.72,0-.98,7.46-5.4,9.8-7.64,9.8-7.64,6.31-6.02,6.32-9,6.27-10.29-.11-.95-.6-1.38-.43-1.51,.11-.08,.69,.39,1.15,.65,2.81,1.59,3.47,3.56,3.47,3.56,1.77,2.79,1.59,3.94,1.7,5.25,.07,.81,.01,1.75-.08,2.53Z"
        fill="#474747"
      />
      <path
        d="M161.74,272.83c-.41-.63-1.12-1.05-1.94-1.05-1.28,0-2.31,1.04-2.31,2.31,0,.28,.06,.55,.15,.8,.33,.88,1.17,1.52,2.16,1.52,.81,0,1.52-.42,1.94-1.05,.09-.14,.17-.3,.23-.46,.09-.25,.15-.52,.15-.8,0-.46-.14-.9-.38-1.26Z"
        fill="#828282"
      />
      <g>
        <path
          d="M161.74,289.15c-.25-.39-.62-.7-1.06-.88-.27-.11-.57-.18-.88-.18s-.61,.06-.88,.18c-.84,.35-1.43,1.17-1.43,2.14s.63,1.84,1.52,2.16c.25,.09,.51,.15,.79,.15s.55-.06,.79-.15c.47-.17,.87-.49,1.14-.9,.24-.36,.38-.79,.38-1.26s-.14-.9-.38-1.26Z"
          fill="#828282"
        />
        <path
          d="M161.74,306.67c-.19-.3-.45-.54-.75-.72-.35-.21-.75-.33-1.18-.33s-.83,.13-1.18,.33c-.67,.4-1.13,1.13-1.13,1.98,0,1.28,1.04,2.31,2.31,2.31,.81,0,1.52-.42,1.94-1.05,.24-.36,.38-.79,.38-1.26s-.14-.9-.38-1.26Z"
          fill="#828282"
        />
      </g>
    </g>
  </fragment>
</template>

<script>
export default {
  name: 'avatarShirtsC',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
